export const enTrans = [
  {
    key: 'hello',
    value: 'Hello',
  },
  {
    key: 'dashboardNav',
    value: 'Dashboard',
  },
  {
    key: 'employerNav',
    value: 'Employer',
  },
  {
    key: 'job',
    value: 'job',
  },
  {
    key: 'savingEmployer',
    value: 'Saving Employer',
  },
  {
    key: 'savingJob',
    value: 'Saving Job',
  },
  {
    key: 'savingIndividual',
    value: 'Saving Individual',
  },
  {
    key: 'savedSuccess',
    value: 'saved successfully!',
  },
  {
    key: 'view',
    value: 'View',
  },
  {
    key: 'viewing',
    value: 'Viewing',
  },
  {
    key: 'viewJobBtn',
    value: 'View Job',
  },
  {
    key: 'individual',
    value: 'individual',
  },
  {
    key: 'individualBtnText',
    value: 'individual',
  },
  { key: 'inviteNav', value: 'Invite' },
  { key: 'inviteTitle', value: 'Invite Organization Members' },
  {
    key: 'inviteText',
    value: `Fill out the form below to send an invitation to members of your organization. Invitiations expire within 7 days, but don't worry you can always send another!`,
  },
  {
    key: 'jobNav',
    value: 'Jobs',
  },
  {
    key: 'individualNav',
    value: 'Individual',
  },
  {
    key: 'globalJobsTitle',
    value: 'Jobs Open Network Wide',
  },
  {
    key: 'jobsWidgetTitle',
    value: 'Latest Jobs',
  },
  {
    key: 'public',
    value: 'Public',
  },
  {
    key: 'addJobBtn',
    value: 'Add Job',
  },
  {
    key: 'privateIndividualTitle',
    value: 'Individuals Open to Work',
  },
  {
    key: 'individualWidgetTitle',
    value: 'Latest Individuals',
  },
  {
    key: 'privateBtn',
    value: ' Private',
  },
  {
    key: 'add',
    value: 'Add',
  },
  {
    key: 'addIndividualBtn',
    value: 'Add Individual',
  },
  {
    key: 'privateEmployerTitle',
    value: 'Latest Employers',
  },
  {
    key: 'addEmployerBtn',
    value: 'Add Employer',
  },
  {
    key: 'notificationTitle',
    value: 'Notifications',
  },
  {
    key: 'notificationCountTextI',
    value: 'You have',
  },
  {
    key: 'of',
    value: 'of',
  },
  {
    key: 'a(f)',
    value: ' ',
  },
  {
    key: 'a(m)',
    value: ' ',
  },
  {
    key: 'notificationCountTextII',
    value: 'unread notifications',
  },
  {
    key: 'filterKeyEventsBtn',
    value: 'Delete all',
  },
  {
    key: 'notificationText',
    value: 'Earlier',
  },
  {
    key: 'notificationMarkAllBtn',
    value: 'Mark all as read',
  },
  {
    key: 'logoutBtn',
    value: 'Log Out',
  },
  {
    key: 'empList',
    value: 'Employers List',
  },
  {
    key: 'columns',
    value: 'Columns',
  },
  {
    key: 'filters',
    value: 'Filters',
  },
  {
    key: 'density',
    value: 'Density',
  },
  {
    key: 'export',
    value: 'Export',
  },
  {
    key: 'checkBoxSelection',
    value: 'Checkbox selection',
  },
  {
    key: 'search',
    value: 'Search',
  },
  {
    key: 'orgName',
    value: 'Organization Name',
  },
  {
    key: 'parentOrgName',
    value: 'Parent Organization Name',
  },
  {
    key: 'supportLead',
    value: 'Employment Support Lead',
  },
  {
    key: 'mainCname',
    value: 'Main Contact Name',
  },
  {
    key: 'mainCphone',
    value: 'Main Contact Phone Number',
  },
  {
    key: 'mainCemail',
    value: 'Email Address',
  },
  {
    key: 'mainCemailPh',
    value: 'Email Address',
  },
  {
    key: 'address',
    value: 'Address',
  },
  {
    key: 'addressPh',
    value: 'Home Address',
  },
  {
    key: 'industry',
    value: 'Industry',
  },
  {
    key: 'description',
    value: 'Description',
  },
  {
    key: 'multiLocation',
    value: 'Multiple Locations',
  },
  {
    key: 'status',
    value: 'Status',
  },
  {
    key: 'reqSkills',
    value: 'Required Skills',
  },
  {
    key: 'keywords',
    value: 'Keywords',
  },
  {
    key: 'skillsAndIntersts',
    value: 'skills and interests',
  },
  {
    key: 'onboardDate',
    value: 'Date onboarded',
  },
  {
    key: 'jobList',
    value: 'Job List',
  },
  {
    key: 'jobTitleJobList',
    value: 'Job Title',
  },
  {
    key: 'closeDate',
    value: 'Closing Date',
  },
  {
    key: 'hrsPerWk',
    value: 'hours/week',
  },
  {
    key: 'schedule',
    value: 'Schedule',
  },
  {
    key: 'prefStartDate',
    value: 'Ideal Start Date',
  },
  {
    key: 'startDateLabel',
    value: 'Start Date',
  },
  {
    key: 'endDateLabel',
    value: 'End Date',
  },
  {
    key: 'certReq',
    value: 'Certification Required',
  },
  {
    key: 'trainingAvail',
    value: 'Training Available',
  },
  {
    key: 'openToTraining',
    value: 'Open to coaching during training',
  },
  {
    key: 'trainingReq',
    value: 'Training Required',
  },
  // {
  //   key: 'notesComments',
  //   value: 'Notes/Comments',
  // },
  {
    key: 'individualList',
    value: 'Individuals List',
  },
  {
    key: 'fullNameIndividual',
    value: 'Full Name',
  },
  {
    key: 'phoneNumber',
    value: 'Phone Number',
  },
  {
    key: 'phoneNumberPh',
    value: 'Phone Number',
  },
  {
    key: 'email',
    value: 'Email',
  },
  {
    key: 'overview-email',
    value: 'Email',
  },
  {
    key: 'dob',
    value: 'Birth Date',
  },
  {
    key: 'popoCheck',
    value: 'Police Check',
  },
  {
    key: 'popoCheck2',
    value: 'Police Check',
  },
  {
    key: 'popoCheckSubtext',
    value: 'What is the date of your most recent police check?',
  },
  {
    key: 'creditCheck',
    value: 'Credit Check',
  },
  {
    key: 'creditCheck2',
    value: 'Credit Check',
  },
  {
    key: 'creditCheckSubtext',
    value: 'What is the date of your most recent credit check?',
  },
  {
    key: 'educationalBackground',
    value: 'Educational Background',
  },
  {
    key: 'prefRoles',
    value: 'Job Preference(s)',
  },
  {
    key: 'prefRolesPh',
    value: 'E.g. Computer Programmer, Baker, Human Resources, etc.',
  },
  {
    key: 'minRate',
    value: 'E.g. $16.55',
  },
  {
    key: 'maxRate',
    value: 'Maximum Rate/Hour',
  },
  {
    key: 'skills',
    value: 'Skills',
  },
  {
    key: 'interests',
    value: 'Interests',
  },
  {
    key: 'restrictions',
    value: 'Work Restrictions',
  },
  {
    key: 'daysAvail',
    value: 'Available Work Days',
  },
  {
    key: 'currentWorkingHrs',
    value: 'Hours Currently working',
  },
  {
    key: 'totalAvailHrs',
    value: 'Total Available Hours',
  },
  {
    key: 'dateIntake',
    value: 'Intake Date',
  },
  {
    key: 'inviteTitle',
    value: 'Invite Organization Members',
  },
  {
    key: 'inviteText',
    value:
      'Fill out the form below to send an invitation to members of your organization. Invitiations expire within 7 days, but don’t worry you can always send another!',
  },
  {
    key: 'inviteEmailMsg',
    value: 'This email will be used to login to MyJobMatch',
  },
  {
    key: 'fName',
    value: 'First Name',
  },
  {
    key: 'lName',
    value: 'Last Name',
  },
  {
    key: 'inviteBtn',
    value: 'Send Invite',
  },
  {
    key: 'settingsTitle',
    value: 'Settings',
  },
  {
    key: 'basicInfo',
    value: 'Basic Information',
  },
  {
    key: 'profileImg',
    value: 'Profile Photo',
  },
  {
    key: 'userEmail',
    value: 'Account Email',
  },
  {
    key: 'changeEmailMsg',
    value: 'To change, contact the organziation maintainer.',
  },
  {
    key: 'submitSettingsBtn',
    value: 'Update',
  },
  {
    key: 'submitSaveBtn',
    value: 'Save',
  },
  {
    key: 'employerBtnText',
    value: 'Employer',
  },
  {
    key: 'jobBtnText',
    value: `Job`,
  },
  {
    key: 'matches',
    value: 'Matches',
  },
  {
    key: 'helpBtn',
    value: 'Help',
  },
  {
    key: 'none',
    value: 'None',
  },
  {
    key: 'helpPrompt',
    value: 'Select one of the options below:',
  },
  {
    key: 'helpReportOption',
    value: 'Report a bug, issue or error',
  },
  {
    key: 'helpEmailOption',
    value: 'Send us an email',
  },
  {
    key: 'helpGuideOption',
    value: 'Read the user guide',
  },
  {
    key: 'here',
    value: 'here',
  },
  {
    key: 'NotificationTitle',
    value: 'Notifications',
  },
  {
    key: 'jobNewNotif',
    value: 'has a new job',
  },
  {
    key: 'jobUpdatedNotif',
    value: 'has updated a job',
  },
  {
    key: 'jobClosingNotif1',
    value: 'position for',
  },
  {
    key: 'jobClosingNotif2',
    value: 'is',
  },
  {
    key: 'jobClosingNotif3',
    value: 'closing in',
  },
  {
    key: 'jobClosingNotif4',
    value: 'day(s)',
  },
  {
    key: 'jobClosingNotif5',
    value: 'closed.',
  },
  {
    key: 'newProvNotif',
    value: 'was added to your organization',
  },
  {
    key: 'profilUpdatedNotif',
    value: 'profile was updated',
  },
  {
    key: 'individualAddedNotif',
    value: 'added a job seeker',
  },
  {
    key: 'updated',
    value: 'updated',
  },
  {
    key: 'open',
    value: 'Open',
  },
  {
    key: 'closed',
    value: 'Closed',
  },
  {
    key: 'individualUpdatedNotif',
    value: 'a new individual’s profile',
  },
  { key: 'aNewPerson', value: 'a new individual' },
  {
    key: 'individualMilkExpirationNotif1',
    value: 'has been open to work for',
  },
  {
    key: 'individualMilkExpirationNotif2',
    value: 'days without any changes',
  },
  {
    key: 'individualMatchesNotif',
    value: 'has new job a recommendation(s)',
  },
  {
    key: 'employerViewTitle',
    value: 'EMPLOYER DETAILS',
  },
  {
    key: 'employerName',
    value: 'Employer',
  },
  {
    key: 'employerNameExample',
    value: 'E.g. Amazon',
  },
  {
    key: 'employersName',
    value: `Employer's name`,
  },
  {
    key: 'addImg',
    value: `Upload logo`,
  },
  {
    key: 'addImgText',
    value: 'Add Image',
  },
  {
    key: 'defaultOption',
    value: 'default',
  },
  {
    key: 'leadProvLabel',
    value: 'Employment Support Lead',
  },
  {
    key: 'orgNameLabel',
    value: 'Organization name ',
  },
  {
    key: 'jobInputPlaceholder',
    value: 'E.g. Loblaws - Dupont St.',
  },
  {
    key: 'orgNameHelperText',
    value:
      'This is the name of your organization followed by an identifier (if multiple locations).',
  },
  {
    key: 'parentOrgNameLabel',
    value: 'Parent Organization',
  },
  {
    key: 'parentOrgNamePlaceholder',
    value: 'E.g. Loblaws',
  },
  {
    key: 'parentOrgNameHelperText',
    value: 'If only one location, Parent name is the same as Organization name.',
  },
  {
    key: 'multiLocLabel',
    value: 'Multiple Locations',
  },
  {
    key: 'industryLabel',
    value: 'Industry *',
  },
  {
    key: 'thousandMaxCharMsg',
    value: 'Max. 1000 characters.',
  },
  {
    key: 'twoThousandMaxCharMsg',
    value: 'Max. 2500 characters.',
  },
  {
    key: 'addressHelperText',
    value:
      'When you begin typing your address, a drop-down list will appear. Please select your address from this list.',
  },
  {
    key: 'reqSkills',
    value: 'Required Skills',
  },
  {
    key: 'reqSkillsPlaceholder',
    value: 'Standing for long hours, lifting over 50 lbs... etc.',
  },
  {
    key: 'keywordLabel',
    value: 'Keywords',
  },
  {
    key: 'keywordPlaceholder',
    value:
      'The more keywords used the more matches you generate between employers and individuals.',
  },
  {
    key: 'mcFirstNameLabel',
    value: 'Main contact’s first name',
  },
  {
    key: 'mcLastNameLabel',
    value: 'Main contact’s last name',
  },
  {
    key: 'mcPhoneNumberLabel',
    value: 'Main contact’s phone number',
  },
  {
    key: 'mcPhoneNumberMsg',
    value: 'Main contact’s phone number required',
  },
  {
    key: 'mcEmailLabel',
    value: 'Main contact’s email',
  },
  {
    key: 'employer',
    value: 'employer',
  },
  {
    key: 'employerProfile',
    value: 'Employer Profile',
  },
  {
    key: 'employerViewEditBtn',
    value: 'Edit Employer',
  },
  {
    key: 'employerDetails',
    value: 'Employer details',
  },
  {
    key: 'employerViewHeader2',
    value: 'EMPLOYER OVERVIEW',
  },
  {
    key: 'employerViewHeader3',
    value: 'EMPLOYER DESCRIPTION',
  },
  {
    key: 'emptyDetailsMsgEmployerView',
    value: 'No details available for this employer...',
  },
  {
    key: 'emptyJobListingMsgEmployerView',
    value: 'Currently no jobs listed with this employer.',
  },
  {
    key: 'emptyNotesMsgEmployerView',
    value: 'Currently no notes made for this employer.',
  },
  {
    key: 'nearest',
    value: 'Nearest',
  },
  {
    key: 'aligned',
    value: 'Aligned',
  },
  {
    key: 'cumulative',
    value: 'Cumulative',
  },
  {
    key: 'nearestIndividualBtn',
    value: 'Nearest Individuals',
  },
  {
    key: 'alignedIndividualBtn',
    value: 'Most Aligned Individuals',
  },
  {
    key: 'alignedEmployersBtn',
    value: 'Most Aligned Employers',
  },
  {
    key: 'cumBtn',
    value: 'Cumulative Matches',
  },
  {
    key: 'jobDetailTitle',
    value: 'JOB DETAILS',
  },
  {
    key: 'orgNameLabel',
    value: 'Organization Name*',
  },
  {
    key: 'jobStatusLabel',
    value: 'Job Status',
  },
  {
    key: 'jobClosed',
    value: 'Closed',
  },
  {
    key: 'jobOpened',
    value: 'Open',
  },
  {
    key: 'jobTypeLabel',
    value: 'Job Type',
  },
  {
    key: 'irlText',
    value: 'In-person',
  },
  {
    key: 'remoteText',
    value: 'Remote',
  },
  {
    key: 'hybridText',
    value: 'Hybrid',
  },
  {
    key: 'addresPlaceholder',
    value: 'Address',
  },
  {
    key: 'addressLabel',
    value: 'Address *',
  },
  {
    key: 'esProviderLabel',
    value: 'Employment Support Provider (auto-populated)',
  },
  {
    key: 'yourESP',
    value: 'Your Employment Support Provider',
  },
  {
    key: 'activity-you',
    value: 'You',
  },
  {
    key: 'esProviderplaceholder',
    value:
      'The lead employment support provider for this employer is auto populated for this job. You can change this after creating a new employer.',
  },
  {
    key: 'jobTitleLabel',
    value: 'Job Title *',
  },
  {
    key: 'jobTitlePlaceholder',
    value: 'Cashier - Day/Night shift, Quinpool Road',
  },
  {
    key: 'descriptionLabel',
    value: 'Description',
  },
  {
    key: 'jobDescriptionText',
    value: 'Job Description',
  },
  {
    key: 'keywordsLabel',
    value: 'Keywords',
  },
  {
    key: 'skillsInterestsLabel',
    value: 'Interest and skill keywords',
  },
  {
    key: 'skillsInterestPlaceholder',
    value:
      'The more keywords used the more matches you generate between employers and individuals. Keywords are a combination of skills and interests.',
  },
  {
    key: 'skills&interestNotesLabel',
    value: 'Skills & interest (additional notes)',
  },
  {
    key: 'skills&interestplaceholder',
    value: 'Briefly descibe what you look for in this job.',
  },
  {
    key: 'skills&interestHelperText',
    value:
      'Didn’t find the keywords you were looking for? Add additional information to help you in skill matching.',
  },
  {
    key: 'hourlyRate',
    value: 'Minimum Hourly Rate',
  },
  {
    key: 'minHrRateLabel',
    value: 'Minimum Hourly Rate',
  },
  {
    key: 'maxHrRateLabel',
    value: 'Maximum Hourly Rate',
  },
  {
    key: 'wklyHrsLabel',
    value: 'Weekly hours',
  },
  {
    key: 'iconText',
    value: 'icon',
  },
  {
    key: 'reqDaysLabel',
    value: 'Required Days',
  },
  {
    key: 'reqDaysPlaceholder',
    value: 'Select the applicable days for this job.',
  },
  {
    key: 'Monday',
    value: 'Monday',
  },
  {
    key: 'Tuesday',
    value: 'Tuesday',
  },
  {
    key: 'Wednesday',
    value: 'Wednesday',
  },
  {
    key: 'Thursday',
    value: 'Thursday',
  },
  {
    key: 'Friday',
    value: 'Friday',
  },
  {
    key: 'Saturday',
    value: 'Saturday',
  },
  {
    key: 'Sunday',
    value: 'Sunday',
  },
  {
    key: 'Mon',
    value: 'Mon',
  },
  {
    key: 'Tues',
    value: 'Tues',
  },
  {
    key: 'Wed',
    value: 'Wed',
  },
  {
    key: 'Thur',
    value: 'Thur',
  },
  {
    key: 'Fri',
    value: 'Fri',
  },
  {
    key: 'Sat',
    value: 'Sat',
  },
  {
    key: 'Sun',
    value: 'Sun',
  },
  {
    key: 'MonToSun',
    value: 'Mon-Sun',
  },
  {
    key: 'MonToFri',
    value: 'Mon-Fri',
  },
  {
    key: 'idealStartDate',
    value: 'Ideal Start Date',
  },
  {
    key: 'closingDateJob',
    value: 'Closing Date',
  },
  {
    key: 'closingDateCheckBoxLabel',
    value: 'Enable closing date for this job',
  },
  {
    key: 'trainingReqLabel',
    value: 'Training Required',
  },
  {
    key: 'certsReqLabel',
    value: 'Certification Required',
  },
  {
    key: 'trainingAvailLabel',
    value: 'Training Available',
  },
  {
    key: 'openToCoachingLabel',
    value: 'Open to job coach support during training',
  },
  {
    key: 'openToCoachSupportColumn',
    value: 'Open to Job Coach Support',
  },
  {
    key: 'howToApply',
    value: 'How to apply',
  },
  {
    key: 'notesPlaceholder',
    value:
      'Please include details on how the employer would like to receive applications for this job (e.g. through the website, via the employment support provider, onsite, etc.).',
  },
  {
    key: '',
    value: 'icon',
  },
  {
    key: 'attachmentsTitle',
    value: 'Attachments',
  },
  {
    key: 'jobDescriptionText',
    value: 'Job Description',
  },
  {
    key: 'uploadJobDescriptionBtn',
    value: 'Upload Job Description',
  },
  {
    key: 'additionalFilesTitle',
    value: 'Additional File(s)',
  },
  {
    key: 'additionalFilesText',
    value: 'Additional File',
  },
  {
    key: 'jobFormSubmitBtn',
    value: 'Save Job',
  },
  {
    key: 'providerCardTitle',
    value: 'EMPLOYMENT SUPPORT LEAD',
  },
  {
    key: 'overviewTitleJobView',
    value: 'JOB OVERVIEW',
  },
  {
    key: 'empty',
    value: 'Empty',
  },
  {
    key: 'backBtnJobView',
    value: 'Back to Job List',
  },
  {
    key: 'backBtnEmployerView',
    value: 'Back to Employer List',
  },
  {
    key: 'individualFormTitle',
    value: 'Individual Details',
  },
  {
    key: 'leadProviderLabel',
    value: 'Employment Support Lead',
  },
  {
    key: 'empStatus',
    value: 'Employer Status',
  },
  {
    key: 'individualFirstNameLabel',
    value: 'First Name',
  },
  {
    key: 'individualFirstNamePh',
    value: 'First Name',
  },
  {
    key: 'individualLastNameLabel',
    value: 'Last Name',
  },
  {
    key: 'individualLastNamePh',
    value: 'Last Name',
  },
  {
    key: 'phoneNumber',
    value: 'Phone Number',
  },
  {
    key: 'chooseYourProNoun',
    value: 'Personal Gender Pronouns',
  },
  {
    key: 'chooseYourProNoun2',
    value: 'E.g. she/them',
  },
  {
    key: 'chooseYourProNounSubtext',
    value: 'What pronouns do you use?',
  },
  {
    key: 'agencyIdLabel',
    value: 'Agency ID',
  },
  {
    key: 'govIdLabel',
    value: 'Government ID',
  },
  {
    key: 'prefCommsLabel',
    value: 'Communication Preference',
  },
  {
    key: 'prefCommsLabelExample',
    value: 'E.g. Text message',
  },
  {
    key: 'prefCommsLabelSubtext',
    value: 'How do you want to be contacted?',
  },
  {
    key: 'N/A',
    value: 'N/A',
  },
  {
    key: 'accomodationsLabel',
    value: 'Accommodation Requirements',
  },
  {
    key: 'acommodationsPlaceholder',
    value: 'E.g. Specialized mobility equipment used',
  },
  {
    key: 'acommodationsHelper',
    value: 'Let us know what you need to ensure a comfortable and accessible workspace.',
  },
  {
    key: 'selectBirthdatePlaceholder',
    value: 'You must be 14 years or older to work in Ontario.',
  },
  {
    key: 'selectBirthdateValidError',
    value: 'The date you entered is not valid. Please try again using: MM/DD/YYYY.',
  },
  {
    key: 'selectAddressPlaceholder',
    value:
      'When you begin typing your address, a drop-down list will appear. Please select your address from this list.',
  },
  {
    key: 'dobLabel',
    value: 'Birth Date',
  },
  {
    key: 'dobPlaceholder',
    value: 'mm/dd/yyyy',
  },
  {
    key: 'dobHelperText',
    value: 'You must be 14 years or older to work in Ontario.',
  },
  {
    key: 'preferredRolesHelperText',
    value: 'What kind of jobs are you interested in?',
  },
  {
    key: 'editProfile-keywordaHeader',
    value: 'Keywords help match you with suitable employers and job openings.',
  },
  {
    key: 'skillsTitle',
    value: 'My Skills',
  },
  {
    key: 'interestsTitle',
    value: 'My Interests',
  },
  {
    key: 'skillsTitlePh',
    value: 'Select all that apply',
  },
  {
    key: 'interestsTitlePh',
    value: 'Select all that apply',
  },
  {
    key: 'daysAvailPh',
    value: 'Select all that apply',
  },
  {
    key: 'restrictionsTitle',
    value: 'Work Restrictions',
  },
  {
    key: 'restrictionsTextPlaceholder',
    value: 'E.g. No heavy lifting, etc.',
  },
  {
    key: 'indStatusLabel',
    value: 'This individual is ',
  },
  {
    key: 'individual',
    value: ' Individual',
  },
  {
    key: 'indStatusOpen',
    value: 'Open to Work',
  },
  {
    key: 'indStatusNotOpen',
    value: 'Not Open to Work',
  },
  {
    key: 'daysAvailTitle',
    value: 'Availability Days',
  },
  {
    key: 'daysAvailHelperText',
    value: 'What days are you available to work?',
  },
  {
    key: 'totalHrsLabel',
    value: 'Hours per Week',
  },
  {
    key: 'totalHrsPlaceholder',
    value: 'E.g. 16',
  },
  {
    key: 'totalHrsPlaceholder-eg14',
    value: 'E.g. 14',
  },
  {
    key: 'currentEmploymentTitle',
    value: 'Employment Schedule & History',
  },
  {
    key: 'addJobBtn',
    value: 'Add a Job',
  },
  {
    key: 'attachmentsTitle',
    value: 'Attachments',
  },
  {
    key: 'resumeUploadTitle',
    value: 'Resume',
  },
  {
    key: 'resumeUploadLabel',
    value: 'Upload Resume',
  },
  {
    key: 'resumeAttached',
    value: 'Resume Attached',
  },
  {
    key: 'resumeUploadLabelProfile',
    value: 'Upload your resume to support your job applications',
  },
  {
    key: 'coverLetterUploadTitle',
    value: 'Cover Letter',
  },
  {
    key: 'coverLetterAttached',
    value: 'Cover Letter Attached',
  },
  {
    key: 'coverLetterUploadLabel',
    value: 'Upload Cover Letter',
  },
  {
    key: 'coverLetterUploadLabelProfile',
    value: 'Upload your cover letter to support your job applications',
  },
  {
    key: 'refLabelProfile',
    value: 'Upload your references to support your job applications',
  },
  {
    key: 'certsLabelProfile',
    value: 'Upload your certifications to support your job applications',
  },
  {
    key: 'refTitle',
    value: 'References',
  },
  {
    key: 'refHelperText',
    value: 'Select up to 3',
  },
  {
    key: 'refLabel',
    value: 'Upload References',
  },
  {
    key: 'certificationTitle',
    value: 'Certifications',
  },
  {
    key: 'certsHelperText',
    value: 'Select up to 5',
  },
  {
    key: 'certsLabel',
    value: 'Upload Certifications',
  },
  {
    key: 'individualSubmitBtn',
    value: 'Save Individual',
  },
  {
    key: 'empInfoMainTitle',
    value: 'INDIVIDUAL OVERVIEW',
  },
  {
    key: 'empScheduleTitle',
    value: 'CURRENT EMPLOYMENT SCHEDULE',
  },
  {
    key: 'emptyNotesMsgIndividual',
    value: 'Currently no notes made for this individual.',
  },
  {
    key: 'nearestJobBtn',
    value: 'Nearest Jobs',
  },
  {
    key: 'nearestEmployersBtn',
    value: 'Nearest Employers',
  },
  {
    key: 'alignedJobsBtn',
    value: 'Most Aligned Jobs',
  },
  {
    key: 'recommendataionsCumBtn',
    value: 'Cumulative Matches',
  },
  {
    key: 'individualViewBackBtn',
    value: 'Back to Individuals List',
  },
  {
    key: 'individualViewEditBtn',
    value: 'Edit Individual',
  },
  {
    key: 'jobViewEditBtn',
    value: 'Edit Job',
  },
  {
    key: 'lessMinute',
    value: `less than  a minute ago`,
  },
  {
    key: 'ago',
    value: 'ago',
  },
  {
    key: 'daysAgo',
    value: 'days ago',
  },
  {
    key: 'oneDayPast',
    value: 'a day ago',
  },
  {
    key: 'on',
    value: 'on',
  },
  {
    key: 'inactive',
    value: 'inactive',
  },
  {
    key: 'active',
    value: 'active',
  },
  {
    key: 'addedBy',
    value: 'added by',
  },
  {
    key: 'added',
    value: 'Added',
  },
  {
    key: 'added2',
    value: 'added',
  },
  {
    key: 'removed',
    value: 'removed',
  },
  {
    key: 'to',
    value: 'to',
  },
  {
    key: 'from',
    value: 'from',
  },
  {
    key: 'yes',
    value: 'yes',
  },
  {
    key: 'no',
    value: 'no',
  },
  {
    key: 'na',
    value: 'N/A',
  },
  {
    key: 'dayCES',
    value: 'Day(s)',
  },
  {
    key: 'hours',
    value: 'Hours',
  },
  {
    key: 'role',
    value: 'Position',
  },
  {
    key: 'jobSource',
    value: 'Job Source',
  },
  {
    key: 'references',
    value: 'References',
  },
  {
    key: 'reference',
    value: 'Reference',
  },
  {
    key: 'certification',
    value: 'certification',
  },
  {
    key: 'employmentHistory',
    value: 'Employment History',
  },
  {
    key: 'noNotifications',
    value: 'You have no new notifications',
  },
  {
    key: 'hasNewJob',
    value: 'has a new job match',
  },
  {
    key: 'rowPerPage',
    value: 'rows per page',
  },
  {
    key: 'density',
    value: 'Density',
  },
  {
    key: 'columns',
    value: 'Columns',
  },
  {
    key: 'filters',
    value: 'Filters',
  },
  {
    key: 'export',
    value: 'Export',
  },
  {
    key: 'noRows',
    value: 'No rows',
  },
  {
    key: 'noResults',
    value: 'No results found.',
  },
  {
    key: 'search...',
    value: 'Search...',
  },
  {
    key: 'columnTitle',
    value: 'Column title',
  },
  {
    key: 'findColumn',
    value: 'Find column',
  },
  {
    key: 'hideAll',
    value: 'Hide all',
  },
  {
    key: 'showAll',
    value: 'Show all',
  },
  {
    key: 'operator',
    value: 'operator',
  },
  {
    key: 'value',
    value: 'value',
  },
  {
    key: 'and',
    value: 'and',
  },
  {
    key: 'or',
    value: 'or',
  },
  {
    key: 'contains',
    value: 'contains',
  },
  {
    key: 'equals',
    value: 'equals',
  },
  {
    key: 'startsWith',
    value: 'starts with',
  },
  {
    key: 'endsWith',
    value: 'ends with',
  },
  {
    key: 'isEmpty',
    value: 'is empty',
  },
  {
    key: 'isNotEmpty',
    value: 'is not empty',
  },
  {
    key: 'isAnyOf',
    value: 'is any of',
  },
  {
    key: 'filterValue',
    value: `Filter Value`,
  },
  {
    key: 'compact',
    value: 'compact',
  },
  {
    key: 'standard',
    value: `standard`,
  },
  {
    key: 'comfortable',
    value: `comfortable`,
  },
  {
    key: 'dlCSV',
    value: 'Download CSV',
  },
  {
    key: 'print',
    value: 'Print',
  },
  {
    key: 'tMenu',
    value: 'Menu',
  },
  {
    key: 'tShowCol',
    value: 'Show columns',
  },
  {
    key: 'tMngCol',
    value: 'Manage columns',
  },
  {
    key: 'tFilter',
    value: 'Filter',
  },
  {
    key: 'tHideCol',
    value: 'Hide column',
  },
  {
    key: 'unsort',
    value: 'Unsort',
  },
  {
    key: 'sortUp',
    value: 'Sort by ASC',
  },
  {
    key: 'sortDown',
    value: 'Sort by DESC',
  },
  {
    key: 'selectLeadProv',
    value: 'Select a lead provider',
  },
  {
    key: 'enterOrgName',
    value: 'Enter the employer’s organization name.',
  },

  {
    key: 'duplicateOrgFound',
    value: 'A duplicate organization name was found, please change to proceed.',
  },
  {
    key: 'duplicateOrgFoundMsg',
    value: 'Organization duplicate found',
  },
  {
    key: 'duplicateParentOrgFoundMsg',
    value: 'Parent Organization duplicate found',
  },
  {
    key: 'selectIndustryText',
    value: 'Select your industry',
  },
  {
    key: 'selectIndutryTextII',
    value: 'Select an industry',
  },
  {
    key: 'mainBranchNameReqMsg',
    value: 'A main branch name is required',
  },
  {
    key: 'leadProviderReqMsg',
    value: 'A lead provider must be selected',
  },
  {
    key: 'descErrorMsg',
    value: 'Please, enter a description with less than 2500 characters',
  },
  {
    key: 'addressReqMsg',
    value: 'You must select an address from one of the options',
  },
  {
    key: 'addressReqMsgII',
    value:
      'In order to save this profile and to match by locations, an address must be selected from the drop down.',
  },
  {
    key: 'validPhoneReq',
    value: 'Please input a valid 10-digit number',
  },
  {
    key: 'phoneErrorMsg',
    value: 'Number is too long!',
  },
  {
    key: 'phoneHelperText',
    value: 'Please input a valid 10-digit number with an optional 5-digit extension',
  },
  {
    key: 'emailErrorMsg',
    value: 'Please enter a valid email address',
  },
  {
    key: 'notesErrorMsg',
    value: 'Sorry, your notes should be less than 1000 characters',
  },
  {
    key: 'created',
    value: 'Created',
  },
  {
    key: 'creator',
    value: 'Creator',
  },
  {
    key: 'goBack',
    value: 'Return to Profile',
  },

  {
    key: 'noDetailsAvailable',
    value: 'No details available for this job...',
  },
  {
    key: 'noNotesOnEmployer',
    value: 'You currently have no notes on this employer…',
  },
  {
    key: 'empOrgReqMsg',
    value: 'You must select an employer organization',
  },
  {
    key: 'addressErrorMsg',
    value: 'Select the full address from the drop down.',
  },
  {
    key: 'jobDuplicateMsg',
    value: 'Job duplicate found',
  },
  {
    key: 'orgSelectPrompt',
    value:
      'Please select an organization name before creating a job title. Note: Changing the organization name will reset this field.',
  },
  {
    key: 'jobTitleErrorMsg',
    value: 'Please add a job title.',
  },
  {
    key: 'minRateErrorMsg',
    value: 'Value must be less than the max. hourly rate',
  },
  {
    key: 'maxRateErrorMsg',
    value: 'Value must be greater than the min. hourly rate',
  },
  {
    key: 'estHrsPerWeek',
    value: 'Estimated weekly hours',
  },
  {
    key: 'jobClosingDateHelperText',
    value: 'A date greater than 24 hours must be selected.',
  },
  {
    key: 'selectProvPlease',
    value: 'Please select a provider',
  },
  {
    key: 'selectProvider',
    value: 'Select a provider',
  },
  {
    key: 'firstNameReqMsg',
    value: 'Please provide your first name.',
  },
  {
    key: 'keepNumberUpdToDate',
    value: 'Keep your work number up to date',
  },
  {
    key: 'indExistsMsg',
    value: 'Individual exists',
  },
  {
    key: 'phoneNumberReqMsg',
    value: 'Please provide your phone number.',
  },
  {
    key: 'validEmailReqMsg',
    value: 'Please provide your email address.',
  },
  {
    key: 'validAddressReqMsg',
    value: 'The address you entered is not valid. Please select from the drop-down list.',
  },
  {
    key: 'dobRequired',
    value: 'The date you entered is not valid. Please try again using: MM/DD/YYYY.',
  },

  {
    key: 'birthDate',
    value: 'Birthdate',
  },
  {
    key: 'dobErrorMsg',
    value: 'The date you entered is not valid. Please try again using: MM/DD/YYYY.',
  },
  {
    key: 'expectedSalaryErrorMsg',
    value: 'I’m in the wrong field! Real wages please.',
  },
  {
    key: 'numberErrorMsg',
    value: 'Invalid input, please remove the decimal point or add a value to the tenths place.',
  },
  {
    key: 'restrictionsHelperText',
    value: 'Telling us about your limits helps us find job options that fit you better.',
  },
  {
    key: 'availableHoursErrorMsg',
    value: 'Please provide hours less than 60 hours.',
  },
  {
    key: 'availableHoursErrorMsg-v1',
    value: 'Please let us know how many hours you are interested in working per week.',
  },
  {
    key: 'hourlyRate-errorNonZero',
    value: 'Please let us know the minimum hourly wage you would like to earn.',
  },
  {
    key: 'availableHrsHelperText',
    value: 'E.g. 25',
  },
  {
    key: 'availableHoursErrorMsg',
    value: 'Input hours between 0 and 99',
  },
  {
    key: 'thousandMaxChars',
    value: 'Max. characters 1000',
  },
  {
    key: 'selectDayLabel',
    value: 'Please let us know what days you are available to work.',
  },
  {
    key: 'selectDayReqMsg',
    value: 'You must select a day',
  },
  {
    key: 'employmentRecord-weekly-schedule-label',
    value: 'Weekly Schedule',
  },
  {
    key: 'Rotating',
    value: 'Rotating',
  },
  {
    key: 'hoursReqErrorMsg',
    value: 'Please let us know how many hours you work(ed) per week.',
  },
  {
    key: 'employerNamePleaseMsg',
    value: 'Please provide an employer name.',
  },
  {
    key: 'roleReqMsg',
    value: 'Please provide your position.',
  },
  {
    key: 'reqRoleLabel',
    value: 'E.g. Baker',
  },
  {
    key: 'individualPlacedByMJM',
    value: 'Did MyJobMatch help you get this job?',
  },
  {
    key: 'individualPlacedByMJMII',
    value: 'Select if you got the job through MyJobMatch.',
  },
  {
    key: 'noLongWorksHere',
    value: 'Past Position',
  },
  {
    key: 'roleActiveMsg',
    value: 'Current Position',
  },
  {
    key: 'lastNameReqMsg',
    value: 'Please provide your last name.',
  },
  {
    key: 'validNameReqMsg',
    value: `Please input a valid name. Only alphabets, numbers, spaces, and dashes'-' allowed.`,
  },
  {
    key: 'proifileUpdated',
    value: 'Profile Updated!',
  },
  {
    key: 'iUnderstand',
    value: 'Okay, I understand',
  },
  {
    key: 'continue',
    value: 'Continue',
  },
  {
    key: 'closeAllJobsMsgPrompt',
    value: 'Please close all jobs for this employer before setting inactive.',
  },
  {
    key: 'permanentlyDelete',
    value: 'Permanently Delete Employer?',
  },
  {
    key: 'deleteThisMsg',
    value: 'Yes, Delete this',
  },
  {
    key: 'doNotDeleteThisMsg',
    value: 'No, I changed my mind',
  },
  {
    key: 'deleteSuccess',
    value: 'Delete successful',
  },
  {
    key: 'deletePermanently',
    value: 'Permanently Delete',
  },
  {
    key: 'permanentlyDeleteJobWarningMsg',
    value:
      '<p>Click “YES, DELETE THIS JOB" to proceed with deletion. <b>This will delete the job from all matching opportunities (individual and employer)</b>.</p>',
  },
  {
    key: 'deleteAllJobWarningMsg',
    value:
      '<p>Click “YES, DELETE THIS EMPLOYER" to proceed. <b>This will delete the employer and all jobs associated with it</b>.</p>',
  },
  {
    key: 'deleteIndividualWarningMsg',
    value:
      '<p>Click “YES, DELETE THIS INDIVIDUAL” to proceed with deletion. <b>This will delete the individual from all matching opportunities (job and employer)</b>.</p>',
  },
  {
    key: 'delete',
    value: 'Delete',
  },
  {
    key: 'emptyInstructions',
    value: `No instructions provided.`,
  },
  {
    key: 'assignLeadToJobMsg',
    value: `Assign new lead provider to all jobs associated with this employer? If yes, after updating the employer please reload the page to see changes made.`,
  },
  //KEYWORDS
  {
    key: 'Account Administration',
    value: 'Account Administration',
  },
  {
    key: 'Account Management',
    value: 'Account Management',
  },
  {
    key: 'Accounting',
    value: 'Accounting',
  },
  {
    key: 'Accounts Payable',
    value: 'Accounts Payable',
  },
  {
    key: 'Administration',
    value: 'Administration',
  },
  {
    key: 'Administrative Support',
    value: 'Administrative Support',
  },
  {
    key: 'Adobe',
    value: 'Adobe',
  },
  {
    key: 'Agile',
    value: 'Agile',
  },
  {
    key: 'Answer Phone',
    value: 'Answer Phone',
  },
  {
    key: 'Application Coding',
    value: 'Application Coding',
  },
  {
    key: 'Assembly Work',
    value: 'Assembly Work',
  },
  {
    key: 'Auditing',
    value: 'Auditing',
  },
  {
    key: 'Back-End Programming Languages',
    value: 'Back-End Programming Languages',
  },
  {
    key: 'Banking',
    value: 'Banking',
  },
  {
    key: 'Beta Testing',
    value: 'Beta Testing',
  },
  {
    key: 'Blended Learning',
    value: 'Blended Learning',
  },
  {
    key: 'Blog Writing',
    value: 'Blog Writing',
  },
  {
    key: 'Booking Travel',
    value: 'Booking Travel',
  },
  {
    key: 'Bookkeeping',
    value: 'Bookkeeping',
  },
  {
    key: 'Brand Management',
    value: 'Brand Management',
  },
  {
    key: 'Budget Forecasting',
    value: 'Budget Forecasting',
  },
  {
    key: 'Budget Management',
    value: 'Budget Management',
  },
  {
    key: 'Budgeting',
    value: 'Budgeting',
  },
  {
    key: 'Buggies',
    value: 'Buggies',
  },
  {
    key: 'Buggy Retrieval',
    value: 'Buggy Retrieval',
  },
  {
    key: 'Business Analysis',
    value: 'Business Analysis',
  },
  {
    key: 'Business Development',
    value: 'Business Development',
  },
  {
    key: 'Bussing',
    value: 'Bussing',
  },
  {
    key: 'C#',
    value: 'C#',
  },
  {
    key: 'C++',
    value: 'C++',
  },
  {
    key: 'Cafe Attendant',
    value: 'Cafe Attendant',
  },
  {
    key: 'Car Detailing',
    value: 'Car Detailing',
  },
  {
    key: 'Career Analysis',
    value: 'Career Analysis',
  },
  {
    key: 'Cash Flow Analysis',
    value: 'Cash Flow Analysis',
  },
  {
    key: 'Cashier',
    value: 'Cashier',
  },
  {
    key: 'Change Management',
    value: 'Change Management',
  },
  {
    key: 'Cleaner',
    value: 'Cleaner',
  },
  {
    key: 'Cleaning',
    value: 'Cleaning',
  },
  {
    key: 'Cleaning Baskets',
    value: 'Cleaning Baskets',
  },
  {
    key: 'Clerical',
    value: 'Clerical',
  },
  {
    key: 'Coding',
    value: 'Coding',
  },
  {
    key: 'Cold Calling',
    value: 'Cold Calling',
  },
  {
    key: 'Communications / Public Relations',
    value: 'Communications / Public Relations',
  },
  {
    key: 'Community Engagement',
    value: 'Community Engagement',
  },
  {
    key: 'Computer',
    value: 'Computer',
  },
  {
    key: 'Computer Science',
    value: 'Computer Science',
  },
  {
    key: 'Computer Skills',
    value: 'Computer Skills',
  },
  {
    key: 'Computer Repair',
    value: 'Computer Repair',
  },
  {
    key: 'Concierge',
    value: 'Concierge',
  },
  {
    key: 'Concessions',
    value: 'Concessions',
  },
  {
    key: 'Construction',
    value: 'Construction',
  },
  {
    key: 'Content Creation',
    value: 'Content Creation',
  },
  {
    key: 'Content Marketing',
    value: 'Content Marketing',
  },
  {
    key: 'Cooking (skill)',
    value: 'Cooking (skill)',
  },
  {
    key: 'Copywriting',
    value: 'Copywriting',
  },
  {
    key: 'Cost Accounting',
    value: 'Cost Accounting',
  },
  {
    key: 'Counselling',
    value: 'Counselling',
  },
  {
    key: 'CRM',
    value: 'CRM',
  },
  {
    key: 'Crossing Guard',
    value: 'Crossing Guard',
  },
  {
    key: 'CSS',
    value: 'CSS',
  },
  {
    key: 'Culinary',
    value: 'Culinary',
  },
  {
    key: 'Customer Relations',
    value: 'Customer Relations',
  },
  {
    key: 'Customer Service',
    value: 'Customer Service',
  },
  {
    key: 'Customer Support',
    value: 'Customer Support',
  },
  {
    key: 'Data Analytics',
    value: 'Data Analytics',
  },
  {
    key: 'Data Collection',
    value: 'Data Collection',
  },
  {
    key: 'Data Entry',
    value: 'Data Entry',
  },
  {
    key: 'Data Modeling',
    value: 'Data Modeling',
  },
  {
    key: 'Database Administration',
    value: 'Database Administration',
  },
  {
    key: 'Database Management',
    value: 'Database Management',
  },
  {
    key: 'Debugging',
    value: 'Debugging',
  },
  {
    key: 'Dental Hygiene',
    value: 'Dental Hygiene',
  },
  {
    key: 'Detailing',
    value: 'Detailing',
  },
  {
    key: 'Digital Marketing',
    value: 'Digital Marketing',
  },
  {
    key: 'Dishwashing',
    value: 'Dishwashing',
  },
  {
    key: 'Dispatch',
    value: 'Dispatch',
  },
  {
    key: 'Document Management',
    value: 'Document Management',
  },
  {
    key: 'Documentation',
    value: 'Documentation',
  },
  {
    key: 'Dynamic Web Page Design',
    value: 'Dynamic Web Page Design',
  },
  {
    key: 'Editing & Proofreading',
    value: 'Editing & Proofreading',
  },
  {
    key: 'Electrical Engineering',
    value: 'Electrical Engineering',
  },
  {
    key: 'Email',
    value: 'Email',
  },
  {
    key: 'Email Marketing',
    value: 'Email Marketing',
  },
  {
    key: 'Emergency Support',
    value: 'Emergency Support',
  },
  {
    key: 'Engineering/Computer Engineering',
    value: 'Engineering/Computer Engineering',
  },
  {
    key: 'Estate Planning',
    value: 'Estate Planning',
  },
  {
    key: 'Event Management',
    value: 'Event Management',
  },
  {
    key: 'Excel',
    value: 'Excel',
  },
  {
    key: 'Executive Leadership',
    value: 'Executive Leadership',
  },
  {
    key: 'Executive Support',
    value: 'Executive Support',
  },
  {
    key: 'Expense Reporting',
    value: 'Expense Reporting',
  },
  {
    key: 'Facilities Management',
    value: 'Facilities Management',
  },
  {
    key: 'File',
    value: 'File',
  },
  {
    key: 'Filing',
    value: 'Filing',
  },
  {
    key: 'Financial Accounting',
    value: 'Financial Accounting',
  },
  {
    key: 'Financial Analysis',
    value: 'Financial Analysis',
  },
  {
    key: 'Financial Compliance',
    value: 'Financial Compliance',
  },
  {
    key: 'Financial Management',
    value: 'Financial Management',
  },
  {
    key: 'Financial Planning',
    value: 'Financial Planning',
  },
  {
    key: 'Financial Reporting',
    value: 'Financial Reporting',
  },
  {
    key: 'Fitness Training',
    value: 'Fitness Training',
  },
  {
    key: 'Folding',
    value: 'Folding',
  },
  {
    key: 'Food Safety',
    value: 'Food Safety',
  },
  {
    key: 'Food Preparation',
    value: 'Food Preparation',
  },
  {
    key: 'Food Processing',
    value: 'Food Processing',
  },
  {
    key: 'Forecasting',
    value: 'Forecasting',
  },
  {
    key: 'Forensic Accounting',
    value: 'Forensic Accounting',
  },
  {
    key: 'Framework Templates',
    value: 'Framework Templates',
  },
  {
    key: 'Front-End Web Technologies',
    value: 'Front-End Web Technologies',
  },
  {
    key: 'Fundraising',
    value: 'Fundraising',
  },
  {
    key: 'Games Creation',
    value: 'Games Creation',
  },
  {
    key: 'Garbage Removal',
    value: 'Garbage Removal',
  },
  {
    key: 'Google Ads',
    value: 'Google Ads',
  },
  {
    key: 'Google Analytics',
    value: 'Google Analytics',
  },
  {
    key: 'Google Design Sprint Method',
    value: 'Google Design Sprint Method',
  },
  {
    key: 'Graphic Design',
    value: 'Graphic Design',
  },
  {
    key: 'Greeter',
    value: 'Greeter',
  },
  {
    key: 'Handout Promotional Items',
    value: 'Handout Promotional Items',
  },
  {
    key: 'Heavy Equipment Operation',
    value: 'Heavy Equipment Operation',
  },
  {
    key: 'Housekeeping',
    value: 'Housekeeping',
  },
  {
    key: 'HTML',
    value: 'HTML',
  },
  {
    key: 'HTML/CSS',
    value: 'HTML/CSS',
  },
  {
    key: 'Human Resources',
    value: 'Human Resources',
  },
  {
    key: 'IBM Cognos Impromptu',
    value: 'IBM Cognos Impromptu',
  },
  {
    key: 'Illustrator',
    value: 'Illustrator',
  },
  {
    key: 'Immigration',
    value: 'Immigration',
  },
  {
    key: 'Impact Assessment',
    value: 'Impact Assessment',
  },
  {
    key: 'Inclusive Classroom',
    value: 'Inclusive Classroom',
  },
  {
    key: 'Income Tax Planning',
    value: 'Income Tax Planning',
  },
  {
    key: 'InDesign',
    value: 'InDesign',
  },
  {
    key: 'Industrial Mechanism',
    value: 'Industrial Mechanism',
  },
  {
    key: 'Instagram Management',
    value: 'Instagram Management',
  },
  {
    key: 'Insurance',
    value: 'Insurance',
  },
  {
    key: 'Interactive Classroom',
    value: 'Interactive Classroom',
  },
  {
    key: 'Intuit QuickBooks',
    value: 'Intuit QuickBooks',
  },
  {
    key: 'Inventory Management',
    value: 'Inventory Management',
  },
  {
    key: 'Investment Management',
    value: 'Investment Management',
  },
  {
    key: 'InVision',
    value: 'InVision',
  },
  {
    key: 'Invoicing',
    value: 'Invoicing',
  },
  {
    key: 'Child Care (skill)',
    value: 'Child Care (skill)',
  },
  {
    key: 'Driving (skill)',
    value: 'Driving (skill)',
  },
  {
    key: 'IT Support',
    value: 'IT Support',
  },
  {
    key: 'Janitorial Services',
    value: 'Janitorial Services',
  },
  {
    key: 'Java',
    value: 'Java',
  },
  {
    key: 'JavaScript',
    value: 'JavaScript',
  },
  {
    key: 'Jira',
    value: 'Jira',
  },
  {
    key: 'Journalism',
    value: 'Journalism',
  },
  {
    key: 'Justinmind',
    value: 'Justinmind',
  },
  {
    key: 'Kitchen Assistant',
    value: 'Kitchen Assistant',
  },
  {
    key: 'Kitchen Help',
    value: 'Kitchen Help',
  },
  {
    key: 'Labour',
    value: 'Labour',
  },
  {
    key: 'Labour Relations',
    value: 'Labour Relations',
  },
  {
    key: 'Language Interpretation',
    value: 'Language Interpretation',
  },
  {
    key: 'Language Skills (Spoken and/or Written)',
    value: 'Language Skills (Spoken and/or Written)',
  },
  {
    key: 'Lead Generation',
    value: 'Lead Generation',
  },
  {
    key: 'Legal',
    value: 'Legal',
  },
  {
    key: 'Legal Support',
    value: 'Legal Support',
  },
  {
    key: 'Lifting',
    value: 'Lifting',
  },
  {
    key: 'Light Duty Cleaning',
    value: 'Light Duty Cleaning',
  },
  {
    key: 'LinkedIn Management',
    value: 'LinkedIn Management',
  },
  {
    key: 'Machine Operation',
    value: 'Machine Operation',
  },
  {
    key: 'Maintenance',
    value: 'Maintenance',
  },
  {
    key: 'Landscaping',
    value: 'Landscaping',
  },
  {
    key: 'Management Accounting',
    value: 'Management Accounting',
  },
  {
    key: 'MAP Testing',
    value: 'MAP Testing',
  },
  {
    key: 'Market Analysis',
    value: 'Market Analysis',
  },
  {
    key: 'Market Research',
    value: 'Market Research',
  },
  {
    key: 'Marketing',
    value: 'Marketing',
  },
  {
    key: 'Marketing Campaigns',
    value: 'Marketing Campaigns',
  },
  {
    key: 'Massage Therapy',
    value: 'Massage Therapy',
  },
  {
    key: 'Mechanical Engineering',
    value: 'Mechanical Engineering',
  },
  {
    key: 'Media Communication',
    value: 'Media Communication',
  },
  {
    key: 'Medical Administration',
    value: 'Medical Administration',
  },
  {
    key: 'Meeting Coordination',
    value: 'Meeting Coordination',
  },
  {
    key: 'Meeting Minutes Recording',
    value: 'Meeting Minutes Recording',
  },
  {
    key: 'Merchandising',
    value: 'Merchandising',
  },
  {
    key: 'Machine Learning/AI',
    value: 'Machine Learning/AI',
  },
  {
    key: 'Microsoft Excel',
    value: 'Microsoft Excel',
  },
  {
    key: 'Microsoft Office Suite',
    value: 'Microsoft Office Suite',
  },
  {
    key: 'Mopping',
    value: 'Mopping',
  },
  {
    key: 'NetSuite',
    value: 'NetSuite',
  },
  {
    key: 'Networking',
    value: 'Networking',
  },
  {
    key: 'Node',
    value: 'Node',
  },
  {
    key: 'Nurse aide',
    value: 'Nurse aide',
  },
  {
    key: 'Nursing',
    value: 'Nursing',
  },
  {
    key: 'Object-Oriented Design',
    value: 'Object-Oriented Design',
  },
  {
    key: 'Occupational Health and Safety',
    value: 'Occupational Health and Safety',
  },
  {
    key: 'Office Supply Management',
    value: 'Office Supply Management',
  },
  {
    key: 'Office Support',
    value: 'Office Support',
  },
  {
    key: 'Oil Changes',
    value: 'Oil Changes',
  },
  {
    key: 'Omnigraffle',
    value: 'Omnigraffle',
  },
  {
    key: 'Oracle Business Intelligence',
    value: 'Oracle Business Intelligence',
  },
  {
    key: 'Order Processing',
    value: 'Order Processing',
  },
  {
    key: 'Outlook',
    value: 'Outlook',
  },
  {
    key: 'Packing',
    value: 'Packing',
  },
  {
    key: 'Packaging',
    value: 'Packaging',
  },
  {
    key: 'Paralegal',
    value: 'Paralegal',
  },
  {
    key: 'Patient Services',
    value: 'Patient Services',
  },
  {
    key: 'Payroll',
    value: 'Payroll',
  },
  {
    key: 'Personalized Learning',
    value: 'Personalized Learning',
  },
  {
    key: 'Phone Skills',
    value: 'Phone Skills',
  },
  {
    key: 'Phone Support',
    value: 'Phone Support',
  },
  {
    key: 'Photo Editing',
    value: 'Photo Editing',
  },
  {
    key: 'Photocopy',
    value: 'Photocopy',
  },
  {
    key: 'Photoshop',
    value: 'Photoshop',
  },
  {
    key: 'PHP',
    value: 'PHP',
  },
  {
    key: 'Physical Labour',
    value: 'Physical Labour',
  },
  {
    key: 'Policy Development',
    value: 'Policy Development',
  },
  {
    key: 'Porter',
    value: 'Porter',
  },
  {
    key: 'Powerpoint',
    value: 'Powerpoint',
  },
  {
    key: 'Process Development',
    value: 'Process Development',
  },
  {
    key: 'Process Improvement',
    value: 'Process Improvement',
  },
  {
    key: 'Procurement',
    value: 'Procurement',
  },
  {
    key: 'Product Design',
    value: 'Product Design',
  },
  {
    key: 'Product Management',
    value: 'Product Management',
  },
  {
    key: 'Production',
    value: 'Production',
  },
  {
    key: 'Program Development',
    value: 'Program Development',
  },
  {
    key: 'Programing',
    value: 'Programing',
  },
  {
    key: 'Project Life Cycle',
    value: 'Project Life Cycle',
  },
  {
    key: 'Project Management',
    value: 'Project Management',
  },
  {
    key: 'Project Management Software',
    value: 'Project Management Software',
  },
  {
    key: 'Proofreading',
    value: 'Proofreading',
  },
  {
    key: 'Prospecting',
    value: 'Prospecting',
  },
  {
    key: 'Python',
    value: 'Python',
  },
  {
    key: 'Quality Assurance',
    value: 'Quality Assurance',
  },
  {
    key: 'Quality Control',
    value: 'Quality Control',
  },
  {
    key: 'Rails',
    value: 'Rails',
  },
  {
    key: 'React',
    value: 'React',
  },
  {
    key: 'Reading 3D',
    value: 'Reading 3D',
  },
  {
    key: 'Receiving',
    value: 'Receiving',
  },
  {
    key: 'Reconciliation',
    value: 'Reconciliation',
  },
  {
    key: 'Recruitment',
    value: 'Recruitment',
  },
  {
    key: 'Recycle Materials',
    value: 'Recycle Materials',
  },
  {
    key: 'Redux',
    value: 'Redux',
  },
  {
    key: 'Relationship Management',
    value: 'Relationship Management',
  },
  {
    key: 'Release Management',
    value: 'Release Management',
  },
  {
    key: 'Report Generation',
    value: 'Report Generation',
  },

  {
    key: 'Research',
    value: 'Research',
  },
  {
    key: 'Resolutions',
    value: 'Resolutions',
  },
  {
    key: 'Resource Allocation',
    value: 'Resource Allocation',
  },
  {
    key: 'Responsive Design',
    value: 'Responsive Design',
  },
  {
    key: 'Revenue Forecasting',
    value: 'Revenue Forecasting',
  },
  {
    key: 'Reviewing Contracts',
    value: 'Reviewing Contracts',
  },
  {
    key: 'Risk Management',
    value: 'Risk Management',
  },
  {
    key: 'Roadmapping',
    value: 'Roadmapping',
  },
  {
    key: 'Ruby',
    value: 'Ruby',
  },
  {
    key: 'Sales',
    value: 'Sales',
  },
  {
    key: 'Salesforce',
    value: 'Salesforce',
  },
  {
    key: 'Sanitizing',
    value: 'Sanitizing',
  },
  {
    key: 'SAS Financial Management',
    value: 'SAS Financial Management',
  },
  {
    key: 'SASS',
    value: 'SASS',
  },
  {
    key: 'Scan Documents',
    value: 'Scan Documents',
  },
  {
    key: 'Scheduling & Planning',
    value: 'Scheduling & Planning',
  },
  {
    key: 'Scope Management',
    value: 'Scope Management',
  },
  {
    key: 'Scrum Management',
    value: 'Scrum Management',
  },
  {
    key: 'Search Engine Marketing (SEM)',
    value: 'Search Engine Marketing (SEM)',
  },
  {
    key: 'Search Engine Optimization (SEO)',
    value: 'Search Engine Optimization (SEO)',
  },
  {
    key: 'Security Compliance',
    value: 'Security Compliance',
  },
  {
    key: 'Security Management',
    value: 'Security Management',
  },
  {
    key: 'Senior Care',
    value: 'Senior Care',
  },
  {
    key: 'Server',
    value: 'Server',
  },
  {
    key: 'Server-Side Scripting',
    value: 'Server-Side Scripting',
  },
  {
    key: 'Shift Work',
    value: 'Shift Work',
  },
  {
    key: 'Shipping',
    value: 'Shipping',
  },
  {
    key: 'Social Media',
    value: 'Social Media',
  },
  {
    key: 'Social Media Management',
    value: 'Social Media Management',
  },
  {
    key: 'Social Work',
    value: 'Social Work',
  },
  {
    key: 'Social-Emotional Learning',
    value: 'Social-Emotional Learning',
  },
  {
    key: 'Software Development',
    value: 'Software Development',
  },
  {
    key: 'Software Workflow',
    value: 'Software Workflow',
  },
  {
    key: 'SQL',
    value: 'SQL',
  },
  {
    key: 'Stakeholder Management',
    value: 'Stakeholder Management',
  },
  {
    key: 'Standing',
    value: 'Standing',
  },
  {
    key: 'Statistical Analysis',
    value: 'Statistical Analysis',
  },
  {
    key: 'Stocking',
    value: 'Stocking',
  },
  {
    key: 'Story Mapping',
    value: 'Story Mapping',
  },
  {
    key: 'Storytelling',
    value: 'Storytelling',
  },
  {
    key: 'Supervision',
    value: 'Supervision',
  },
  {
    key: 'Supply Chain',
    value: 'Supply Chain',
  },
  {
    key: 'Sweeping',
    value: 'Sweeping',
  },
  {
    key: 'Tableau',
    value: 'Tableau',
  },
  {
    key: 'Tape Management',
    value: 'Tape Management',
  },
  {
    key: 'Retail (skill)',
    value: 'Retail (skill)',
  },
  {
    key: 'Tax Preparation',
    value: 'Tax Preparation',
  },
  {
    key: 'Telecommunication',
    value: 'Telecommunication',
  },
  {
    key: 'Trades',
    value: 'Trades',
  },
  {
    key: 'Training',
    value: 'Training',
  },
  {
    key: 'Training Design /Facilitation',
    value: 'Training Design /Facilitation',
  },
  {
    key: 'Troubleshooting',
    value: 'Troubleshooting',
  },
  {
    key: 'Troubleshooting (interest)',
    value: 'Troubleshooting (interest)',
  },
  {
    key: 'Trucking',
    value: 'Trucking',
  },
  {
    key: 'TypeScript',
    value: 'TypeScript',
  },
  {
    key: 'Typography',
    value: 'Typography',
  },
  {
    key: 'User Testing',
    value: 'User Testing',
  },
  {
    key: 'Unloading',
    value: 'Unloading',
  },
  {
    key: 'User Research',
    value: 'User Research',
  },
  {
    key: 'UX/UI Design',
    value: 'UX/UI Design',
  },
  {
    key: 'Vendor Management',
    value: 'Vendor Management',
  },
  {
    key: 'Version Control',
    value: 'Version Control',
  },
  {
    key: 'Video Editing',
    value: 'Video Editing',
  },
  {
    key: 'Waterfall',
    value: 'Waterfall',
  },
  {
    key: 'Wealth Management',
    value: 'Wealth Management',
  },
  {
    key: 'Wipe Tables',
    value: 'Wipe Tables',
  },
  {
    key: 'Wiping',
    value: 'Wiping',
  },
  {
    key: 'Word',
    value: 'Word',
  },
  {
    key: 'Animals',
    value: 'Animals',
  },
  {
    key: 'Art',
    value: 'Art',
  },
  {
    key: 'Automotive',
    value: 'Automotive',
  },
  {
    key: 'Biking',
    value: 'Biking',
  },
  {
    key: 'Camp',
    value: 'Camp',
  },
  {
    key: 'Clothing',
    value: 'Clothing',
  },
  {
    key: 'Community Services',
    value: 'Community Services',
  },
  {
    key: 'Computers',
    value: 'Computers',
  },
  {
    key: 'Data Management',
    value: 'Data Management',
  },
  {
    key: 'Daycare',
    value: 'Daycare',
  },
  {
    key: 'Design',
    value: 'Design',
  },
  {
    key: 'Electronics',
    value: 'Electronics',
  },
  {
    key: 'Event Services',
    value: 'Event Services',
  },
  {
    key: 'Food Retailer',
    value: 'Food Retailer',
  },
  {
    key: 'Food Services',
    value: 'Food Services',
  },
  {
    key: 'Gardening',
    value: 'Gardening',
  },
  {
    key: 'Grocery Store',
    value: 'Grocery Store',
  },
  {
    key: 'Health Care',
    value: 'Health Care',
  },
  {
    key: 'Heavy Equipment',
    value: 'Heavy Equipment',
  },
  {
    key: 'Hospitality Services',
    value: 'Hospitality Services',
  },
  {
    key: 'Information Technology',
    value: 'Information Technology',
  },
  {
    key: 'Janitorial',
    value: 'Janitorial',
  },
  {
    key: 'Landscaping',
    value: 'Landscaping',
  },
  {
    key: 'Legal Services',
    value: 'Legal Services',
  },
  {
    key: 'Library',
    value: 'Library',
  },
  {
    key: 'Manufacturer',
    value: 'Manufacturer',
  },
  {
    key: 'Media',
    value: 'Media',
  },
  {
    key: 'Movies',
    value: 'Movies',
  },
  {
    key: 'Music',
    value: 'Music',
  },
  {
    key: 'Outdoors',
    value: 'Outdoors',
  },
  {
    key: 'Painting',
    value: 'Painting',
  },
  {
    key: 'Park',
    value: 'Park',
  },
  {
    key: 'Reading',
    value: 'Reading',
  },
  {
    key: 'Recycling',
    value: 'Recycling',
  },
  {
    key: 'Security',
    value: 'Security',
  },
  {
    key: 'Senior Facility',
    value: 'Senior Facility',
  },
  {
    key: 'Theatre',
    value: 'Theatre',
  },
  {
    key: 'Tobacconists',
    value: 'Tobacconists',
  },
  {
    key: 'Warehouse',
    value: 'Warehouse',
  },
  {
    key: 'Technology',
    value: 'Technology',
  },
  {
    key: 'Library Assistance',
    value: 'Library Assistance',
  },
  {
    key: 'Carting',
    value: 'Carting',
  },
  {
    key: 'Membership Management',
    value: 'Membership Management',
  },
  {
    key: 'Line Cook',
    value: 'Line Cook',
  },
  {
    key: 'Walking (skill)',
    value: 'Walking (skill)',
  },
  {
    key: 'Cooking (interest)',
    value: 'Cooking (interest)',
  },
  {
    key: 'Walking (interest)',
    value: 'Walking (interest)',
  },
  {
    key: 'Sports (skill)',
    value: 'Sports (skill)',
  },
  {
    key: 'Sports (interest)',
    value: 'Sports (interest)',
  },
  {
    key: 'Standup Comedy',
    value: 'Standup Comedy',
  },
  {
    key: 'Accounts Receivable',
    value: 'Accounts Receivable',
  },
  {
    key: 'Child Care (interest)',
    value: 'Child Care (interest)',
  },
  {
    key: 'Education (skill)',
    value: 'Education (skill)',
  },
  {
    key: 'Writing (skill)',
    value: 'Writing (skill)',
  },
  {
    key: 'Driving (interest)',
    value: 'Driving (interest)',
  },
  {
    key: 'Education (interest)',
    value: 'Education (interest)',
  },
  {
    key: 'Retail (interest)',
    value: 'Retail (interest)',
  },
  {
    key: 'Writing (interest)',
    value: 'Writing (interest)',
  },
  {
    key: 'Event Setup',
    value: 'Event Setup',
  },
  {
    key: 'Telemarketing',
    value: 'Telemarketing',
  },
  {
    key: 'Sorting',
    value: 'Sorting',
  },
  {
    key: 'Baking (interest)',
    value: 'Baking (interest)',
  },
  {
    key: 'Baking (skill)',
    value: 'Baking (skill)',
  },
  {
    key: 'Transportation',
    value: 'Transportation',
  },
  {
    key: 'Teamwork (skill)',
    value: 'Teamwork (skill)',
  },
  {
    key: 'Teamwork',
    value: 'Teamwork',
  },
  {
    key: 'Professional Driving (G License or Equivalent)',
    value: 'Professional Driving (G License or Equivalent)',
  },
  {
    key: 'Commercial Driving',
    value: 'Commercial Driving',
  },
  {
    key: 'Microsoft Access',
    value: 'Microsoft Access',
  },
  {
    key: 'Forklift Operation',
    value: 'Forklift Operation',
  },
  {
    key: 'Logistics Management',
    value: 'Logistics Management',
  },
  {
    key: 'Deliveries',
    value: 'Deliveries',
  },
  {
    key: 'Repetitive Movements',
    value: 'Repetitive Movements',
  },
  {
    key: 'Advertising',
    value: 'Advertising',
  },
  {
    key: 'Bowling',
    value: 'Bowling',
  },
  {
    key: 'Dining',
    value: 'Dining',
  },
  {
    key: 'Taekwondo',
    value: 'Taekwondo',
  },
  {
    key: 'Gym',
    value: 'Gym',
  },
  {
    key: 'Dog Walking',
    value: 'Dog Walking',
  },
  {
    key: 'Animal Care',
    value: 'Animal Care',
  },
  {
    key: 'Mascot',
    value: 'Mascot',
  },
  {
    key: 'Bike Repair',
    value: 'Bike Repair',
  },
  {
    key: 'Xylophonist',
    value: 'Xylophonist',
  },
  // REPORTING TRANSLATIONS
  {
    key: 'reportsTitle',
    value: 'Insights',
  },
  {
    key: 'viewJobMatches',
    value: 'View Job Matches',
  },
  {
    key: 'viewEmployerMatches',
    value: 'View Employer Matches',
  },
  {
    key: 'by',
    value: 'by',
  },
  {
    key: 'thatAre',
    value: 'that are',
  },
  {
    key: 'global',
    value: 'global',
  },
  {
    key: 'myOrg',
    value: 'my org',
  },
  {
    key: 'topRanked',
    value: 'Top ranked',
  },
  {
    key: 'topRankedSkillsAndInterests',
    value: 'Ranked skills & interests',
  },
  {
    key: 'rankedJobKeywords',
    value: 'Ranked job keywords',
  },
  {
    key: 'IndProfileTab',
    value: 'Skill and Interest Profile',
  },
  {
    key: 'JobProfileTab',
    value: 'Keyword Profile',
  },
  {
    key: 'IndPieTab',
    value: 'Individual Status Report',
  },
  {
    key: 'indStatus',
    value: 'Employment Status',
  },
  {
    key: 'reportTitleI',
    value:
      'Identify the top 10 most common skills or interests of Individuals (private to your organization) to help identify the kinds of jobs, companies and industries your organization could target. Toggle by those who are ‘open to work’, ‘not open to work’ or ‘ALL’.',
  },
  {
    key: 'reportTitleII',
    value:
      'Identify the top 10 most common keywords associated with Jobs. Toggle by “Open jobs” “Closed jobs” or “All jobs”.',
  },
  {
    key: 'reportTitleIII',
    value:
      'Use this report to identify Individuals (private to your organization) who could benefit from having more skills or interests in their profile (which helps improve matching opportunities).',
  },
  {
    key: 'reportTitleIV',
    value:
      'Use this report to identify Jobs that could benefit from having more skills or interests in its description (which helps improve matching opportunities).',
  },
  {
    key: 'reportTitleV',
    value:
      'Use this report to identify Individuals (private to your organization) who are ‘open to work’ and ‘not open to work’ and how many hours they are currently working and want to work.',
  },
  {
    key: 'jobKeywords',
    value: 'job keywords',
  },
  {
    key: 'indDistributionTitle',
    value: 'Individuals grouped by total skills',
  },
  {
    key: 'indDistributionTitleII',
    value: 'Individuals grouped by total interests',
  },
  {
    key: 'jobDistributionTitle',
    value: 'Jobs grouped by total keywords',
  },
  {
    key: 'indDistributionSubtitle',
    value: 'Individuals open to work vs. not open to work',
  },
  {
    key: 'noGroupingsMessage',
    value: 'No groupings found for this tag',
  },
  {
    key: 'noDataMessage',
    value: 'No Data',
  },
  {
    key: 'submitRequest',
    value: 'Submit Request',
  },
  {
    key: 'submitKeywordMsg',
    value: `Don't forget to hit the submit request button below!`,
  },
  {
    key: 'submitPromptI',
    value: `Not finding the skills and interests you are looking for? Submit a request here.`,
  },
  {
    key: 'submitPromptII',
    value: `you are looking for? Submit a request here.`,
  },
  {
    key: 'overview',
    value: 'Overview & Description',
  },
  {
    key: 'lp-welcome',
    value: 'Welcome to MyJobMatch!',
  },
  {
    key: 'lp-empJourney',
    value: 'Time to begin your employment journey',
  },
  {
    key: 'welcome',
    value: 'Welcome',
  },
  {
    key: 'lp-returningUser',
    value: 'Returning user? Log in to proceed. ',
  },
  {
    key: 'lp-newUser',
    value: 'New here? Create an account.',
  },
  {
    key: 'lp-login',
    value: 'Log in',
  },
  {
    key: 'lp-createAccount',
    value: 'Create Account',
  },
  {
    key: 'db-subtitle',
    value: "Opportunities await, let's unleash your greatness",
  },
  {
    key: 'db-jobMatchesTitle',
    value: 'Job Matches',
  },
  {
    key: 'db-jobMatchesInactive',
    value:
      "You currently don't have any job matches. Make sure your profile has skills and interests keywords as well as an Ontario home address. Browse the job list to see if anything interests you.",
  },
  {
    key: 'db-jobMatchesInterestText',
    value:
      "You currently don't have any active applications. Browse the job list to see if anything interests you.",
  },
  {
    key: 'db-jobMatchesAddSkills',
    value: 'Add Skills and Interests',
  },
  {
    key: 'db-jobMatchesBrowseJobs',
    value: 'Browse jobs',
  },
  {
    key: 'db-viewAll',
    value: 'View All',
  },
  {
    key: 'db-jobInterestTitle',
    value: 'Job Interest Status',
  },
  {
    key: 'db-jobInterestHours',
    value: 'Hours to Fill: ',
  },
  {
    key: 'db-jobKM',
    value: ' km from your home address',
  },
  {
    key: 'db-jobInterestStatus',
    value: 'Status: ',
  },
  {
    key: 'db-jobInterestStatusInProgress',
    value: 'In Progress',
  },
  {
    key: 'db-jobInterestStatusOffer',
    value: 'Offer of Employment',
  },
  {
    key: 'db-jobInterestStatusInterview',
    value: 'Interview Scheduled',
  },
  {
    key: 'db-jobInterestStatusNope',
    value: 'Not a Match',
  },
  {
    key: 'db-profileCompletionTitle',
    value: 'Profile Completion',
  },
  {
    key: 'db-profileEditButton',
    value: 'Edit Profile',
  },
  {
    key: 'db-profileUpdateJobPref',
    value: 'Update Job Preferences',
  },
  {
    key: 'prof-Title',
    value: 'My Profile',
  },
  {
    key: 'prof-subTitle',
    value: 'Showcase your personal and professional details',
  },
  {
    key: 'prof-editProfile',
    value: 'Edit Profile',
  },
  {
    key: 'prof-skillsAccordian',
    value: 'SKILLS, INTERESTS & RESTRICTIONS',
  },
  {
    key: 'prof-overviewAccordian',
    value: 'Overview',
  },
  {
    key: 'prof-employmentAccordian',
    value: 'Employment Schedule & History',
  },
  {
    key: 'prof-employmentAccordianDays',
    value: 'Days',
  },
  {
    key: 'prof-employmentAccordianStarted',
    value: 'Started',
  },
  {
    key: 'prof-employmentAccordianEnded',
    value: 'Ended',
  },
  {
    key: 'prof-employmentAccordianDuration',
    value: 'Duration',
  },
  {
    key: 'prof-employmentAccordianSource',
    value: 'Source',
  },
  {
    key: 'prof-employmentAccordianYears',
    value: ' years.',
  },
  {
    key: 'prof-employmentAccordianMonths',
    value: ' months.',
  },
  {
    key: 'prof-employmentAccordianMonth',
    value: ' month.',
  },
  {
    key: 'prof-employmentAccordianLessThanMonth',
    value: 'less than a month',
  },
  {
    key: 'Other',
    value: 'Other',
  },
  {
    key: 'prof-attachmentsAccordianCertifications',
    value: 'Certifications',
  },
  {
    key: 'jobs-title',
    value: 'Jobs',
  },
  {
    key: 'jobs-subtitle',
    value: 'Browse through a variety of job opportunities',
  },
  {
    key: 'jobs-closed',
    value: 'No longer accepting applications',
  },
  {
    key: 'jobs-filters',
    value: 'Filters',
  },
  {
    key: 'jobs-sortBy',
    value: 'Sort By',
  },
  {
    key: 'jobs-myJobMatches',
    value: 'My Job Matches',
  },
  {
    key: 'jobsSection',
    value: 'Jobs Section',
  },
  {
    key: 'jobs-jobsILike',
    value: 'Jobs I Like',
  },
  {
    key: 'jobs-searchBarPlaceHolder',
    value: 'Search Jobs',
  },
  {
    key: 'jobsView-backToJobs',
    value: 'Back to Jobs',
  },
  {
    key: 'jobsView-jobDescription',
    value: 'JOB DESCRIPTION',
  },
  {
    key: 'jobsView-jobOverview',
    value: 'JOB OVERVIEW',
  },
  {
    key: 'jobsView-startApplication',
    value: 'Start application',
  },
  {
    key: 'jobsView-disableApplication',
    value: 'Max applications reached',
  },
  {
    key: 'jobsView-startedApplication',
    value: 'Started Application',
  },
  {
    key: 'jobsView-removeApplication',
    value: 'Remove Application',
  },
  {
    key: 'jobsView-like',
    value: 'Like',
  },
  {
    key: 'jobsView-liked',
    value: 'Liked',
  },
  {
    key: 'jobsView-help',
    value: 'Help',
  },
  {
    key: 'jobsView-goodMatch?',
    value: 'Great choice in taking this step!',
  },
  {
    key: 'jobsView-encouragingPushPart',
    value:
      "Starting your job application is a big move towards your career goals. Click 'Continue' and a MyJobMatch Supports Provider will be in touch to help with the next steps of your application.",
  },
  {
    key: 'jobsView-encouragingPushPart1',
    value: "You're one step away from starting an application for the ",
  },
  {
    key: 'jobsView-encouragingPush2',
    value: ' position at ',
  },
  {
    key: 'jobsView-encouragingPush3',
    value: ' km away from you',
  },
  {
    key: 'jobsView-expressInterestCopy',
    value: 'Keep in mind you can apply for a maximum of 5 jobs at a time.',
  },
  {
    key: 'jobsView-expressInterestAccept',
    value: 'Continue',
  },
  {
    key: 'jobsViewMobile-summaryAccordian',
    value: 'Summary & Overview',
  },
  {
    key: 'jobsViewMobile-jobSummary',
    value: 'JOB SUMMARY',
  },
  {
    key: 'empSupportLead-requestSupport',
    value: 'Request Support',
  },
  {
    key: 'overviewWidget-noDetailsAvalible',
    value: 'No details available for this employer...',
  },
  {
    key: 'overviewWidget-noJobsWithEmployer',
    value: 'Currently no jobs listed with this employer.',
  },
  {
    key: 'myjobmatches-title',
    value: 'My Job Matches',
  },
  {
    key: 'chatfeed-title',
    value: 'Chat Feed',
  },
  {
    key: 'myjobmatches-subtitle',
    value: 'Browse through job matches, jobs you like, and track your applications',
  },
  {
    key: 'chatfeed-subtitle',
    value: "Chat with your organization if you're connected and have permission",
  },
  {
    key: 'myactivity-title',
    value: 'My Activity',
  },
  {
    key: 'myactivity-subtitle',
    value: 'Track your job search actions to help you stay organized and updated on your progress',
  },
  {
    key: 'myactivity-noActivityFound',
    value: 'No activity found within this time',
  },
  {
    key: 'myactivity-liked',
    value: 'liked',
  },
  {
    key: 'myactivity-applicationUpdate1',
    value: 'Your application for ',
  },
  {
    key: 'myactivity-applicationUpdate2',
    value: ' has been updated to:',
  },
  {
    key: 'myactivity-unliked',
    value: 'unliked',
  },
  {
    key: 'myactivity-expressedInterestIn',
    value: 'started an application for',
  },
  {
    key: 'myactivity-removeApplied',
    value: 'removed your application for',
  },
  {
    key: 'myactivity-archive',
    value: 'archived your successful application for',
  },
  {
    key: 'myactivity-loggedIn',
    value: 'logged onto MyJobMatch on',
  },
  {
    key: 'myactivity-unhandledCase',
    value: 'Unhandled case',
  },
  {
    key: 'myactivity-edited',
    value: 'You edited your',
  },
  {
    key: 'myactivity-onYourProfile',
    value: 'in your Profile.',
  },
  {
    key: 'myactivity-yourProfile',
    value: 'your profile.',
  },
  {
    key: 'myactivity-earlier',
    value: 'EARLIER',
  },
  {
    key: 'myactivity-startDate',
    value: 'Start Date',
  },
  {
    key: 'myactivity-endDate',
    value: 'End Date',
  },
  {
    key: 'myactivity-errorMessage',
    value: 'Please select a valid date range to continue',
  },
  {
    key: 'myactivity-resetButton',
    value: 'Refresh',
  },
  {
    key: 'jobs-resetButton',
    value: 'Reset',
  },
  {
    key: 'jobs-applyButton',
    value: 'Apply',
  },
  {
    key: 'myactivity-searchButton',
    value: 'Search',
  },
  {
    key: 'profile-overview',
    value: 'OVERVIEW',
  },
  {
    key: 'profile-overviewSubHeading',
    value: "Click 'Edit Profile' to edit any information below.",
  },
  {
    key: 'onboardingQuiz-quizComplete',
    value: 'Quiz complete!',
  },
  {
    key: 'onboardingQuiz-noteToEdit1',
    value: 'Note that the answers you provide are not permanent! You can edit your profile if your',
  },
  {
    key: 'onboardingQuiz-noteToEdit2',
    value: 'change.',
  },
  {
    key: 'onboardingQuiz-currentSkills',
    value: 'Current skills:',
  },
  {
    key: 'onboardingQuiz-currentInterests',
    value: 'Current interests:',
  },
  {
    key: 'onboardingQuiz-newTypeSkills',
    value: 'New skills based on quiz results',
  },
  {
    key: 'onboardingQuiz-newTypeInterests',
    value: 'New interests based on quiz results',
  },
  {
    key: 'onboardingQuiz-addNewS',
    value: 'Add New Skills',
  },
  {
    key: 'onboardingQuiz-addNewI',
    value: 'Add New Interests',
  },
  {
    key: 'onboardingQuiz-goBack',
    value: 'Go Back',
  },
  {
    key: 'individualCreate-quizCompletedPopup',
    value: 'Update your profile to save these new keywords.',
  },
  {
    key: 'individualCreate-keywordSubmitPopup',
    value: 'Your request has been received.',
  },
  {
    key: 'individualCreate-confirmChoice',
    value: 'Are you sure you want to delete this job record?',
  },
  {
    key: 'stepper-step',
    value: 'Step',
  },
  {
    key: 'stepper-of',
    value: 'of',
  },
  {
    key: 'stepper-next',
    value: 'Next',
  },
  {
    key: 'stepper-back',
    value: 'Back',
  },
  {
    key: 'jobQuizCarousel-no',
    value: 'No',
  },
  {
    key: 'jobQuizCarousel-yes',
    value: 'Yes!',
  },
  {
    key: 'jobQuizCarousel-added',
    value: 'Added!',
  },
  {
    key: 'jobQuizCarousel-remove',
    value: 'Remove',
  },
  {
    key: 'jobQuizCarousel-previous',
    value: 'Previous',
  },
  {
    key: 'jobQuizCarousel-next',
    value: 'Next',
  },
  {
    key: 'selectRegisterOption-referenceCode?',
    value: 'Do you have a Reference Code?',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode0',
    value: 'Do you have an Employment Support Provider?',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode0_1',
    value: 'Have they created a MyJobMatch account for you?',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode1',
    value: 'If your Employment Support Provider',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode2',
    value: 'created a MyJobMatch profile for you, request a Reference Code to access it.',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode3',
    value: 'Click "New User" to create a MyJobMatch account if you\'re new to the service.',
  },
  {
    key: 'selectRegisterOption-newUser',
    value: 'New User',
  },
  {
    key: 'selectRegisterOption-referenceCode',
    value: 'Reference code',
  },
  {
    key: 'referenceCodePanel-inputPersonalCode',
    value: 'Enter your Reference Code',
  },
  {
    key: 'referenceCodePanel-pleaseNumOrLet',
    value: 'please enter a number or letter',
  },
  {
    key: 'referenceCodePanel-enterRefCode',
    value:
      'You must request a Reference Code from your Employment Support Provider. If you do not have a Reference Code, you are a New User.',
  },
  {
    key: 'referenceCodePanel-continue',
    value: 'Continue',
  },
  {
    key: 'panelForms-continue',
    value: 'Continue',
  },
  {
    key: 'panelForms-previous',
    value: 'Previous',
  },
  {
    key: 'panelForms-termsAndConditions1',
    value: 'I agree to the',
  },
  {
    key: 'panelForms-termsAndConditions2',
    value: 'Terms and Conditions',
  },
  {
    key: 'panelForms-termsAndConditions3',
    value: 'and the',
  },
  {
    key: 'panelForms-termsAndConditions4',
    value: 'Privacy Policy',
  },
  {
    key: 'panelForms-marketingPromotionalMaterials',
    value: 'I agree to receive marketing or promotional materials',
  },
  {
    key: 'panelForms-letUsKnowPreferences',
    value: 'Share your employment preferences:',
  },
  {
    key: 'panelForms-orgFullError1',
    value: 'Sorry!',
  },
  {
    key: 'panelForms-orgFullError2',
    value:
      'is currently not onboarding new individuals, choose another organization or let us pick for you!',
  },
  {
    key: 'panelForms-fullCapacity',
    value: 'Full Capacity',
  },
  {
    key: 'panelForms-avalible',
    value: 'Available',
  },
  {
    key: 'panelForms-descriptionAndFocus',
    value: 'Description and Focus',
  },
  {
    key: 'panelForms-chooseOrg',
    value:
      'Would you like help from an employment specialist? Select a provider from the list. If not, choose ‘Independent’ from the options. Not sure where services are located? Click <a href="https://www.google.com/maps/d/viewer?mid=1X7aKYuCFmr6-71mxaNuGfEmbSEOxA2g&usp=sharing">here</a> to view the map.',
  },
  {
    key: 'panelForms-fillMinRate',
    value: "Please let us know the minimum hourly wage you'd like to earn.",
  },
  {
    key: 'panelForms-addNonZero',
    value: 'Please let us know the minimum hourly wage you would like to earn.',
  },
  {
    key: 'panelForms-pleaseTellUsMinimumHourlyWage',
    value: 'Please let us know the minimum hourly wage you would like to earn.',
  },
  {
    key: 'panelForms-inputHours',
    value: 'How many hours are you interested in working per week?',
  },
  {
    key: 'panelForms-inputHoursError',
    value: 'Please let us know how many hours you are interested in working per week.',
  },
  {
    key: 'panelForm-minRateHelp',
    value: 'What is the minimum hourly wage you would like to earn?',
  },
  {
    key: 'panelForms-quizAlmostDone',
    value: "You're almost there.",
  },
  {
    key: 'panelForms-quizAlmostDoneSubHeader',
    value:
      "Skills have been added to your profile based on your quiz results. Now let's add your interests.",
  },
  {
    key: 'panelForms-suggestedRole',
    value: "Is the following position a good fit for you? Select 'Yes' to 3 options.",
  },
  {
    key: 'panelForms-exciteYou?',
    value: "Does the following interest excite you? Select 'Yes' to 3 options.",
  },
  {
    key: 'panelForms-completeQuizText1',
    value: 'Take this quiz to help',
  },
  {
    key: 'panelForms-completeQuizText2',
    value: 'us add new',
  },
  {
    key: 'panelForms-completeQuizText3',
    value: 'to your profile!',
  },
  { key: 'panelForms-completeQuizText4', value: 'You can always add more' },
  { key: 'panelForms-completeQuizText5', value: 'later on.' },
  {
    key: 'panelForms-quizIncomplete',
    value: 'Quiz Incomplete!',
  },
  {
    key: 'panelForms-pleaseCompleteQuiz',
    value:
      "Finish the quiz by choosing 'yes' for 3 items. After that, we'll add skills and interests to your profile based on your answers.",
  },
  {
    key: 'panelForms-completeQuizButton',
    value: 'Complete Quiz',
  },
  {
    key: 'panelForms-completeQuizNoButton',
    value: 'No Thanks',
  },
  {
    key: 'panelForms-areYouSureCont?',
    value: 'Are you sure you want to continue?',
  },
  {
    key: 'panelForms-quizUnsavedProgWillBeLost',
    value:
      'You have not completed the quiz. Any skills and interests gathered up to this point will will be lost.',
  },
  {
    key: 'panelForms-accAlreadyExists1',
    value: 'MyJobMatch Account',
  },
  {
    key: 'panelForms-accAlreadyExists2',
    value: 'Already Exists',
  },
  {
    key: 'panelForms-alreadyHaveAcc1',
    value: 'Have you created a MyJobMatch account already?',
  },
  {
    key: 'panelForms-alreadyHaveAcc2',
    value: 'If so, try logging in with your email instead of creating a new account.',
  },
  {
    key: 'panelForms-hasEspGivenRC?1',
    value: 'Has your Employment Support Provider created an account on your behalf?',
  },
  {
    key: 'panelForms-hasEspGivenRC?2',
    value: 'If so, please request a Reference Code from them to gain access to your account. ',
  },
  {
    key: 'panelForms-forgotPasswordSupport1',
    value:
      'If you have forgotten your password or require additional assistance, please reach out to',
  },
  {
    key: 'panelForms-forgotPasswordSupport2',
    value: 'MyJobMatch Support',
  },
  {
    key: 'pageNoteFound',
    value:
      "Ooops, this link doesn't work, you may have entered in the wrong link name. Head back to the dashboard, if the problem persists, please contact the admin",
  },
  {
    key: 'logOutButton',
    value: 'Log Out',
  },
  {
    key: 'signUp-liveInOntario?',
    value: 'Do you live in Ontario?',
  },
  {
    key: 'signUp-mjmOnlyInToronto1',
    value:
      'MyJobMatch presently services the Greater Toronto Area (GTA), with future plans to expand elsewhere in Ontario. While you are welcome to create an account if you are an Ontario resident, please know that most employers and job opportunities are currently in the GTA.',
  },
  {
    key: 'signUp-mjmOnlyInToronto2',
    value:
      'If you do not live in Ontario, please join our waitlist to receive a notification if MyJobMatch comes your way.',
  },
  {
    key: 'signUp-iLiveInOntario',
    value: 'I live in Ontario',
  },
  {
    key: 'signUp-notifyMe',
    value: 'Notify Me',
  },
  {
    key: 'mobileNav-myProfile',
    value: 'My Profile',
  },
  {
    key: 'mobileNav-myJobMatches',
    value: 'My Job Matches',
  },
  {
    key: 'mobileNav-myActivity',
    value: 'My Activity',
  },
  {
    key: 'mobileNav-help',
    value: 'Help',
  },
  {
    key: 'notifcation-view',
    value: 'View',
  },
  {
    key: 'notifcation-jobPosting',
    value: 'Job Posting',
  },
  {
    key: 'notification-jobMatch1',
    value: 'You matched with a job at',
  },
  {
    key: 'notification-view',
    value: 'View',
  },
  {
    key: 'notification-jobPosting',
    value: 'Job Posting',
  },
  {
    key: 'notification-jobMatch2',
    value: 'to learn more.',
  },

  {
    key: 'notification-tryAgainError',
    value: 'Sorry, something went wrong, please try again',
  },
  {
    key: 'notification-activeApplications1',
    value: 'Active Applications',
  },
  {
    key: 'notification-activeApplications2',
    value: 'to track changes.',
  },
  {
    key: 'notification-indivUpdated1',
    value: 'Visit your',
  },
  {
    key: 'notification-indivUpdated2',
    value: 'Activity Log',
  },
  {
    key: 'notification-indivUpdated3',
    value: 'to view changes.',
  },
  {
    key: 'notification-ejiUpdated1',
    value: 'Your',
  },
  {
    key: 'notification-ejiUpdated2',
    value: 'application status has changed.',
  },
  {
    key: 'notification-ejiUpdatedProfile',
    value: 'has updated your profile.',
  },
  {
    key: 'notification-errorCheckInternet',
    value: 'Sorry, something went wrong, check your internet connection and please try again.',
  },
  {
    key: 'formQuizComp-leave?',
    value: 'Your results will not be saved if you exit the quiz.',
  },
  {
    key: 'formQuizComp-veiwResults',
    value: 'View Results',
  },
  {
    key: 'formQuizComp-previous',
    value: 'Previous',
  },
  {
    key: 'formQuizComp-notPermenantSkills',
    value:
      'Note that the answers you provide are not permanent! You can edit your profile if your skills change.',
  },
  {
    key: 'formQuizComp-notPermenantInterests',
    value:
      'Note that the answers you provide are not permanent! You can edit your profile if your interests change.',
  },
  {
    key: 'formQuizComp-skillHeader',
    value: 'What are you able to do?',
  },
  {
    key: 'formQuizComp-interestHeader',
    value: 'What excites you?',
  },
  {
    key: 'formQuizComp-helpAddTypeToProfile1',
    value: 'Complete this quiz to help us add',
  },
  {
    key: 'formQuizComp-helpAddTypeToProfile2',
    value: 'to your profile!',
  },
  {
    key: 'formQuizComp-suitYou?',
    value:
      "Pick 'Yes' or 'No' depending on whether the skills listed are aligned with your abilities.",
  },
  {
    key: 'formQuizComp-exciteYou?',
    value: "Does the following interest excite you? Select 'Yes' to 3 options.",
  },
  {
    key: 'formQuizComp-skillsSubHeader',
    value:
      "Pick 'Yes' or 'No' depending on whether the skills listed are aligned with your abilities.",
  },
  {
    key: 'formQuizComp-interestsSubHeader',
    value: "Pick 'Yes' or 'No' for each interest to show if you like it or not.",
  },
  {
    key: 'formQuizComp-quizHeaderSkills1',
    value: 'Take this quiz to help us add new skills to your profile.',
  },
  {
    key: 'formQuizComp-quizHeaderInterests1',
    value: 'Another short quiz to help us add new interests to your profile.',
  },
  {
    key: 'notification-reOpen1',
    value: 'The',
  },
  {
    key: 'notification-reOpen2',
    value: 'job you liked has re-opened. Submit your application now!',
  },
  {
    key: 'notification-notAMatch0',
    value: '',
  },
  {
    key: 'notification-notAMatch1',
    value: 'position wasn’t the right fit. A better fit may be ahead. Return to the',
  },
  {
    key: 'notification-notAMatch2',
    value: 'to continue browsing.',
  },
  {
    key: 'notification-offer',
    value: 'Contact your Employment Support Provider for more details.',
  },
  {
    key: 'notification-typeOffer1',
    value: 'You have been offered the',
  },
  {
    key: 'notification-typeOffer2',
    value: 'job!',
  },
  {
    key: 'qt-admin-assistant',
    value: 'Admin Assistant',
  },
  {
    key: 'qt-barista',
    value: 'Barista',
  },
  {
    key: 'qt-bike-mechanic',
    value: 'Bike Mechanic',
  },
  {
    key: 'qt-childcare-provider',
    value: 'Childcare Provider',
  },
  {
    key: 'qt-cleaner',
    value: 'Cleaner',
  },
  {
    key: 'qt-community-engagement-coordinator',
    value: 'Community Engagement Coordinator',
  },
  {
    key: 'qt-computer-programmer',
    value: 'Computer Programmer',
  },
  {
    key: 'qt-construction-worker',
    value: 'Construction Worker',
  },
  {
    key: 'qt-cook',
    value: 'Cook',
  },
  {
    key: 'qt-delivery-driver',
    value: 'Delivery Driver',
  },
  {
    key: 'qt-dog-walker',
    value: 'Dog Walker',
  },
  {
    key: 'qt-event-and-project-coordinator',
    value: 'Event and Project Coordinator',
  },
  {
    key: 'qt-grocery-clerk',
    value: 'Grocery Clerk',
  },
  {
    key: 'qt-healthcare-worker',
    value: 'Healthcare Worker',
  },
  {
    key: 'qt-it-technician',
    value: 'IT Technician',
  },
  {
    key: 'qt-library-assistant',
    value: 'Library Assistant',
  },
  {
    key: 'qt-retail-sales-associate',
    value: 'Retail Sales Associate',
  },
  {
    key: 'qt-server',
    value: 'Server',
  },
  {
    key: 'qt-social-media-manager',
    value: 'Social Media Manager',
  },
  {
    key: 'qt-utility-worker',
    value: 'Utility Worker',
  },
  {
    key: 'qt-note-that-the-answers-you-provide-are-not-permanent!-you-can-edit-your-profile-if-ever-your-skills-change.',
    value:
      'The answers you provide are not permanent! You can edit your profile if your skills change.',
  },
  {
    key: 'qt-animals',
    value: 'Animals',
  },
  {
    key: 'qt-creative-art',
    value: 'Creative Art',
  },
  {
    key: 'qt-children',
    value: 'Children',
  },
  {
    key: 'qt-computers',
    value: 'Computers',
  },
  {
    key: 'qt-culinary-arts',
    value: 'Culinary Arts',
  },
  {
    key: 'qt-driving',
    value: 'Driving',
  },
  {
    key: 'qt-entertaining-people',
    value: 'Entertaining people',
  },
  {
    key: 'qt-fitness',
    value: 'Fitness',
  },
  {
    key: 'qt-helping-people',
    value: 'Helping people',
  },
  {
    key: 'qt-learning-new-things',
    value: 'Learning new things',
  },
  {
    key: 'qt-organization',
    value: 'Organization',
  },
  {
    key: 'step2-org',
    value: 'Organization',
  },
  {
    key: 'qt-outdoors',
    value: 'Outdoors',
  },
  {
    key: 'qt-solving-puzzles',
    value: 'Solving puzzles',
  },
  {
    key: 'qt-shopping',
    value: 'Shopping',
  },
  {
    key: 'qt-playing-sports',
    value: 'Playing sports',
  },
  {
    key: 'qt-talking',
    value: 'Talking',
  },
  {
    key: 'qt-skills-and-interests-have-been-added-to-your-profile-based-on-your-quiz-results.',
    value: 'Skills and interests have been added to your profile based on your quiz results.',
  },
  {
    key: 'qt-note-that-the-answers-you-provide-are-not-permanent!-you-can-edit-your-profile-if-your-skills-change.',
    value:
      'Note that the answers you provide are not permanent! You can edit your profile if your skills change.',
  },
  {
    key: 'help',
    value: 'Help',
  },
  {
    key: 'panel1AHelp-welcome',
    value:
      'Welcome to our Help & Support Centre. We are dedicated to providing you with support through every step of your employment journey.',
  },
  {
    key: 'panel1AHelp-bubbleTitle',
    value: 'Having trouble completing your profile? We can help!',
  },
  {
    key: 'panel1AHelp-bubbleContent',
    value:
      'Follow the prompts to provide us with the important information we need to create your profile. Once complete, you’ll be able to browse employment opportunities on MyJobMatch.',
  },
  {
    key: 'panel2AHelp-bubbleTitle',
    value: 'Vous avez du mal à remplir votre profil? Nous pouvons vous aider!',
  },
  {
    key: 'panel2AHelp-bubbleContent',
    value:
      'Follow the prompts to provide us with the important information we need to create your profile. Once complete, you’ll be able to browse employment opportunities on MyJobMatch.',
  },
  {
    key: 'panel3AHelp-relatedSkills',
    value:
      "Both the Skills and Interest Quiz are completed when 3 skills and 3 interests are selected. To update your selections, click on 'Edit Profile' under the 'My Profile' section.",
  },
  {
    key: 'panel3AHelp-relatedInterests',
    value:
      "Both the Skills and Interest Quiz are completed when 3 skills and 3 interests are selected. To update your selections, click on 'Edit Profile' under the 'My Profile' section.",
  },
  {
    key: 'panel3AHelp-bubbleTitle',
    value: 'Help us build your profile by completing this quiz',
  },
  {
    key: 'dashboardHelp-bubbleTitle',
    value: 'Dashboard',
  },
  {
    key: 'dashboardHelp-bubbleContent',
    value:
      'The MyJobMatch Dashboard is like a news centre, displaying all of the most important information and activity in one view. You can browse the latest jobs and review your active applications at a glance.',
  },
  {
    key: 'dashboard-subtitle',
    value: 'View and manage all of your important information and tasks below',
  },
  {
    key: 'referenceCodeHelp-bubbleTitle',
    value: 'What’s a Reference Code? Let us explain!',
  },
  {
    key: 'referenceCodeHelp-bubbleContent',
    value:
      'If your Employment Support Provider (ESP) has created a MyJobMatch profile on your behalf, you can request a code to access it yourself. Please get in touch with your ESP directly and ask them for your MyJobMatch Reference Code to redeem account access. This does not apply to new MyJobMatch users.',
  },
  {
    key: 'myProfileHelp-bubbleTitle',
    value: 'My Profile',
  },
  {
    key: 'myProfileHelp-bubbleContent',
    value:
      "Your profile shows important details of your work history, like your job status, past and present work hours, skills, interests, and more. You can update these details anytime by clicking 'Edit Profile.'",
  },
  {
    key: 'editProfileHelp-bubbleTitle',
    value: 'Edit Profile',
  },
  {
    key: 'editProfileHelp-bubbleContent',
    value:
      'The information you provide is not permanent! You can edit your profile any time your preferences change. Follow the prompts to update or add more information to your profile.',
  },
  {
    key: 'jobsHelp-bubbleTitle',
    value: 'Jobs',
  },
  {
    key: 'jobsHelp-bubbleContent',
    value:
      'Browse through the employment opportunities on MyJobMatch and let us know if something stands out to you. Click the “Like” button to save a job for later or the “Start Application” button to notify MyJobMatch that you’d like to begin the application process.',
  },
  {
    key: 'jobsHelp-bubbleContent-list-title',
    value: 'If you would like to refine your search, you can use the filter and sort features.',
  },
  {
    key: 'jobsHelp-bubbleContent-list-item1',
    value:
      'Filter: according to minimum hourly rate, available work days, and hours per week by toggling OFF or ON. Each filter is populated with your profile preferences, but you can also edit the fields according to your current curiosity.',
  },
  {
    key: 'jobsHelp-bubbleContent-list-item2',
    value:
      'Sort: according to most recent job posts, closest distance to your home, highest to lowest minimum hourly rate, and fastest approaching closing date by selecting the checkboxes.',
  },
  {
    key: 'jobMatchesHelp-bubbleTitle',
    value: 'My Job Matches',
  },
  {
    key: 'jobMatchesHelp-bubbleContent',
    value:
      'This view displays the jobs that are most aligned with your profile—based on your skills, interests, and distance from the workplace. “Active Applications” displays the jobs you have expressed interest in applying for, while “Jobs I Like” displays the jobs you’ve liked while browsing Jobs.',
  },
  {
    key: 'myActivityHelp-bubbleTitle',
    value: 'My Activity',
  },
  {
    key: 'chatHelp-bubbleTitle',
    value: 'Chat Feed',
  },
  {
    key: 'myActivityHelp-bubbleContent',
    value:
      'This is a digital record of all of the activity on your profile. You can scroll through the list to see everything you’ve been up to, or use the date range filter to find more specific activity.',
  },
  {
    key: 'chatHelp-bubbleContent',
    value:
      "The Chat section is where you can connect with your Employment Support Provider through messages. Once your provider grants you access, you'll be able to respond and engage in conversations to receive support and guidance. If you’re expecting a new message, try refreshing the app to ensure you see the latest updates. It’s a space designed to make communication easy and helpful for your journey.",
  },
  {
    key: 'needSupport?',
    value: 'Do you need more support?',
  },
  {
    key: 'contactCustomerSupport',
    value: 'Contact Customer Support',
  },
  {
    key: 'FAQs',
    value: 'Frequently Asked Questions',
  },
  {
    key: 'mjm-userGuide',
    value: 'MyJobMatch User Guide',
  },
  {
    key: 'filterKeyEventsBtn',
    value: 'Delete All',
  },
  {
    key: 'skillsAndInterests-noRestrictions',
    value: 'No Restrictions',
  },
  {
    key: 'panelForms-alreadyUsingEmail',
    value: 'We found an account that already uses this email address.',
  },
  {
    key: 'qt-congratulations-your-profile-is-complete!',
    value: 'Congatulations your profile is complete!',
  },
  {
    key: 'dashboard-popupMessage1',
    value: 'Your profile is now active. It’s time to explore MyJobMatch!',
  },
  {
    key: 'dashboard-popupMessage2',
    value:
      "Your profile isn't active yet because it needs your skills and interests. Without these details, MyJobMatch can't find the right job matches for you.",
  },
  {
    key: 'mustBe14YearsOrOlder',
    value: 'You must be 14 years or older to work in Ontario.',
  },
  {
    key: 'isValidDate-invalidDateMessage',
    value: 'The date you entered is not valid. Please try again using: MM/DD/YYYY.',
  },
  {
    key: 'maximumApplication',
    value: 'You have reached the maximum number of active applications (5)',
  },
  {
    key: 'myjobmatches-buttonSubtitleMatches',
    value: 'Job ideas for you that match your skills, what you like, and are near where you live.',
  },
  {
    key: 'myjobmatches-buttonSubtitleApplications',
    value:
      "Monitor the job applications you've submitted, with a limit of only five active applications at a time.",
  },
  {
    key: 'myjobmatches-buttonSubtitleLikes',
    value:
      "There's no limit to how many jobs you can like, allowing you to keep track of numerous opportunities that catch your eye.",
  },
  {
    key: 'exitQuizButton',
    value: 'Exit Quiz',
  },
  {
    key: 'completeQuizButton',
    value: 'Complete Quiz',
  },
  {
    key: 'pleaseSD',
    value: 'Please select a start date.',
  },
  {
    key: 'weeklySchedule',
    value: 'Please let us know your work schedule.',
  },
  {
    key: 'independent',
    value: 'Independent',
  },
  {
    key: 'independentSubtitle',
    value:
      'For jobseekers who prefer to job search without support from an employment support organization. ',
  },
  {
    key: 'clto',
    value: 'Community Living Toronto',
  },
  {
    key: 'caa',
    value: 'Corbrook Awakening Abilities',
  },
  {
    key: 'letsExplore',
    value: "Let's Explore",
  },
  {
    key: 'completeMyProfile',
    value: 'Complete My Profile',
  },
  {
    key: 'editProfile-stepPersonalDetails',
    value: 'Personal Details',
  },
  {
    key: 'editProfile-stepKeywords',
    value: 'Keywords',
  },
  {
    key: 'editProfile-stepPreferences',
    value: 'Preferences',
  },
  {
    key: 'editProfile-stepEmploymentDetails',
    value: 'Employment Details',
  },
  {
    key: 'editProfile-stepAdditional',
    value: 'Additional',
  },
  {
    key: 'editProfile-skillsSubtitle',
    value: 'A skill is your ability to do something well.',
  },
  {
    key: 'editProfile-interestsSubtitle',
    value: 'An interest is something that you’re excited and curious about.',
  },
  {
    key: 'editProfile-skillssButton',
    value: 'Skills Quiz',
  },
  {
    key: 'editProfile-interestsButton',
    value: 'Interests Quiz',
  },
  {
    key: 'jobs-sortByRecent',
    value: 'Most Recent',
  },
  {
    key: 'jobs-sortByDistance',
    value: 'Distance to Home',
  },
  {
    key: 'jobs-sortByHourlyRate',
    value: 'Minumum Hourly Rate',
  },
  {
    key: 'hrs',
    value: 'hrs',
  },
  {
    key: 'submitPrompt-placeholder',
    value: 'Request additional skills and interests here.',
  },
  {
    key: 'jobs-errorMessage1',
    value:
      "You currently don't have any job matches. Make sure your profile has skills and interests keywords as well as an Ontario home address. Browse the job list to see if anything interests you.",
  },
  {
    key: 'jobs-errorMessage2',
    value:
      'There is currently no information to view. Browse the job list to see if anything interests you or send a mesagae in the chat to request.',
  },
  {
    key: 'remove-app-header',
    value: "Are you sure you want to take back this application you've started?",
  },
  {
    key: 'remove-app-bold',
    value: 'Removing your application will alert your Support Provider.',
  },
  {
    key: 'remove-app-content',
    value: 'If you still want to proceed click Continue',
  },
];

export const frTrans = [
  {
    key: 'hello',
    value: 'Bonjour',
  },
  {
    key: 'dashboardNav',
    value: 'Tableau de bord',
  },
  {
    key: 'employerNav',
    value: 'Employeur',
  },
  {
    key: 'inviteNav',
    value: 'Inviter',
  },
  { key: 'inviteTitle', value: 'Inviter des membres de l’organisation' },
  {
    key: 'inviteText',
    value: `Remplissez le formulaire ci-dessous pour envoyer une invitation aux membres de votre organisation. Les invitations expirent dans un délai de 7 jours, mais ne vous inquiétez pas, vous pourrez toujours en envoyer une autre!`,
  },
  {
    key: 'jobNav',
    value: 'Postes',
  },
  {
    key: 'individualNav',
    value: 'Personne',
  },
  {
    key: 'employer',
    value: 'employeur',
  },
  {
    key: 'individual',
    value: 'personne',
  },
  {
    key: 'individualBtnText',
    value: 'la Personne',
  },
  {
    key: 'globalJobsTitle',
    value: 'Postes ouverts à l’échelle du réseau',
  },
  {
    key: 'jobsWidgetTitle',
    value: 'Derniers postes',
  },
  {
    key: 'public',
    value: 'publique',
  },
  {
    key: 'addJobBtn',
    value: 'Ajouter un poste',
  },
  {
    key: 'privateIndividualTitle',
    value: 'Personnes en recherche d’emploi',
  },
  {
    key: 'individualWidgetTitle',
    value: 'Dernières personnes',
  },
  {
    key: 'privateBtn',
    value: ' Privé',
  },
  {
    key: 'add',
    value: 'Ajouter',
  },
  {
    key: 'addIndividualBtn',
    value: 'Ajouter une personne',
  },
  {
    key: 'privateEmployerTitle',
    value: 'Derniers employeurs',
  },
  {
    key: 'addEmployerBtn',
    value: 'Ajouter un employeur',
  },
  {
    key: 'notificationTitle',
    value: 'Notifications',
  },
  {
    key: 'notificationCountTextI',
    value: 'Vous avez',
  },
  {
    key: 'of',
    value: 'sur',
  },
  {
    key: 'a(f)',
    value: 'une',
  },
  {
    key: 'a(m)',
    value: 'un',
  },
  {
    key: 'notificationCountTextII',
    value: 'notifications non lues.',
  },
  {
    key: 'filterKeyEventsBtn',
    value: 'Delete All',
  },
  {
    key: 'notificationText',
    value: 'Auparavant',
  },
  {
    key: 'notificationMarkAllBtn',
    value: 'Tout marquer comme lu',
  },
  {
    key: 'logoutBtn',
    value: 'Déconnexion',
  },
  {
    key: 'empList',
    value: 'Liste des employeurs',
  },
  {
    key: 'columns',
    value: 'Colonnes',
  },
  {
    key: 'filters',
    value: 'Filtres',
  },
  {
    key: 'density',
    value: 'Densité',
  },
  {
    key: 'export',
    value: 'Exportation',
  },
  {
    key: 'search',
    value: 'Recherche',
  },
  {
    key: 'orgName',
    value: 'Nom de l’organisation',
  },
  {
    key: 'parentOrgName',
    value: 'Nom de l’organisation mère',
  },
  {
    key: 'supportLead',
    value: 'Responsable du soutien à l’emploi',
  },
  {
    key: 'mainCname',
    value: 'Nom de la personne-ressource principale',
  },
  {
    key: 'mainCphone',
    value: 'Numéro de téléphone de la personne-ressource principale',
  },
  {
    key: 'mainCemail',
    value: 'Adresse électronique',
  },
  {
    key: 'mainCemailPh',
    value: 'Adresse électronique',
  },
  {
    key: 'address',
    value: 'Adresse',
  },
  {
    key: 'addressPh',
    value: 'Adresse personnelle',
  },
  {
    key: 'industry',
    value: 'Industrie',
  },
  {
    key: 'description',
    value: 'Description',
  },
  {
    key: 'multiLocation',
    value: 'Lieux multiples',
  },
  {
    key: 'status',
    value: 'Statut',
  },
  {
    key: 'reqSkills',
    value: 'Compétences exigées',
  },
  {
    key: 'keywords',
    value: 'Mots-clés',
  },
  {
    key: 'skillsAndIntersts',
    value: 'compétences et intérêts',
  },
  {
    key: 'onboardDate',
    value: 'Date d’intégration',
  },
  {
    key: 'jobList',
    value: 'Liste des postes',
  },
  {
    key: 'jobTitleJobList',
    value: 'Intitulé du poste',
  },
  {
    key: 'closeDate',
    value: 'Date de clôture',
  },
  {
    key: 'hrsPerWk',
    value: 'Heures par semaine',
  },
  {
    key: 'schedule',
    value: 'Horaire',
  },
  {
    key: 'prefStartDate',
    value: 'Date de début idéale',
  },
  {
    key: 'startDateLabel',
    value: 'Date de début',
  },
  {
    key: 'endDateLabel',
    value: 'Date de fin',
  },
  {
    key: 'certReq',
    value: 'Certification exigée',
  },
  {
    key: 'trainingAvail',
    value: 'Formation disponible',
  },
  {
    key: 'openToTraining',
    value: 'Possibilité d’un accompagnement professionnel pendant la formation',
  },
  {
    key: 'trainingReq',
    value: 'Formation exigée',
  },
  // {
  //   key: 'notesComments',
  //   value: 'Remarques/Commentaires',
  // },
  {
    key: 'individualList',
    value: 'Liste des personnes',
  },
  {
    key: 'fullNameIndividual',
    value: 'Nom complet',
  },
  {
    key: 'phoneNumber',
    value: 'Numéro de téléphone',
  },
  {
    key: 'email',
    value: 'Adresse électronique',
  },
  {
    key: 'overview-email',
    value: 'COURRIEL',
  },
  {
    key: 'dob',
    value: 'Date de naissance',
  },
  {
    key: 'popoCheck',
    value: 'Date de la dernière vérification policière',
  },
  {
    key: 'popoCheck2',
    value: 'Vérification policière',
  },
  {
    key: 'popoCheckSubtext',
    value: 'Quelle est la date de votre dernière vérification policière?',
  },
  {
    key: 'creditCheck',
    value: 'Date de la dernière vérification de solvabilité',
  },
  {
    key: 'creditCheck2',
    value: 'Vérification de solvabilité',
  },
  {
    key: 'creditCheckSubtext',
    value: 'Quelle est la date de votre dernière vérification de solvabilité?',
  },
  {
    key: 'educationalBackground',
    value: 'Educational Background',
  },
  {
    key: 'prefRoles',
    value: 'Préférences professionnelles',
  },
  {
    key: 'prefRolesPh',
    value: 'Exemple : programmeur/programmeuse informatique',
  },
  {
    key: 'minRate',
    value: 'Exemple : 16,55 $',
  },
  {
    key: 'maxRate',
    value: 'Tarif maximum par heure',
  },
  {
    key: 'skills',
    value: 'Compétences',
  },
  {
    key: 'interests',
    value: 'Intérêts',
  },
  {
    key: 'restrictions',
    value: 'Restrictions de travail',
  },
  {
    key: 'daysAvail',
    value: 'Jours de disponibilité',
  },
  {
    key: 'currentWorkingHrs',
    value: 'Heures actuellement travaillées',
  },
  {
    key: 'totalAvailHrs',
    value: 'Total des heures disponibles',
  },
  {
    key: 'dateIntake',
    value: 'Date d’admission',
  },
  {
    key: 'inviteTitle',
    value: 'Inviter des membres de l’organisation',
  },
  {
    key: 'inviteText',
    value:
      'Remplissez le formulaire ci-dessous pour envoyer une invitation aux membres de votre organisation. Les invitations expirent dans un délai de 7 jours, mais ne vous inquiétez pas, vous pourrez toujours en envoyer une autre!',
  },
  {
    key: 'fName',
    value: 'Prénom',
  },
  {
    key: 'lName',
    value: 'Nom de famille',
  },
  {
    key: 'inviteEmailMsg',
    value: `Il s’agit de l’adresse électronique qui sera utilisée pour se connecter à MyJobMatch`,
  },
  {
    key: 'inviteBtn',
    value: 'Envoyer l’invitation',
  },
  {
    key: 'settingsTitle',
    value: 'Paramètres',
  },
  {
    key: 'basicInfo',
    value: 'Renseignements de base',
  },
  {
    key: 'profileImg',
    value: 'Photo de profil',
  },
  {
    key: 'userEmail',
    value: 'E-mail du compte',
  },
  {
    key: 'changeEmailMsg',
    value: 'Pour modifier, veuillez contacter la personne responsable de l’organisation.',
  },
  {
    key: 'submitSettingsBtn',
    value: 'Mettre à jour',
  },
  {
    key: 'submitSaveBtn',
    value: 'Enregistrer',
  },
  {
    key: 'employerBtnText',
    value: `l'employeur`,
  },
  {
    key: 'jobBtnText',
    value: `LE POSTE`,
  },
  {
    key: 'matches',
    value: 'recommandations',
  },
  {
    key: 'helpBtn',
    value: 'Aide',
  },
  {
    key: 'none',
    value: 'Aucune',
  },
  {
    key: 'helpPrompt',
    value: 'Sélectionnez l’une des options ci-dessous',
  },
  {
    key: 'helpReportOption',
    value: 'Signaler un bogue, un problème ou une erreur',
  },
  {
    key: 'helpEmailOption',
    value: 'Nous envoyer un courriel',
  },
  {
    key: 'helpGuideOption',
    value: `Lire le guide d'utilisation`,
  },
  {
    key: 'here',
    value: 'ici',
  },
  {
    key: 'NotificationTitle',
    value: 'Notifications',
  },
  {
    key: 'jobNewNotif',
    value: 'propose un nouveau poste',
  },
  {
    key: 'jobUpdatedNotif',
    value: 'a mis à jour un poste',
  },
  {
    key: 'jobClosingNotif1',
    value: 'le poste pour',
  },
  {
    key: 'jobClosingNotif2',
    value: 'sera',
  },
  {
    key: 'jobClosingNotif3',
    value: 'clôturé dans',
  },
  {
    key: 'jobClosingNotif4',
    value: 'jour(s)',
  },
  {
    key: 'jobClosingNotif5',
    value: 'clôturé aujourd’hui!',
  },
  {
    key: 'newProvNotif',
    value: 'a été ajouté à votre organisation',
  },
  {
    key: 'profilUpdatedNotif',
    value: 'a été mis à jour',
  },
  {
    key: 'individualAddedNotif',
    value: 'a ajouté un chercheur d’emploi',
  },
  {
    key: 'updated',
    value: 'a mis à jour ',
  },
  {
    key: 'open',
    value: 'Ouvert',
  },
  {
    key: 'closed',
    value: 'Fermé',
  },
  {
    key: 'individualUpdatedNotif',
    value: 'profil d’une nouvelle personne',
  },
  { key: 'aNewPerson', value: 'une nouvelle personne' },
  {
    key: 'individualMilkExpirationNotif1',
    value: 'est en recherche d’emploi depuis',
  },
  {
    key: 'individualMilkExpirationNotif2',
    value: 'jours sans aucun changement',
  },
  {
    key: 'individualMatchesNotif',
    value: 'a de nouvelles recommandations d’emploi',
  },
  {
    key: 'selectBirthdatePlaceholder',
    value: 'Vous devez avoir au moins 14 ans pour travailler en Ontario.',
  },
  {
    key: 'selectBirthdateValidError',
    value:
      'La date saisie n’est pas valide. Veuillez réessayer en utilisant le format : MM/JJ/AAAA',
  },
  {
    key: 'selectAddressPlaceholder',
    value:
      'Une liste déroulante apparaît lorsque vous commencez à saisir votre adresse. Veuillez sélectionner votre adresse dans cette liste.',
  },
  {
    key: 'addressHelperText',
    value:
      'Une liste déroulante apparaît lorsque vous commencez à saisir votre adresse. Veuillez sélectionner votre adresse dans cette liste.',
  },
  {
    key: 'dobLabel',
    value: 'Date de naissance',
  },
  {
    key: 'dobPlaceholder',
    value: 'mm/jj/aaaa',
  },
  {
    key: 'dobHelperText',
    value: 'Vous devez avoir au moins 14 ans pour travailler en Ontario.',
  },
  {
    key: 'editProfile-keywordaHeader',
    value:
      'Les mots-clés permettent de trouver des employeurs et des offres d’emploi correspondant à votre profil.',
  },
  {
    key: 'skillsTitle',
    value: 'Mes compétences',
  },
  {
    key: 'interestsTitle',
    value: 'Mes intérêts',
  },
  {
    key: 'restrictionsTextPlaceholder',
    value:
      'Exemple: incapacité à soulever des charges lourdes, à rester assis/assise longtemps, etc. ',
  },
  {
    key: 'restrictionsHelperText',
    value:
      'En nous parlant de vos limites, nous pouvons trouver des options d’emploi qui vous conviennent le mieux.',
  },
  {
    key: 'individual',
    value: 'personne',
  },
  {
    key: 'indStatusLabel',
    value: 'Statut de la personne',
  },
  {
    key: 'indStatusOpen',
    value: 'En recherche d’emploi',
  },
  {
    key: 'indStatusNotOpen',
    value: `Ne recherche pas d'emploi`,
  },
  {
    key: 'daysAvailTitle',
    value: 'Jours de disponibilité',
  },
  {
    key: 'daysAvailHelperText',
    value: 'Quels jours êtes-vous disponible pour travailler?',
  },
  {
    key: 'totalHrsLabel',
    value: 'Heures par semaine',
  },
  {
    key: 'totalHrsPlaceholder',
    value: 'Exemple : 14',
  },
  {
    key: 'currentEmploymentTitle',
    value: 'Horaire d’emploi et historique',
  },
  {
    key: 'addJobBtn',
    value: 'Ajouter un poste',
  },
  {
    key: 'attachmentsTitle',
    value: 'Pièces jointes',
  },
  {
    key: 'resumeUploadTitle',
    value: 'CV',
  },
  {
    key: 'resumeUploadLabel',
    value: 'Joindre un CV',
  },
  {
    key: 'resumeAttached',
    value: 'Resume Attached',
  },
  {
    key: 'coverLetterUploadTitle',
    value: 'Lettre d’accompagnement',
  },
  {
    key: 'coverLetterAttached',
    value: 'Cover Letter Attached',
  },
  {
    key: 'coverLetterUploadLabel',
    value: 'Joindre une lettre d’accompagnement',
  },
  {
    key: 'refTitle',
    value: 'Références',
  },
  {
    key: 'refHelperText',
    value: '3 au maximum',
  },
  {
    key: 'refLabel',
    value: 'Joindre des références',
  },

  {
    key: 'certsHelperText',
    value: '5 au maximum',
  },
  {
    key: 'certsLabel',
    value: 'Joindre des certifications',
  },
  {
    key: 'individualSubmitBtn',
    value: 'Enregistrer la personne',
  },
  {
    key: 'empInfoMainTitle',
    value: 'APERÇU DE LA PERSONNE',
  },
  {
    key: 'empScheduleTitle',
    value: 'HORAIRE D’EMPLOI ACTUEL',
  },
  {
    key: 'emptyNotesMsgIndividual',
    value: 'Il n’y a actuellement aucun commentaire pour cette personne.',
  },
  {
    key: 'nearestJobBtn',
    value: 'Postes les plus proches',
  },
  {
    key: 'nearestEmployersBtn',
    value: 'Employeurs les plus proches',
  },
  {
    key: 'alignedJobsBtn',
    value: 'Postes les plus adéquats',
  },
  {
    key: 'recommendationsWidgetAlignedBtn',
    value: 'Emplois les plus adéquats',
  },
  {
    key: 'recommendataionsCumBtn',
    value: 'Recommandations cumulées',
  },
  {
    key: 'individualViewBackBtn',
    value: 'Retour à la liste des personnes',
  },
  {
    key: 'individualViewEditBtn',
    value: 'Modifier la personne',
  },
  {
    key: 'jobViewEditBtn',
    value: 'Modifier la poste',
  },
  {
    key: 'job',
    value: 'poste',
  },
  {
    key: 'employerViewTitle',
    value: 'DÉTAILS DE L’EMPLOYEUR',
  },
  {
    key: 'employerName',
    value: `Employeur`,
  },
  {
    key: 'employerNameExample',
    value: 'Exemple : Amazon',
  },
  {
    key: 'employersName',
    value: `Nom de l'employeur`,
  },
  {
    key: 'addImg',
    value: `Ajouter une image`,
  },
  {
    key: 'addImgText',
    value: 'Ajouter une image',
  },
  {
    key: 'defaultOption',
    value: 'par défaut',
  },
  {
    key: 'leadProvLabel',
    value: 'Responsable du soutien à l’emploi',
  },
  {
    key: 'orgNameLabel',
    value: 'Nom de l’organisation*',
  },
  {
    key: 'jobInputPlaceholder',
    value: 'Exemple : Loblaws – rue Dupont',
  },
  {
    key: 'orgNameHelperText',
    value:
      'Il s’agit du nom de votre organisation suivi d’un élément d’identification (en cas de lieux multiples).',
  },
  {
    key: 'parentOrgNameLabel',
    value: 'Organisation mère',
  },
  {
    key: 'parentOrgNamePlaceholder',
    value: 'Exemple : Loblaws',
  },
  {
    key: 'parentOrgNameHelperText',
    value:
      'S’il n’y a qu’un seul lieu, le nom de l’organisation mère est identique à celui de l’organisation.',
  },
  {
    key: 'multiLocLabel',
    value: 'Lieux multiples',
  },
  {
    key: 'industryLabel',
    value: 'Industrie*',
  },
  {
    key: 'thousandMaxCharMsg',
    value: 'Maximum 1 000 caractères.',
  },
  {
    key: 'twoThousandMaxCharMsg',
    value: 'Maximum 2 500 caractères.',
  },
  {
    key: 'reqSkills',
    value: 'Compétences exigées',
  },
  {
    key: 'reqSkillsPlaceholder',
    value: 'Se tenir debout pendant de longues heures, soulever plus de 50 livres, etc.',
  },
  {
    key: 'keywordLabel',
    value: 'Mots-clés',
  },
  {
    key: 'keywordPlaceholder',
    value:
      'Plus vous utilisez de mots-clés, plus vous générez de correspondances entre des employeurs et des personnes.',
  },
  {
    key: 'mcFirstNameLabel',
    value: 'Prénom de la personne-ressource principale',
  },
  {
    key: 'mcLastNameLabel',
    value: 'Nom de famille de la personne-ressource principale',
  },
  {
    key: 'mcPhoneNumberLabel',
    value: 'Numéro de téléphone de la personne-ressource principale',
  },
  {
    key: 'mcPhoneNumberMsg',
    value: 'Numéro de téléphone du contact principal requis',
  },
  {
    key: 'mcEmailLabel',
    value: 'Adresse électronique de la personne-ressource principale',
  },
  {
    key: 'employerProfile',
    value: 'Profil de l’employeur',
  },
  {
    key: 'savingEmployer',
    value: 'Employeur épargnant',
  },
  {
    key: 'savingJob',
    value: 'Poste épargnant',
  },
  {
    key: 'savingIndividual',
    value: 'Personne épargnant',
  },
  {
    key: 'savedSuccess',
    value: 'enregistré avec succès!',
  },
  {
    key: 'view',
    value: 'Voir',
  },
  {
    key: 'viewing',
    value: 'Affichage',
  },
  {
    key: 'viewJobBtn',
    value: 'Afficher le poste',
  },
  {
    key: 'employerViewEditBtn',
    value: 'Modifier l’employeur',
  },
  {
    key: 'employerDetails',
    value: 'Détails concernant l’employeur',
  },
  {
    key: 'employerViewHeader2',
    value: 'APERÇU DE L’EMPLOYEUR',
  },
  {
    key: 'employerViewHeader3',
    value: 'DESCRIPTION DE L’EMPLOYEUR',
  },
  {
    key: 'emptyDetailsMsgEmployerView',
    value: 'Pas de renseignements disponibles pour cet employeur...',
  },
  {
    key: 'emptyJobListingMsgEmployerView',
    value: 'Il n’y a actuellement aucun poste à pourvoir chez cet employeur.',
  },
  {
    key: 'emptyNotesMsgEmployerView',
    value: 'Il n’y a actuellement aucun commentaire pour cet employeur.',
  },
  {
    key: 'nearestIndividualBtn',
    value: 'Personnes les plus proches',
  },
  {
    key: 'nearest',
    value: 'la plus proches',
  },
  {
    key: 'aligned',
    value: 'le plus aligné',
  },
  {
    key: 'cumulative',
    value: 'cumulatif',
  },
  {
    key: 'alignedIndividualBtn',
    value: 'Personnes les plus adéquates',
  },
  {
    key: 'alignedEmployersBtn',
    value: 'Employeurs les plus adéquate',
  },
  {
    key: 'cumBtn',
    value: 'Recommandations cumulées',
  },
  {
    key: 'jobDetailTitle',
    value: 'DÉTAILS DU POSTE',
  },
  {
    key: 'orgNameLabel',
    value: 'Nom de l’organisation*',
  },
  {
    key: 'jobStatusLabel',
    value: 'Statut du poste',
  },
  {
    key: 'jobClosed',
    value: 'Fermé',
  },
  {
    key: 'jobOpened',
    value: 'Ouvert',
  },
  {
    key: 'jobTypeLabel',
    value: 'Type de poste',
  },
  {
    key: 'irlText',
    value: 'Sur place',
  },
  {
    key: 'remoteText',
    value: 'À distance',
  },
  {
    key: 'hybridText',
    value: 'Hybride',
  },
  {
    key: 'addresPlaceholder',
    value: 'Adresse',
  },
  {
    key: 'addressLabel',
    value: 'Adresse*',
  },
  {
    key: 'esProviderLabel',
    value: 'Fournisseur de soutien à l’emploi (renseigné automatiquement)',
  },
  {
    key: 'esProviderplaceholder',
    value:
      'Le principal fournisseur de soutien à l’emploi de cet employeur est automatiquement renseigné pour ce poste.',
  },
  {
    key: 'jobTitleLabel',
    value: 'Intitulé du poste*',
  },
  {
    key: 'jobTitlePlaceholder',
    value: 'Caissier/caissière –  quart de jour/nuit, Quinpool Road',
  },
  {
    key: 'descriptionLabel',
    value: 'Description',
  },
  {
    key: 'jobDescriptionText',
    value: 'Description du poste',
  },
  {
    key: 'keywordsLabel',
    value: 'Mots-clés*',
  },
  {
    key: 'skillsInterestsLabel',
    value: 'Mots-clés concernant les intérêts et les compétences*',
  },
  {
    key: 'skillsInterestPlaceholder',
    value:
      'Plus vous utilisez de mots-clés, plus vous générez de correspondances entre des employeurs et des personnes. Les mots-clés sont une combinaison de compétences et d’intérêts.',
  },
  {
    key: 'skills&interestNotesLabel',
    value: 'Compétences et intérêts (notes supplémentaires)',
  },
  {
    key: 'skills&interestplaceholder',
    value: 'Décrivez brièvement ce que vous recherchez dans ce poste.',
  },
  {
    key: 'skills&interestHelperText',
    value:
      'Vous n’avez pas trouvé les mots-clés que vous cherchiez? Ajoutez des renseignements supplémentaires pour faciliter la mise en correspondance des compétences.',
  },
  {
    key: 'hourlyRate',
    value: 'Taux horaire',
  },
  {
    key: 'minHrRateLabel',
    value: 'Taux minimum par heure',
  },
  {
    key: 'maxHrRateLabel',
    value: 'Taux horaire maximal',
  },
  {
    key: 'wklyHrsLabel',
    value: 'Heures par semaine*',
  },
  {
    key: 'iconText',
    value: 'icône',
  },
  {
    key: 'reqDaysLabel',
    value: 'Jours requis',
  },
  {
    key: 'reqDaysPlaceholder',
    value: 'Sélectionnez les jours applicables pour ce poste.',
  },
  {
    key: 'Monday',
    value: 'Lundi',
  },
  {
    key: 'Tuesday',
    value: 'Mardi',
  },
  {
    key: 'Wednesday',
    value: 'Mercredi',
  },
  {
    key: 'Thursday',
    value: 'Jeudi',
  },
  {
    key: 'Friday',
    value: 'Vendredi',
  },
  {
    key: 'Saturday',
    value: 'Samedi',
  },
  {
    key: 'Sunday',
    value: 'Dimanche',
  },
  {
    key: 'Mon',
    value: 'Lun.',
  },
  {
    key: 'Tues',
    value: 'Mar.',
  },
  {
    key: 'Wed',
    value: 'Mer.',
  },
  {
    key: 'Thur',
    value: 'Jeu.',
  },
  {
    key: 'Fri',
    value: 'Ven.',
  },
  {
    key: 'Sat',
    value: 'Sam.',
  },
  {
    key: 'Sun',
    value: 'Dim.',
  },
  {
    key: 'MonToSun',
    value: 'Lun.-Dim.',
  },
  {
    key: 'MonToFri',
    value: 'Lun.-Ven.',
  },
  {
    key: 'idealStartDate',
    value: 'Date de début idéale',
  },
  {
    key: 'closingDateJob',
    value: 'Date de clôture',
  },
  {
    key: 'closingDateCheckBoxLabel',
    value: 'Activer une date de clôture pour ce poste',
  },
  {
    key: 'trainingReqLabel',
    value: 'Formation exigée',
  },
  {
    key: 'certsReqLabel',
    value: 'Certification exigée',
  },
  {
    key: 'trainingAvailLabel',
    value: 'Formation exigée',
  },
  {
    key: 'openToCoachingLabel',
    value: 'Possibilité d’un accompagnement professionnel pendant la formation',
  },
  {
    key: 'howToApply',
    value: 'Comment postuler',
  },
  {
    key: 'notesPlaceholder',
    value:
      'Veuillez préciser comment l’employeur souhaite recevoir les candidatures à ce poste (sur le site Web, par l’intermédiaire du fournisseur de soutien à l’emploi, sur place, etc.).',
  },
  {
    key: 'attachmentsTitle',
    value: 'Pièces jointes',
  },
  {
    key: 'jobDescriptionText',
    value: 'Description du poste',
  },
  {
    key: 'uploadJobDescriptionBtn',
    value: 'Joindre la description du poste',
  },
  {
    key: 'additionalFilesTitle',
    value: 'Fichier(s) supplémentaire(s)',
  },
  {
    key: 'additionalFilesText',
    value: 'Fichier(s) supplémentaire(s)',
  },
  {
    key: 'jobFormSubmitBtn',
    value: 'Enregistrer le poste',
  },
  {
    key: 'providerCardTitle',
    value: 'RESPONSABLE DU SOUTIEN À L’EMPLOI',
  },
  {
    key: 'overviewTitleJobView',
    value: 'APERÇU DU POSTE',
  },
  {
    key: 'empty',
    value: 'Vide',
  },
  {
    key: 'backBtnJobView',
    value: 'Retour à la liste des postes',
  },
  {
    key: 'backBtnEmployerView',
    value: 'Retour à la liste des employeurs',
  },
  {
    key: 'individualFormTitle',
    value: 'Détails de la personne',
  },
  {
    key: 'leadProviderLabel',
    value: 'Responsable du soutien à l’emploi',
  },
  {
    key: 'empStatus',
    value: `Statut de l'employeur`,
  },
  {
    key: 'individualFirstNameLabel',
    value: 'Prénom',
  },
  {
    key: 'individualFirstNamePh',
    value: 'Prénom',
  },
  {
    key: 'individualLastNamePh',
    value: 'Nom de famille',
  },
  {
    key: 'individualLastNameLabel',
    value: 'Nom de famille',
  },
  {
    key: 'phoneNumber',
    value: 'Numéro de téléphone',
  },
  {
    key: 'phoneNumberPh',
    value: 'Numéro de téléphone',
  },
  {
    key: 'chooseYourProNoun',
    value: 'Pronoms personnels',
  },
  {
    key: 'chooseYourProNoun2',
    value: 'Exemple : elle/iel',
  },
  {
    key: 'chooseYourProNounSubtext',
    value: 'Quels pronoms utilisez-vous?',
  },
  {
    key: 'agencyIdLabel',
    value: 'Identifiant de l’organisme',
  },
  {
    key: 'govIdLabel',
    value: 'Pièce d’identité gouvernementale',
  },
  {
    key: 'prefCommsLabel',
    value: 'Moyen de communication préféré',
  },
  {
    key: 'prefCommsLabelExample',
    value: 'Exemple : message texte',
  },
  {
    key: 'prefCommsLabelSubtext',
    value: 'Comment souhaitez-vous que l’on vous joigne?',
  },
  {
    key: 'N/A',
    value: 'Sans objet',
  },
  {
    key: 'accomodationsLabel',
    value: `Mesures d’adaptation exigées`,
  },
  {
    key: 'acommodationsPlaceholder',
    value: 'Exemple : utilisation de matériel de mobilité spécialisé',
  },
  {
    key: 'acommodationsHelper',
    value:
      'Indiquez ce dont vous avez besoin pour que l’espace de travail soit confortable et accessible.',
  },
  {
    key: 'dobLabel',
    value: 'Date de naissance*',
  },
  {
    key: 'preferredRolesHelperText',
    value: 'Quels sont les types de postes qui vous intéressent?',
  },
  {
    key: 'restrictionsTitle',
    value: 'Restrictions de travail',
  },
  {
    key: 'indStatusLabel',
    value: 'Statut de la personne',
  },
  {
    key: 'daysAvailTitle',
    value: 'Jours de disponibilité',
  },

  {
    key: 'totalHrsPlaceholder-eg14',
    value: 'Exemple : 14',
  },
  {
    key: 'addJobBtn',
    value: 'Ajouter un poste',
  },
  {
    key: 'attachmentsTitle',
    value: 'Pièces jointes',
  },
  {
    key: 'resumeUploadTitle',
    value: 'CV',
  },
  {
    key: 'resumeUploadLabelProfile',
    value: 'Joignez votre CV à l’appui de vos candidatures',
  },
  {
    key: 'coverLetterUploadLabelProfile',
    value: 'Joignez votre lettre d’accompagnement à l’appui de vos candidatures',
  },
  {
    key: 'refLabelProfile',
    value: 'Joignez vos références à l’appui de vos candidatures',
  },
  {
    key: 'certsLabelProfile',
    value: 'Joignez vos certifications à l’appui de vos candidatures',
  },
  {
    key: 'resumeUploadLabel',
    value: 'Joindre un CV',
  },
  {
    key: 'coverLetterUploadTitle',
    value: 'Lettre d’accompagnement',
  },
  {
    key: 'coverLetterUploadLabel',
    value: 'Joindre une lettre d’accompagnement',
  },
  {
    key: 'refTitle',
    value: 'Références',
  },
  {
    key: 'refHelperText',
    value: '3 au maximum',
  },
  {
    key: 'refLabel',
    value: 'Joindre des références',
  },
  {
    key: 'certificationTitle',
    value: 'Certifications',
  },
  {
    key: 'certsHelperText',
    value: 'Certifications (5 au maximum)',
  },
  {
    key: 'empInfoMainTitle',
    value: 'APERÇU DE LA PERSONNE',
  },
  {
    key: 'empScheduleTitle',
    value: 'HORAIRE D’EMPLOI ACTUEL',
  },
  {
    key: 'emptyNotesMsgIndividual',
    value: 'Il n’y a actuellement aucun commentaire pour cette personne.',
  },
  {
    key: 'recommendationsWidgetAlignedBtn',
    value: 'Emplois les plus adéquats',
  },
  {
    key: 'recommendataionsCumBtn',
    value: 'Recommandations cumulées',
  },
  {
    key: 'individualViewBackBtn',
    value: 'Retour à la liste des personnes',
  },
  {
    key: 'individualViewEditBtn',
    value: 'Modifier la personne',
  },
  {
    key: 'lessMinute',
    value: `il y a moins d'une minute`,
  },
  {
    key: 'ago',
    value: 'depuis',
  },
  {
    key: 'daysAgo',
    value: 'jours avant',
  },
  {
    key: 'oneDayPast',
    value: 'un jour avant',
  },
  {
    key: 'on',
    value: 'le',
  },
  {
    key: 'inactive',
    value: 'inactif',
  },
  {
    key: 'active',
    value: 'actif',
  },
  {
    key: 'addedBy',
    value: 'ajouté par',
  },
  {
    key: 'added',
    value: 'Ajouté',
  },
  {
    key: 'added2',
    value: 'ajouté',
  },
  {
    key: 'removed',
    value: 'supprimé',
  },
  {
    key: 'to',
    value: 'dans',
  },
  {
    key: 'from',
    value: 'de',
  },
  {
    key: 'yes',
    value: 'oui',
  },
  {
    key: 'no',
    value: 'non',
  },
  {
    key: 'na',
    value: 'Sans objet',
  },
  {
    key: 'dayCES',
    value: 'Journée(s)',
  },
  {
    key: 'hours',
    value: 'Heures',
  },
  {
    key: 'role',
    value: 'Emploi',
  },
  {
    key: 'jobSource',
    value: "Source d'emploi",
  },
  {
    key: 'references',
    value: 'Référence(s)',
  },
  {
    key: 'reference',
    value: 'Référence',
  },
  {
    key: 'certification',
    value: 'certification',
  },
  {
    key: 'employmentHistory',
    value: 'Antécédents professionnels',
  },
  {
    key: 'noNotifications',
    value: 'Vous n’avez aucune nouvelle notification',
  },
  {
    key: 'hasNewJob',
    value: 'nouvelle correspondance avec un poste',
  },
  {
    key: 'rowPerPage',
    value: 'lignes par page',
  },
  {
    key: 'density',
    value: 'densité',
  },
  {
    key: 'columns',
    value: 'Colonnes',
  },
  {
    key: 'filters',
    value: 'Filtres',
  },
  {
    key: 'export',
    value: 'Exporter',
  },
  {
    key: 'checkBoxSelection',
    value: 'Sélection',
  },
  {
    key: 'noRows',
    value: 'Pas de lignes',
  },
  {
    key: 'noResults',
    value: 'Aucun résultat trouvé.',
  },
  {
    key: 'search...',
    value: 'Recherche...',
  },
  {
    key: 'columnTitle',
    value: 'Nom de colonne',
  },
  {
    key: 'findColumn',
    value: 'Rechercher la colonne',
  },
  {
    key: 'hideAll',
    value: 'masquer tout',
  },
  {
    key: 'showAll',
    value: 'Afficher tout',
  },
  {
    key: 'operator',
    value: 'Opérateur',
  },
  {
    key: 'value',
    value: 'valeur',
  },
  {
    key: 'and',
    value: 'et',
  },
  {
    key: 'or',
    value: 'ou',
  },
  {
    key: 'contains',
    value: 'contient',
  },
  {
    key: 'equals',
    value: 'équivaut à',
  },
  {
    key: 'startsWith',
    value: 'commence par',
  },
  {
    key: 'endsWith',
    value: 'se termine par',
  },
  {
    key: 'isEmpty',
    value: 'est vide',
  },
  {
    key: 'isNotEmpty',
    value: `n'est pas vide`,
  },
  {
    key: 'isAnyOf',
    value: `est une des valeurs`,
  },
  {
    key: 'filterValue',
    value: `Valeur du filtre`,
  },
  {
    key: 'compact',
    value: 'compact',
  },
  {
    key: 'standard',
    value: `standard`,
  },
  {
    key: 'comfortable',
    value: `confortable`,
  },
  {
    key: 'dlCSV',
    value: 'Télécharger CSV',
  },
  {
    key: 'print',
    value: 'imprimer',
  },
  {
    key: 'compact',
    value: 'compact',
  },
  {
    key: 'standard',
    value: `standard`,
  },
  {
    key: 'comfortable',
    value: `confortable`,
  },
  {
    key: 'tMenu',
    value: 'Menu',
  },
  {
    key: 'tShowCol',
    value: 'Afficher les colonnes',
  },
  {
    key: 'tMngCol',
    value: 'Manage columns',
  },
  {
    key: 'tFilter',
    value: 'Filtre',
  },
  {
    key: 'tHideCol',
    value: 'Masquer les colonnes',
  },
  {
    key: 'unsort',
    value: 'Ne pas trier',
  },
  {
    key: 'sortUp',
    value: 'Tri asc.',
  },
  {
    key: 'sortDown',
    value: 'Tri desc.',
  },
  //START Rest of translations
  {
    key: 'selectLeadProv',
    value: 'Sélectionnez un fournisseur principal',
  },
  {
    key: 'enterOrgName',
    value: 'Indiquez le nom de l’employeur.',
  },
  {
    key: 'duplicateOrgFound',
    value: 'Un nom d’organisation en double a été trouvé; veuillez modifier le nom pour continuer.',
  },
  {
    key: 'duplicateOrgFoundMsg',
    value: 'Une organisation en double a été trouvée',
  },
  {
    key: 'duplicateParentOrgFoundMsg',
    value: 'Une organisation mère en double a été trouvée',
  },
  {
    key: 'selectIndustryText',
    value: 'Sélectionnez votre industrie',
  },
  {
    key: 'selectIndutryTextII',
    value: 'Sélectionnez une industrie',
  },
  {
    key: 'mainBranchNameReqMsg',
    value: 'Le nom de la succursale principale est requis',
  },
  {
    key: 'leadProviderReqMsg',
    value: 'Un fournisseur principal doit être sélectionné',
  },
  {
    key: 'descErrorMsg',
    value: 'Veuillez saisir une description comportant moins de 2 500 caractères',
  },
  {
    key: 'addressReqMsg',
    value: 'Vous devez sélectionner une adresse parmi l’une des options proposées',
  },
  {
    key: 'addressReqMsgII',
    value:
      'Pour enregistrer ce profil et effectuer une mise en correspondance par lieu, vous devez sélectionner une adresse dans la liste déroulante.',
  },
  {
    key: 'validPhoneReq',
    value: 'Veuillez saisir un numéro valide à 10 chiffres',
  },
  {
    key: 'phoneErrorMsg',
    value: 'Le numéro est trop long!',
  },
  {
    key: 'phoneHelperText',
    value:
      'Veuillez saisir un numéro valide comportant 10 chiffres (possibilité de saisir un numéro de poste comportant 5 chiffres)',
  },
  {
    key: 'emailErrorMsg',
    value: 'Veuillez indiquer une adresse électronique valide',
  },
  {
    key: 'notesErrorMsg',
    value: 'Désolé, vos commentaires doivent comporter moins de 1 000 caractères',
  },
  {
    key: 'created',
    value: 'Créé le',
  },
  {
    key: 'creator',
    value: 'Créateur',
  },
  {
    key: 'goBack',
    value: 'Revenir au profil',
  },
  {
    key: 'openToCoachingLabel',
    value: 'Possibilité d’un accompagnement professionnel',
  },
  {
    key: 'openToCoachSupportColumn',
    value: 'Possibilité d’un accompagnement professionnel',
  },
  {
    key: 'noDetailsAvailable',
    value: 'Pas de renseignements disponibles pour ce poste...',
  },
  {
    key: 'noNotesOnEmployer',
    value: 'Vous n’avez actuellement aucun commentaire sur cet employeur…',
  },
  {
    key: 'empOrgReqMsg',
    value: 'Vous devez sélectionner un employeur',
  },
  {
    key: 'addressErrorMsg',
    value: 'Sélectionnez l’adresse complète dans le menu déroulant.',
  },
  {
    key: 'jobDuplicateMsg',
    value: 'Un poste en double a été trouvé',
  },
  {
    key: 'orgSelectPrompt',
    value:
      'Veuillez sélectionner un nom d’organisation avant de créer un intitulé de poste. Remarque : toute modification du nom de l’organisation aura pour effet de réinitialiser ce champ.',
  },
  {
    key: 'jobTitleErrorMsg',
    value: 'Veuillez indiquer un intitulé de poste.',
  },
  {
    key: 'minRateErrorMsg',
    value: 'La valeur doit être inférieure au taux horaire maximal',
  },
  {
    key: 'maxRateErrorMsg',
    value: 'La valeur doit être supérieure au taux horaire minimal',
  },
  {
    key: 'estHrsPerWeek',
    value: 'Estimation des heures requises par semaine (60 heures max.)',
  },
  {
    key: 'jobClosingDateHelperText',
    value: 'Une date située dans plus de 24 heures doit être sélectionnée.',
  },
  {
    key: 'selectProvPlease',
    value: 'Veuillez sélectionner un fournisseur',
  },
  {
    key: 'selectProvider',
    value: 'Sélectionnez un fournisseur',
  },
  {
    key: 'firstNameReqMsg',
    value: 'Veuillez indiquer votre prénom.',
  },
  {
    key: 'validNameReqMsg',
    value:
      'Veuillez saisir un nom valide. Seuls les lettres, les chiffres, les tirets (-) et les espaces sont autorisés.',
  },
  {
    key: 'indExistsMsg',
    value: 'La personne existe',
  },
  {
    key: 'phoneNumberReqMsg',
    value: 'Veuillez indiquer votre numéro de téléphone.',
  },
  {
    key: 'validEmailReqMsg',
    value: 'Veuillez indiquer votre adresse électronique.',
  },
  {
    key: 'validAddressReqMsg',
    value: 'L’adresse saisie n’est pas valide. Veuillez faire un choix dans la liste déroulante.',
  },
  {
    key: 'dobRequired',
    value:
      'La date saisie n’est pas valide. Veuillez réessayer en utilisant le format : MM/JJ/AAAA',
  },
  {
    key: 'birthDate',
    value: 'date de naissance',
  },
  {
    key: 'dobErrorMsg',
    value:
      'La date saisie n’est pas valide. Veuillez réessayer en utilisant le format : MM/JJ/AAAA',
  },
  {
    key: 'expectedSalaryErrorMsg',
    value: 'Je me trouve dans le mauvais champ! Veuillez indiquer des salaires réels.',
  },
  {
    key: 'numberErrorMsg',
    value:
      'Saisie non valide; veuillez supprimer la virgule décimale ou ajouter une valeur décimale.',
  },
  {
    key: 'availableHoursErrorMsg',
    value: 'Veuillez indiquer moins de 60 heures.',
  },
  {
    key: 'availableHrsHelperText',
    value: 'E.g. 25',
  },
  {
    key: 'availableHoursErrorMsg',
    value: 'Veuillez saisir un nombre d’heures situé entre 0 et 99',
  },
  {
    key: 'availableHoursErrorMsg-v1',
    value: 'Veuillez indiquer le nombre d’heures que vous souhaitez travailler chaque semaine.',
  },
  {
    key: 'thousandMaxChars',
    value: 'Max. 1 000 caractères',
  },
  {
    key: 'selectDayLabel',
    value: 'Veuillez nous indiquer quels sont vos jours de disponibilité pour travailler.',
  },
  {
    key: 'selectDayReqMsg',
    value: 'Vous devez sélectionner un jour',
  },
  {
    key: 'employmentRecord-weekly-schedule-label',
    value: 'Horaire hebdomadaire',
  },
  {
    key: 'Rotating',
    value: 'Roulement',
  },
  {
    key: 'hoursReqErrorMsg',
    value: "Veuillez nous indiquer combien d'heures vous travaillez par semaine.",
  },
  {
    key: 'employerNamePleaseMsg',
    value: 'Veuillez fournir un nom d’employeur.',
  },
  {
    key: 'roleReqMsg',
    value: 'Veuillez indiquer une fonction.',
  },
  {
    key: 'reqRoleLabel',
    value: 'E.g. Baker',
  },
  {
    key: 'individualPlacedByMJM',
    value: 'Avez-vous obtenu ce poste avec l’aide de MyJobMatch?',
  },
  {
    key: 'individualPlacedByMJMII',
    value: 'Indiquez si vous avez obtenu ce poste via MyJobMatch.',
  },
  {
    key: 'noLongWorksHere',
    value: 'Emploi passé',
  },
  {
    key: 'roleActiveMsg',
    value: 'Emploi actuel',
  },
  {
    key: 'lastNameReqMsg',
    value: 'Veuillez indiquer votre nom de famille.',
  },
  {
    key: 'keepNumberUpdToDate',
    value: 'Veillez à ce que votre numéro de téléphone professionnel soit à jour',
  },
  {
    key: 'proifileUpdated',
    value: 'Profil mis à jour!',
  },
  {
    key: 'iUnderstand',
    value: 'OK, je comprends',
  },
  {
    key: 'continue',
    value: 'Continuer',
  },
  {
    key: 'closeAllJobsMsgPrompt',
    value: 'Veuillez clôturer tous les postes de cet employeur avant de le rendre inactif.',
  },
  {
    key: 'permanentlyDeleteEmployer',
    value: 'Supprimer définitivement l’employeur?',
  },
  {
    key: 'importantMsgI',
    value:
      'IMPORTANT : tous les postes associés à cet employeur seront supprimés. Cliquez sur Oui pour continuer et supprimer l’employeur et tous les postes qui lui sont associés.',
  },
  {
    key: 'deleteThisMsg',
    value: 'Oui, procédez à la suppression',
  },
  {
    key: 'doNotDeleteThisMsg',
    value: 'Non, j’ai changé d’avis',
  },
  {
    key: 'deleteSuccess',
    value: 'Suppression réussie',
  },
  {
    key: 'deletePermanently',
    value: 'Suppression définitive',
  },
  {
    key: 'permanentlyDeleteJobWarningMsg',
    value:
      'Ce poste sera supprimé définitivement. Cliquez sur Oui pour procéder à la suppression;<b> toutes les correspondances entre le poste et des personnes seront également supprimées</b>.',
  },
  {
    key: 'deleteAllJobWarningMsg',
    value:
      'Tous les postes associés à cet employeur seront supprimés définitivement. <br/> Click yes to proceed and delete <b>the employer and all of the jobs associated with it</b>.',
  },
  {
    key: 'deleteIndividualWarningMsg',
    value:
      '<p>Cette personne sera supprimée définitivement.<br/> Cliquez sur Oui pour procéder à la suppression, <b>toutes les correspondances entre des postes et la personne ET entre des employeurs et la personne seront également supprimées.</b>.</p>',
  },
  {
    key: 'delete',
    value: 'Supprimer',
  },
  {
    key: 'emptyInstructions',
    value: `Mode d'emploi introuvable`,
  },
  {
    key: 'assignLeadToJobMsg',
    value: `Attribuer un nouveau fournisseur principal à tous les emplois associés à cet employeur? Si oui, après avoir mis à jour l’employeur, veuillez recharger la page pour afficher les modifications apportées.`,
  },

  // KEYWORDS
  {
    key: 'Account Administration',
    value: 'Administration de compte',
  },
  {
    key: 'Account Management',
    value: 'Gestion de compte',
  },
  {
    key: 'Accounting',
    value: 'Comptabilité',
  },
  {
    key: 'Accounts Payable',
    value: 'Comptes fournisseurs',
  },
  {
    key: 'Administration',
    value: 'Administration',
  },
  {
    key: 'Administrative Support',
    value: 'Soutien administratif',
  },
  {
    key: 'Adobe',
    value: 'Adobe',
  },
  {
    key: 'Agile',
    value: 'Agile',
  },
  {
    key: 'Answer Phone',
    value: 'Répondre au téléphone',
  },
  {
    key: 'Application Coding',
    value: 'Codage d’applications',
  },
  {
    key: 'Assembly Work',
    value: 'Travaux d’assemblage',
  },
  {
    key: 'Auditing',
    value: 'Audit',
  },
  {
    key: 'Back-End Programming Languages',
    value: 'Langages de programmation dorsaux',
  },
  {
    key: 'Banking',
    value: 'Banque',
  },
  {
    key: 'Beta Testing',
    value: 'Tests bêta',
  },
  {
    key: 'Blended Learning',
    value: 'Apprentissage mixte',
  },
  {
    key: 'Blog Writing',
    value: 'Rédaction d’articles de blogue',
  },
  {
    key: 'Booking Travel',
    value: 'Réservation de voyages',
  },
  {
    key: 'Bookkeeping',
    value: 'Tenue des comptes',
  },
  {
    key: 'Brand Management',
    value: 'Gestion de la marque',
  },
  {
    key: 'Budget Forecasting',
    value: 'Prévisions budgétaires',
  },
  {
    key: 'Budget Management',
    value: 'Gestion budgétaire',
  },
  {
    key: 'Budgeting',
    value: 'Budgétisation',
  },
  {
    key: 'Buggies',
    value: 'Chariots',
  },
  {
    key: 'Buggy Retrieval',
    value: 'Récupération de chariots',
  },
  {
    key: 'Business Analysis',
    value: 'Analyse opérationnelle',
  },
  {
    key: 'Business Development',
    value: 'Développement commercial',
  },
  {
    key: 'Bussing',
    value: 'Aide-serveur',
  },
  {
    key: 'C#',
    value: 'C#',
  },
  {
    key: 'C++',
    value: 'C++',
  },
  {
    key: 'Cafe Attendant',
    value: 'Serveur de café',
  },
  {
    key: 'Car Detailing',
    value: 'Esthétique automobile',
  },
  {
    key: 'Career Analysis',
    value: 'Analyse de carrière',
  },
  {
    key: 'Cash Flow Analysis',
    value: 'Analyse des flux de trésorerie',
  },
  {
    key: 'Cashier',
    value: 'Caissier',
  },
  {
    key: 'Change Management',
    value: 'Gestion du changement',
  },
  {
    key: 'Cleaner',
    value: 'Nettoyeur',
  },
  {
    key: 'Cleaning',
    value: 'Nettoyage',
  },
  {
    key: 'Cleaning Baskets',
    value: 'Nettoyage de paniers',
  },
  {
    key: 'Clerical',
    value: 'Travail de bureau',
  },
  {
    key: 'Coding',
    value: 'Codage',
  },
  {
    key: 'Cold Calling',
    value: 'Prospection téléphonique',
  },
  {
    key: 'Communications / Public Relations',
    value: 'Communication/Relations publiques',
  },
  {
    key: 'Community Engagement',
    value: 'Engagement communautaire',
  },
  {
    key: 'Computer',
    value: 'Ordinateur',
  },
  {
    key: 'Computer Science',
    value: 'Informatique',
  },
  {
    key: 'Computer Skills',
    value: 'Compétences informatiques',
  },
  {
    key: 'Computer Repair',
    value: 'Réparation d’ordinateurs',
  },
  {
    key: 'Concierge',
    value: 'Conciergerie',
  },
  {
    key: 'Concessions',
    value: 'Concessions',
  },
  {
    key: 'Construction',
    value: 'Construction',
  },
  {
    key: 'Content Creation',
    value: 'Création de contenu',
  },
  {
    key: 'Content Marketing',
    value: 'Marketing de contenu',
  },
  {
    key: 'Cooking (skill)',
    value: 'Cuisine (compétence)',
  },
  {
    key: 'Copywriting',
    value: 'Rédaction',
  },
  {
    key: 'Cost Accounting',
    value: 'Comptabilité analytique',
  },
  {
    key: 'Counselling',
    value: 'Conseils',
  },
  {
    key: 'CRM',
    value: 'Gestion de la relation client',
  },
  {
    key: 'Crossing Guard',
    value: 'Brigadier',
  },
  {
    key: 'CSS',
    value: 'CSS',
  },
  {
    key: 'Culinary',
    value: 'Culinaire',
  },
  {
    key: 'Customer Relations',
    value: 'Relation client',
  },
  {
    key: 'Customer Service',
    value: 'Service à la clientèle',
  },
  {
    key: 'Customer Support',
    value: 'Soutien à la clientèle',
  },
  {
    key: 'Data Analytics',
    value: 'Analyse de données',
  },
  {
    key: 'Data Collection',
    value: 'Collecte de données',
  },
  {
    key: 'Data Entry',
    value: 'Saisie de données',
  },
  {
    key: 'Data Modeling',
    value: 'Modélisation de données',
  },
  {
    key: 'Database Administration',
    value: 'Administration de bases de données',
  },
  {
    key: 'Database Management',
    value: 'Gestion de base de données',
  },
  {
    key: 'Debugging',
    value: 'Débogage',
  },
  {
    key: 'Dental Hygiene',
    value: 'Hygiène dentaire',
  },
  {
    key: 'Detailing',
    value: 'Détaillage',
  },
  {
    key: 'Digital Marketing',
    value: 'Marketing numérique',
  },
  {
    key: 'Dishwashing',
    value: 'Plonge',
  },
  {
    key: 'Dispatch',
    value: 'Expédition',
  },
  {
    key: 'Document Management',
    value: 'Gestion de documents',
  },
  {
    key: 'Documentation',
    value: 'Documentation',
  },
  {
    key: 'Dynamic Web Page Design',
    value: 'Conception de pages Web dynamiques',
  },
  {
    key: 'Editing & Proofreading',
    value: 'Édition et relecture',
  },
  {
    key: 'Electrical Engineering',
    value: 'Génie électrique',
  },
  {
    key: 'Email',
    value: 'Courriel',
  },
  {
    key: 'Email Marketing',
    value: 'Marketing par courriel',
  },
  {
    key: 'Emergency Support',
    value: 'Assistance d’urgence',
  },
  {
    key: 'Engineering/Computer Engineering',
    value: 'Ingénierie/Ingénierie informatique',
  },
  {
    key: 'Estate Planning',
    value: 'Planification successorale',
  },
  {
    key: 'Event Management',
    value: 'Gestion d’événements',
  },
  {
    key: 'Excel',
    value: 'Excel',
  },
  {
    key: 'Executive Leadership',
    value: 'Leadership exécutif',
  },
  {
    key: 'Executive Support',
    value: 'Soutien à la haute direction',
  },
  {
    key: 'Expense Reporting',
    value: 'Rapports de dépenses',
  },
  {
    key: 'Facilities Management',
    value: 'Gestion des installations',
  },
  {
    key: 'File',
    value: 'Dossier',
  },
  {
    key: 'Filing',
    value: 'Classer',
  },
  {
    key: 'Financial Accounting',
    value: 'Comptabilité financière',
  },
  {
    key: 'Financial Analysis',
    value: 'Analyse financière',
  },
  {
    key: 'Financial Compliance',
    value: 'Conformité financière',
  },
  {
    key: 'Financial Management',
    value: 'Gestion financière',
  },
  {
    key: 'Financial Planning',
    value: 'Planification financière',
  },
  {
    key: 'Financial Reporting',
    value: 'Information financière',
  },
  {
    key: 'Fitness Training',
    value: 'Entraînement physique',
  },
  {
    key: 'Folding',
    value: 'Plier',
  },
  {
    key: 'Food Safety',
    value: 'Food Safety',
  },
  {
    key: 'Food Preparation',
    value: 'Préparation des aliments',
  },
  {
    key: 'Food Processing',
    value: 'Transformation des aliments',
  },
  {
    key: 'Forecasting',
    value: 'Prévisions',
  },
  {
    key: 'Forensic Accounting',
    value: 'Juricomptabilité',
  },
  {
    key: 'Framework Templates',
    value: 'Modèles de cadres',
  },
  {
    key: 'Front-End Web Technologies',
    value: 'Technologies Web frontales',
  },
  {
    key: 'Fundraising',
    value: 'Collecte de fonds',
  },
  {
    key: 'Games Creation',
    value: 'Création de jeux',
  },
  {
    key: 'Garbage Removal',
    value: 'Ramassage des poubelles',
  },
  {
    key: 'Google Ads',
    value: 'Google Ads',
  },
  {
    key: 'Google Analytics',
    value: 'Google Analytics',
  },
  {
    key: 'Google Design Sprint Method',
    value: 'Méthode Design Sprint de Google',
  },
  {
    key: 'Graphic Design',
    value: 'Conception graphique',
  },
  {
    key: 'Greeter',
    value: 'Accueil',
  },
  {
    key: 'Handout Promotional Items',
    value: 'Articles promotionnels',
  },
  {
    key: 'Heavy Equipment Operation',
    value: 'Conduite de matériel lourd',
  },
  {
    key: 'Housekeeping',
    value: 'Entretien ménager',
  },
  {
    key: 'HTML',
    value: 'HTML',
  },
  {
    key: 'HTML/CSS',
    value: 'HTML/CSS',
  },
  {
    key: 'Human Resources',
    value: 'Ressources humaines',
  },
  {
    key: 'IBM Cognos Impromptu',
    value: 'IBM Cognos Impromptu',
  },
  {
    key: 'Illustrator',
    value: 'Illustrator',
  },
  {
    key: 'Immigration',
    value: 'Immigration',
  },
  {
    key: 'Impact Assessment',
    value: 'Évaluation de l’impact',
  },
  {
    key: 'Inclusive Classroom',
    value: 'Classe inclusive',
  },
  {
    key: 'Income Tax Planning',
    value: 'Planification fiscale',
  },
  {
    key: 'InDesign',
    value: 'InDesign',
  },
  {
    key: 'Industrial Mechanism',
    value: 'Mécanisme industriel',
  },
  {
    key: 'Instagram Management',
    value: 'Gestion de compte Instagram',
  },
  {
    key: 'Insurance',
    value: 'Assurance',
  },
  {
    key: 'Interactive Classroom',
    value: 'Salle de classe interactive',
  },
  {
    key: 'Intuit QuickBooks',
    value: 'Intuit QuickBooks',
  },
  {
    key: 'Inventory Management',
    value: 'Gestion des stocks',
  },
  {
    key: 'Investment Management',
    value: 'Gestion d’investissements',
  },
  {
    key: 'InVision',
    value: 'InVision',
  },
  {
    key: 'Invoicing',
    value: 'Facturation',
  },
  {
    key: 'Child Care (skill)',
    value: 'Garde d’enfants (compétence)',
  },
  {
    key: 'Driving (skill)',
    value: 'Conduite (compétence)',
  },
  {
    key: 'IT Support',
    value: 'Soutien informatique',
  },
  {
    key: 'Janitorial Services',
    value: 'Services de nettoyage et d’entretien',
  },
  {
    key: 'Java',
    value: 'Java',
  },
  {
    key: 'JavaScript',
    value: 'Javascript',
  },
  {
    key: 'Jira',
    value: 'Jira',
  },
  {
    key: 'Journalism',
    value: 'Journalisme',
  },
  {
    key: 'Justinmind',
    value: 'Justinmind',
  },
  {
    key: 'Kitchen Assistant',
    value: 'Commis de cuisine',
  },
  {
    key: 'Kitchen Help',
    value: 'Aide de cuisine',
  },
  {
    key: 'Labour',
    value: 'Travail',
  },
  {
    key: 'Labour Relations',
    value: 'Relations de travail',
  },
  {
    key: 'Language Interpretation',
    value: 'Interprétation linguistique',
  },
  {
    key: 'Language Skills (Spoken and/or Written)',
    value: 'Compétences linguistiques (orales ou écrites)',
  },
  {
    key: 'Lead Generation',
    value: 'Génération de pistes',
  },
  {
    key: 'Legal',
    value: 'Droit',
  },
  {
    key: 'Legal Support',
    value: 'Soutien juridique',
  },
  {
    key: 'Lifting',
    value: 'Soulever',
  },
  {
    key: 'Light Duty Cleaning',
    value: 'Nettoyage léger',
  },
  {
    key: 'LinkedIn Management',
    value: 'Gestion de compte LinkedIn',
  },
  {
    key: 'Machine Operation',
    value: 'Fonctionnement de machines',
  },
  {
    key: 'Maintenance',
    value: 'Entretien',
  },
  {
    key: 'Landscaping',
    value: 'Aménagement paysager',
  },
  {
    key: 'Management Accounting',
    value: 'Comptabilité de gestion',
  },
  {
    key: 'MAP Testing',
    value: 'Tests MAP',
  },
  {
    key: 'Market Analysis',
    value: 'Analyse de marché',
  },
  {
    key: 'Market Research',
    value: 'Étude de marché',
  },
  {
    key: 'Marketing',
    value: 'Marketing',
  },
  {
    key: 'Marketing Campaigns',
    value: 'Campagnes marketing',
  },
  {
    key: 'Massage Therapy',
    value: 'Massothérapie',
  },
  {
    key: 'Mechanical Engineering',
    value: 'Génie mécanique',
  },
  {
    key: 'Media Communication',
    value: 'Communication médiatique',
  },
  {
    key: 'Medical Administration',
    value: 'Administration médicale',
  },
  {
    key: 'Meeting Coordination',
    value: 'Coordination de réunions',
  },
  {
    key: 'Meeting Minutes Recording',
    value: 'Enregistrement des procès-verbaux de réunion',
  },
  {
    key: 'Merchandising',
    value: 'Marchandisage',
  },
  {
    key: 'Machine Learning/AI',
    value: 'Apprentissage automatique/IA',
  },
  {
    key: 'Microsoft Excel',
    value: 'Microsoft Excel',
  },
  {
    key: 'Microsoft Office Suite',
    value: 'Suite Microsoft Office',
  },
  {
    key: 'Mopping',
    value: 'Passer la serpillière',
  },
  {
    key: 'NetSuite',
    value: 'NetSuite',
  },
  {
    key: 'Networking',
    value: 'Réseautage',
  },
  {
    key: 'Node',
    value: 'Nœud',
  },
  {
    key: 'Nurse aide',
    value: 'Aide-soignant',
  },
  {
    key: 'Nursing',
    value: 'Soins infirmiers',
  },
  {
    key: 'Object-Oriented Design',
    value: 'Conception orientée objet',
  },
  {
    key: 'Occupational Health and Safety',
    value: 'Santé et sécurité au travail',
  },
  {
    key: 'Office Supply Management',
    value: 'Gestion des fournitures de bureau',
  },
  {
    key: 'Office Support',
    value: 'Soutien du bureau',
  },
  {
    key: 'Oil Changes',
    value: 'Vidange d’huile',
  },
  {
    key: 'Omnigraffle',
    value: 'OmniGraffle',
  },
  {
    key: 'Oracle Business Intelligence',
    value: 'Oracle Business Intelligence',
  },
  {
    key: 'Order Processing',
    value: 'Traitement des commandes',
  },
  {
    key: 'Outlook',
    value: 'Outlook',
  },
  {
    key: 'Packing',
    value: 'Conditionnement',
  },
  {
    key: 'Packaging',
    value: 'Emballage',
  },
  {
    key: 'Paralegal',
    value: 'Services parajuridiques',
  },
  {
    key: 'Patient Services',
    value: 'Services aux patients',
  },
  {
    key: 'Payroll',
    value: 'Paie',
  },
  {
    key: 'Personalized Learning',
    value: 'Apprentissage personnalisé',
  },
  {
    key: 'Phone Skills',
    value: 'Communication téléphonique',
  },
  {
    key: 'Phone Support',
    value: 'Assistance au téléphone',
  },
  {
    key: 'Photo Editing',
    value: 'Retouche photo',
  },
  {
    key: 'Photocopy',
    value: 'Photocopie',
  },
  {
    key: 'Photoshop',
    value: 'Photoshop',
  },
  {
    key: 'PHP',
    value: 'PHP',
  },
  {
    key: 'Physical Labour',
    value: 'Travail physique',
  },
  {
    key: 'Policy Development',
    value: 'Élaboration de politiques',
  },
  {
    key: 'Porter',
    value: 'Porteur',
  },
  {
    key: 'Powerpoint',
    value: 'PowerPoint',
  },
  {
    key: 'Process Development',
    value: 'Élaboration de processus',
  },
  {
    key: 'Process Improvement',
    value: 'Amélioration des processus',
  },
  {
    key: 'Procurement',
    value: 'Approvisionnement',
  },
  {
    key: 'Product Design',
    value: 'Conception de produits',
  },
  {
    key: 'Product Management',
    value: 'Gestion des produits',
  },
  {
    key: 'Production',
    value: 'Production',
  },
  {
    key: 'Program Development',
    value: 'Élaboration de programmes',
  },
  {
    key: 'Programing',
    value: 'Programmation',
  },
  {
    key: 'Project Life Cycle',
    value: 'Cycle de projet',
  },
  {
    key: 'Project Management',
    value: 'Gestion de projet',
  },
  {
    key: 'Project Management Software',
    value: 'Logiciel de gestion de projet',
  },
  {
    key: 'Proofreading',
    value: 'Relecture',
  },
  {
    key: 'Prospecting',
    value: 'Prospection',
  },
  {
    key: 'Python',
    value: 'Python',
  },
  {
    key: 'Quality Assurance',
    value: 'Assurance de la qualité',
  },
  {
    key: 'Quality Control',
    value: 'Contrôle de la qualité',
  },
  {
    key: 'Rails',
    value: 'Rails',
  },
  {
    key: 'React',
    value: 'React',
  },
  {
    key: 'Reading 3D',
    value: 'Lecture 3D',
  },
  {
    key: 'Receiving',
    value: 'Recevoir',
  },
  {
    key: 'Reconciliation',
    value: 'Rapprochement',
  },
  {
    key: 'Recruitment',
    value: 'Recrutement',
  },
  {
    key: 'Recycle Materials',
    value: 'Recyclage des matériaux',
  },
  {
    key: 'Redux',
    value: 'Redux',
  },
  {
    key: 'Relationship Management',
    value: 'Gestion des relations',
  },
  {
    key: 'Release Management',
    value: 'Gestion des versions',
  },
  {
    key: 'Report Generation',
    value: 'Génération de rapport',
  },

  {
    key: 'Research',
    value: 'Recherche',
  },
  {
    key: 'Resolutions',
    value: 'Résolutions',
  },
  {
    key: 'Resource Allocation',
    value: 'Allocation des ressources',
  },
  {
    key: 'Responsive Design',
    value: 'Conception adaptative',
  },
  {
    key: 'Revenue Forecasting',
    value: 'Prévision des recettes',
  },
  {
    key: 'Reviewing Contracts',
    value: 'Examen des contrats',
  },
  {
    key: 'Risk Management',
    value: 'Gestion des risques',
  },
  {
    key: 'Roadmapping',
    value: 'Feuille de route',
  },
  {
    key: 'Ruby',
    value: 'Ruby',
  },
  {
    key: 'Sales',
    value: 'Ventes',
  },
  {
    key: 'Salesforce',
    value: 'Force de vente',
  },
  {
    key: 'Sanitizing',
    value: 'Assainissement',
  },
  {
    key: 'SAS Financial Management',
    value: 'SAS Financial Management',
  },
  {
    key: 'SASS',
    value: 'Sass',
  },
  {
    key: 'Scan Documents',
    value: 'Numérisation de documents',
  },
  {
    key: 'Scheduling & Planning',
    value: 'Ordonnancement et planification',
  },
  {
    key: 'Scope Management',
    value: 'Gestion de la portée',
  },
  {
    key: 'Scrum Management',
    value: 'Gestion Scrum',
  },
  {
    key: 'Search Engine Marketing (SEM)',
    value: 'Marketing des moteurs de recherche',
  },
  {
    key: 'Search Engine Optimization (SEO)',
    value: 'Référencement naturel',
  },
  {
    key: 'Security Compliance',
    value: 'Conformité de sécurité',
  },
  {
    key: 'Security Management',
    value: 'Gestion de la sécurité',
  },
  {
    key: 'Senior Care',
    value: 'Soins aux personnes âgées',
  },
  {
    key: 'Server',
    value: 'Serveur',
  },
  {
    key: 'Server-Side Scripting',
    value: 'Programmation côté serveur',
  },
  {
    key: 'Shift Work',
    value: 'Travail posté',
  },
  {
    key: 'Shipping',
    value: 'Livraison',
  },
  {
    key: 'Social Media',
    value: 'Médias sociaux',
  },
  {
    key: 'Social Media Management',
    value: 'Gestion des médias sociaux',
  },
  {
    key: 'Social Work',
    value: 'Travail social',
  },
  {
    key: 'Social-Emotional Learning',
    value: 'Apprentissage socioémotionnel',
  },
  {
    key: 'Software Development',
    value: 'Développement de logiciels',
  },
  {
    key: 'Software Workflow',
    value: 'Flux de travail logiciel',
  },
  {
    key: 'SQL',
    value: 'SQL',
  },
  {
    key: 'Stakeholder Management',
    value: 'Gestion des parties prenantes',
  },
  {
    key: 'Standing',
    value: 'Debout',
  },
  {
    key: 'Statistical Analysis',
    value: 'Analyse statistique',
  },
  {
    key: 'Stocking',
    value: 'Stockage',
  },
  {
    key: 'Story Mapping',
    value: 'Cartographie des récits',
  },
  {
    key: 'Storytelling',
    value: 'Narration',
  },
  {
    key: 'Supervision',
    value: 'Supervision',
  },
  {
    key: 'Supply Chain',
    value: 'Chaîne d’approvisionnement',
  },
  {
    key: 'Sweeping',
    value: 'Balayage',
  },
  {
    key: 'Tableau',
    value: 'Tableau',
  },
  {
    key: 'Tape Management',
    value: 'Gestion des bandes',
  },
  {
    key: 'Retail (skill)',
    value: 'Commerce de détail (compétence)',
  },
  {
    key: 'Tax Preparation',
    value: 'Préparation de déclarations de revenus',
  },
  {
    key: 'Telecommunication',
    value: 'Télécommunication',
  },
  {
    key: 'Trades',
    value: 'Métiers',
  },
  {
    key: 'Training',
    value: 'Formation',
  },
  {
    key: 'Training Design /Facilitation',
    value: 'Conception/Animation de formations',
  },
  {
    key: 'Troubleshooting',
    value: 'Dépannage',
  },
  {
    key: 'Troubleshooting (interest)',
    value: 'Dépannage (intérêt)',
  },
  {
    key: 'Trucking',
    value: 'Camionnage',
  },
  {
    key: 'TypeScript',
    value: 'TypeScript',
  },
  {
    key: 'Typography',
    value: 'Typographie',
  },
  {
    key: 'User Testing',
    value: 'Tests d’utilisation',
  },
  {
    key: 'Unloading',
    value: 'Déchargement',
  },
  {
    key: 'User Research',
    value: 'Recherche sur les utilisateurs',
  },
  {
    key: 'UX/UI Design',
    value: 'Conception IU/EU',
  },
  {
    key: 'Vendor Management',
    value: 'Gestion des fournisseurs',
  },
  {
    key: 'Version Control',
    value: 'Contrôle des versions',
  },
  {
    key: 'Video Editing',
    value: 'Montage vidéo',
  },
  {
    key: 'Waterfall',
    value: 'Cascade',
  },
  {
    key: 'Wealth Management',
    value: 'Gestion de patrimoine',
  },
  {
    key: 'Wipe Tables',
    value: 'Nettoyage de tables',
  },
  {
    key: 'Wiping',
    value: 'Essuyage',
  },
  {
    key: 'Word',
    value: 'Mot',
  },
  {
    key: 'Animals',
    value: 'Animaux',
  },
  {
    key: 'Art',
    value: 'Art',
  },
  {
    key: 'Automotive',
    value: 'Automobile',
  },
  {
    key: 'Biking',
    value: 'Cyclisme',
  },
  {
    key: 'Camp',
    value: 'Camp',
  },
  {
    key: 'Clothing',
    value: 'Vêtements',
  },
  {
    key: 'Community Services',
    value: 'Services communautaires',
  },
  {
    key: 'Computers',
    value: 'Ordinateurs',
  },
  {
    key: 'Data Management',
    value: 'Gestion de données',
  },
  {
    key: 'Daycare',
    value: 'Garderie',
  },
  {
    key: 'Design',
    value: 'Conception',
  },
  {
    key: 'Electronics',
    value: 'Électronique',
  },
  {
    key: 'Event Services',
    value: 'Services événementiels',
  },
  {
    key: 'Food Retailer',
    value: 'Détaillant alimentaire',
  },
  {
    key: 'Food Services',
    value: 'Services alimentaires',
  },
  {
    key: 'Gardening',
    value: 'Jardinage',
  },
  {
    key: 'Grocery Store',
    value: 'Épicerie',
  },
  {
    key: 'Health Care',
    value: 'Soins de santé',
  },
  {
    key: 'Heavy Equipment',
    value: 'Matériel lourd',
  },
  {
    key: 'Hospitality Services',
    value: 'Services de l’accueil',
  },
  {
    key: 'Information Technology',
    value: 'Informatique',
  },
  {
    key: 'Janitorial',
    value: 'Conciergerie',
  },
  {
    key: 'Landscaping',
    value: 'Aménagement paysager',
  },
  {
    key: 'Legal Services',
    value: 'Services juridiques',
  },
  {
    key: 'Library',
    value: 'Bibliothèque',
  },
  {
    key: 'Manufacturer',
    value: 'Fabricant',
  },
  {
    key: 'Media',
    value: 'Médias',
  },
  {
    key: 'Movies',
    value: 'Films',
  },
  {
    key: 'Music',
    value: 'Musique',
  },
  {
    key: 'Outdoors',
    value: 'Plein air',
  },
  {
    key: 'Painting',
    value: 'Peinture',
  },
  {
    key: 'Park',
    value: 'Parc',
  },
  {
    key: 'Reading',
    value: 'Lecture',
  },
  {
    key: 'Recycling',
    value: 'Recyclage',
  },
  {
    key: 'Security',
    value: 'Sécurité',
  },
  {
    key: 'Senior Facility',
    value: 'Établissement pour personnes âgées',
  },
  {
    key: 'Theatre',
    value: 'Théâtre',
  },
  {
    key: 'Tobacconists',
    value: 'Marchand de bac',
  },
  {
    key: 'Warehouse',
    value: 'Entrepôt',
  },
  {
    key: 'Technology',
    value: 'Technologie',
  },
  {
    key: 'Library Assistance',
    value: 'Aide à la bibliothèque',
  },
  {
    key: 'Carting',
    value: 'Roulage',
  },
  {
    key: 'Membership Management',
    value: 'Gestion des adhésions',
  },
  {
    key: 'Line Cook',
    value: 'Cuisinier à la chaîne',
  },
  {
    key: 'Walking (skill)',
    value: 'Marche (compétence)',
  },
  {
    key: 'Cooking (interest)',
    value: 'Cuisine (intérêt)',
  },
  {
    key: 'Walking (interest)',
    value: 'Marche (intérêt)',
  },
  {
    key: 'Sports (skill)',
    value: 'Sport (compétence)',
  },
  {
    key: 'Sports (interest)',
    value: 'Sport (intérêt)',
  },
  {
    key: 'Standup Comedy',
    value: 'Monologue comique',
  },
  {
    key: 'Accounts Receivable',
    value: 'Comptes débiteurs',
  },
  {
    key: 'Child Care (interest)',
    value: 'Garde d’enfants (intérêt)',
  },
  {
    key: 'Education (skill)',
    value: 'Éducation (compétence)',
  },
  {
    key: 'Writing (skill)',
    value: 'Rédaction (compétence)',
  },
  {
    key: 'Driving (interest)',
    value: 'Conduite (intérêt)',
  },
  {
    key: 'Education (interest)',
    value: 'Éducation (intérêt)',
  },
  {
    key: 'Retail (interest)',
    value: 'Commerce de détail (intérêt)',
  },
  {
    key: 'Writing (interest)',
    value: 'Rédaction (intérêt)',
  },
  {
    key: 'Event Setup',
    value: 'Organisation d’événements',
  },
  {
    key: 'Telemarketing',
    value: 'Télémarketing',
  },
  {
    key: 'Sorting',
    value: 'Tri',
  },
  {
    key: 'Baking (interest)',
    value: 'Boulangerie (intérêt)',
  },
  {
    key: 'Baking (skill)',
    value: 'Boulangerie (compétence)',
  },
  {
    key: 'Transportation',
    value: 'Transport',
  },
  {
    key: 'Teamwork (skill)',
    value: 'Travail en équipe (compétence)',
  },
  {
    key: 'Teamwork (interest)',
    value: 'Travail en équipe (intérêt)',
  },
  {
    key: 'Professional Driving (G License or Equivalent)',
    value: 'Conduite professionnelle (permis G ou équivalent)',
  },
  {
    key: 'Commercial Driving',
    value: 'Conduite commerciale',
  },
  {
    key: 'Microsoft Access',
    value: 'Microsoft Access',
  },
  {
    key: 'Forklift Operation',
    value: 'Conduite de chariot élévateur',
  },
  {
    key: 'Logistics Management',
    value: 'Gestion logistique',
  },
  {
    key: 'Deliveries',
    value: 'Livraisons',
  },
  {
    key: 'Repetitive Movements',
    value: 'Mouvements répétitifs',
  },
  {
    key: 'Advertising',
    value: 'Publicité',
  },
  {
    key: 'Bowling',
    value: 'Jeu de quilles',
  },
  {
    key: 'Dining',
    value: 'Restauration',
  },
  {
    key: 'Taekwondo',
    value: 'Taekwondo',
  },
  {
    key: 'Gym',
    value: 'Sport',
  },
  {
    key: 'Dog Walking',
    value: 'Promenade de chien',
  },
  {
    key: 'Animal Care',
    value: 'Soins aux animaux',
  },
  {
    key: 'Mascot',
    value: 'Mascotte',
  },
  {
    key: 'Bike Repair',
    value: 'Réparation de vélo',
  },
  {
    key: 'Xylophonist',
    value: 'Xylophoniste',
  },
  {
    key: 'reportsTitle',
    value: 'Données',
  },
  {
    key: 'viewJobMatches',
    value: 'Afficher les postes pouvant correspondre',
  },
  {
    key: 'viewEmployerMatches',
    value: 'Afficher les employeurs pouvant correspondre',
  },
  {
    key: 'thatAre',
    value: ' ',
  },
  {
    key: 'by',
    value: 'par',
  },
  {
    key: 'global',
    value: 'globaux',
  },
  {
    key: 'myOrg',
    value: 'Mon Org',
  },
  {
    key: 'topRanked',
    value: 'Classement des compétences',
  },
  {
    key: 'topRankedSkillsAndInterests',
    value: 'Classement des compétences et des intérêts',
  },
  {
    key: 'rankedJobKeywords',
    value: 'Mots-clés associés aux postes les mieux classés',
  },
  {
    key: 'IndProfileTab',
    value: 'Profil de compétences et d’intérêts',
  },
  {
    key: 'JobProfileTab',
    value: 'Profil de mots-clés',
  },
  {
    key: 'IndPieTab',
    value: 'Rapport sur la personne',
  },
  {
    key: 'indStatus',
    value: 'Statut d’emploi',
  },
  {
    key: 'reportTitleI',
    value:
      'Consultez les 10 compétences ou intérêts les plus courants chez les personnes (relevant de votre organisation) pour déterminer les types de postes, d’entreprises et d’industries que votre organisation pourrait cibler. Basculez entre les personnes « en recherche d’emploi », les personnes qui ne sont « pas en recherche d’emploi » et « toutes les personnes ».',
  },
  {
    key: 'reportTitleII',
    value:
      'Consultez les 10 mots-clés les plus courants associés aux postes. Basculez entre les « postes ouverts », les « postes fermés » et « tous les postes ».',
  },
  {
    key: 'reportTitleIII',
    value:
      'Ce rapport dresse la liste des personnes (relevant de votre organisation) dont le profil pourrait inclure un plus grand nombre de compétences ou d’intérêts (afin d’améliorer les correspondances).',
  },
  {
    key: 'reportTitleIV',
    value:
      'Ce rapport dresse la liste des postes dont la description pourrait inclure un plus grand nombre de compétences ou d’intérêts (afin d’améliorer les correspondances).',
  },
  {
    key: 'reportTitleV',
    value:
      'Ce rapport dresse la liste des personnes (relevant de votre organisation) qui sont « en recherche d’emploi » et de celles qui ne sont « pas en recherche d’emploi » et indique le nombre d’heures qu’elles travaillent actuellement et qu’elles souhaitent travailler.',
  },
  {
    key: 'jobKeywords',
    value: 'Mots-clés associés aux postes',
  },
  {
    key: 'indDistributionTitle',
    value: 'Personnes regroupées en fonction de toutes les compétences',
  },
  {
    key: 'indDistributionTitleII',
    value: 'Personnes regroupées en fonction de toutes intérêts',
  },
  {
    key: 'jobDistributionTitle',
    value: 'Postes regroupés en fonction de tous les mots-clés',
  },
  {
    key: 'indDistributionSubtitle',
    value: 'Personnes en recherche d’emploi et personnes qui ne recherchent pas d’emploi',
  },
  {
    key: 'noGroupingsMessage',
    value: 'Aucun regroupement trouvé pour cette étiquette',
  },
  {
    key: 'noDataMessage',
    value: 'Aucune donnée',
  },
  {
    key: 'submitRequest',
    value: 'Envoyer la demande',
  },
  {
    key: 'submitKeywordMsg',
    value: 'N’oubliez pas d’appuyer sur le bouton « Envoyer la demande » ci-dessous!',
  },
  {
    key: 'submitPromptI',
    value:
      'Vous ne trouvez pas les compétences et les intérêts que vous recherchez? Envoyez-nous une demande ici.',
  },
  {
    key: 'submitPrompt-placeholder',
    value: 'Demandez l’ajout d’autres compétences et intérêts ici.',
  },
  {
    key: 'submitPromptII',
    value: 'que vous cherchez? Envoyez une demande en cliquant ici.',
  },
  {
    key: 'overview',
    value: 'Overview & Description',
  },
  // THIS IS WHERE THE NEW KEYS THAT NEED TO BE TRANSLATED START ----------------------------------------------------------------------------------------------------------
  {
    key: 'lp-welcome',
    value: 'Bienvenue sur MyJobMatch!',
  },
  {
    key: 'lp-empJourney',
    value: 'Il est temps de commencer votre parcours vers l’emploi',
  },
  {
    key: 'welcome',
    value: 'Bienvenue',
  },
  {
    key: 'lp-returningUser',
    value: 'Utilisateur déjà inscrit? Connectez-vous pour continuer.',
  },
  {
    key: 'lp-newUser',
    value: 'Nouvel utilisateur? Créez un compte.',
  },
  {
    key: 'lp-login',
    value: 'Connexion',
  },
  {
    key: 'lp-createAccount',
    value: 'Créer un compte',
  },
  {
    key: 'db-subtitle',
    value: "Opportunities await, let's unleash your greatness",
  },
  {
    key: 'db-jobMatchesTitle',
    value: 'Suggestions d’emploi',
  },
  {
    key: 'db-jobMatchesInactive',
    value:
      'Votre profil n’est pas encore actif, car il ne contient pas vos compétences et vos intérêts. Sans ces mots-clés, MyJobMatch ne pourra pas trouver des offres d’emploi susceptibles de vous convenir.',
  },
  {
    key: 'db-jobMatchesInterestText',
    value:
      'Vous n’avez aucune candidature en cours. Parcourez la liste des postes pour voir si l’un d’eux vous intéresse.',
  },
  {
    key: 'db-jobMatchesAddSkills',
    value: 'Ajouter des compétences et des intérêts',
  },
  {
    key: 'db-jobMatchesBrowseJobs',
    value: 'Parcourir les postes',
  },
  {
    key: 'db-viewAll',
    value: 'Tout afficher',
  },
  {
    key: 'db-jobInterestTitle',
    value: 'Job Interest Status',
  },
  {
    key: 'db-jobInterestHours',
    value: 'Heures disponibles : ',
  },
  {
    key: 'db-jobKM',
    value: ' km de votre domicile',
  },
  {
    key: 'db-jobInterestStatus',
    value: 'Statut: ',
  },
  // There is an error with this key:
  {
    key: 'db-jobInterestStatusInProgress',
    value: 'En cours',
  },
  {
    key: 'db-jobInterestStatusOffer',
    value: 'Offre d’emploi',
  },
  {
    key: 'db-jobInterestStatusInterview',
    value: 'Entrevue planifiée',
  },
  {
    key: 'db-jobInterestStatusNope',
    value: 'Pas un match',
  },
  {
    key: 'db-profileCompletionTitle',
    value: 'Renseignement du profil',
  },
  {
    key: 'db-profileEditButton',
    value: 'Modifier le profil',
  },
  {
    key: 'db-profileUpdateJobPref',
    value: 'Mettre à jour les préférences professionnelles',
  },
  {
    key: 'prof-Title',
    value: 'Mon profil',
  },
  {
    key: 'prof-subTitle',
    value: 'Mettez en avant vos renseignements personnels et professionnels',
  },
  {
    key: 'prof-editProfile',
    value: 'Modifier le profil',
  },
  {
    key: 'prof-skillsAccordian',
    value: 'SKILLS, INTERESTS & RESTRICTIONS',
  },
  {
    key: 'prof-overviewAccordian',
    value: 'Aperçu',
  },
  {
    key: 'prof-employmentAccordian',
    value: 'Horaire d’emploi et historique',
  },
  {
    key: 'prof-employmentAccordianDays',
    value: 'Days',
  },
  {
    key: 'prof-employmentAccordianStarted',
    value: 'Commencé',
  },
  {
    key: 'prof-employmentAccordianEnded',
    value: 'Complété',
  },
  {
    key: 'prof-employmentAccordianDuration',
    value: 'Duration',
  },
  {
    key: 'prof-employmentAccordianSource',
    value: 'Source',
  },
  {
    key: 'prof-employmentAccordianYears',
    value: ' years.',
  },
  {
    key: 'prof-employmentAccordianMonths',
    value: ' months.',
  },
  {
    key: 'prof-employmentAccordianMonth',
    value: ' month.',
  },
  {
    key: 'prof-employmentAccordianLessThanMonth',
    value: 'less than a month',
  },
  {
    key: 'Other',
    value: 'Other',
  },
  {
    key: 'prof-attachmentsAccordianCertifications',
    value: 'Certifications',
  },
  {
    key: 'jobs-title',
    value: 'Postes',
  },
  {
    key: 'jobs-subtitle',
    value: 'Parcourez une variété d’offres d’emploi',
  },
  {
    key: 'jobs-closed',
    value: "N'accepte plus les candidatures",
  },
  {
    key: 'jobs-filters',
    value: 'Filtres',
  },
  {
    key: 'jobs-sortBy',
    value: 'Trier par',
  },
  {
    key: 'jobs-sortByRecent',
    value: 'Les plus récents',
  },
  {
    key: 'jobs-sortByDistance',
    value: 'Distance du domicile',
  },
  {
    key: 'jobs-sortByHourlyRate',
    value: 'Taux horaire minimal',
  },
  {
    key: 'jobs-myJobMatches',
    value: 'Mes postes suggérés',
  },
  {
    key: 'jobsSection',
    value: 'Postes',
  },
  {
    key: 'jobs-applicationsStarted',
    value: 'Applications Started',
  },
  {
    key: 'jobs-jobsILike',
    value: 'Postes aimés',
  },
  {
    key: 'jobs-searchBarPlaceHolder',
    value: 'Rechercher des postes',
  },
  {
    key: 'jobsView-backToJobs',
    value: 'Back to Jobs',
  },
  {
    key: 'jobsView-jobDescription',
    value: 'DESCRIPTION DU POSTE',
  },
  {
    key: 'jobsView-jobOverview',
    value: 'APERÇU DU POSTE',
  },
  {
    key: 'jobsView-startApplication',
    value: 'Démarrer la candidature',
  },
  {
    key: 'jobsView-disableApplication',
    value: 'Nombre maximum de candidatures atteint',
  },
  {
    key: 'jobsView-startedApplication',
    value: 'Canadidature démarrée',
  },
  {
    key: 'jobsView-removeApplication',
    value: 'Remove Application',
  },
  {
    key: 'jobsView-like',
    value: 'Éléments aimés',
  },
  {
    key: 'jobsView-liked',
    value: 'Éléments aimés',
  },
  {
    key: 'jobsView-help',
    value: 'Aide',
  },
  {
    key: 'jobsView-goodMatch?',
    value: 'Bravo d’avoir pris cette décision!',
  },
  {
    key: 'jobsView-encouragingPushPart',
    value:
      'En démarrant une candidature, vous faites un grand pas en avant pour atteindre vos objectifs professionnels. Cliquez sur « Continuer » et un fournisseur de soutien MyJobMatch vous contactera pour vous aider dans les prochaines étapes de votre candidature.',
  },
  {
    key: 'jobsView-encouragingPushPart1',
    value: "You're one step away from starting an application for the ",
  },
  {
    key: 'jobsView-encouragingPush2',
    value: ' position at ',
  },
  {
    key: 'jobsView-encouragingPush3',
    value: ' km away from you',
  },
  {
    key: 'jobsView-expressInterestCopy',
    value: 'Notez que vous pouvez postuler à un maximum de 5 emplois à la fois.',
  },
  {
    key: 'jobsView-expressInterestAccept',
    value: 'Continuer',
  },
  {
    key: 'jobsViewMobile-summaryAccordian',
    value: 'Summary & Overview',
  },
  {
    key: 'jobsViewMobile-jobSummary',
    value: 'JOB SUMMARY',
  },
  {
    key: 'empSupportLead-requestSupport',
    value: 'Demander de l’aide',
  },
  {
    key: 'overviewWidget-noDetailsAvalible',
    value: 'No details available for this employer...',
  },
  {
    key: 'overviewWidget-noJobsWithEmployer',
    value: 'Currently no jobs listed with this employer.',
  },
  {
    key: 'myjobmatches-title',
    value: 'Mes postes suggérés',
  },
  {
    key: 'chatfeed-title',
    value: 'Fil de discussion',
  },
  {
    key: 'myjobmatches-subtitle',
    value:
      'Parcourez les postes qui vous ont été suggérés et que vous aimez et suivez vos candidatures ',
  },
  {
    key: 'chatfeed-subtitle',
    value: "Discutez avec votre organisation si vous êtes connecté et avez l'autorisation.",
  },
  {
    key: 'myactivity-title',
    value: 'Mon activité',
  },
  {
    key: 'myactivity-subtitle',
    value:
      'Suivez vos activités de recherche d’emploi pour mieux vous organiser et vérifier vos progrès.',
  },
  {
    key: 'myactivity-noActivityFound',
    value: 'No activity found within this time',
  },
  {
    key: 'myactivity-liked',
    value: 'aimé',
  },
  {
    key: 'myactivity-applicationUpdate1',
    value: 'Your application for ',
  },
  {
    key: 'myactivity-applicationUpdate2',
    value: ' has been updated to:',
  },
  {
    key: 'myactivity-unliked',
    value: 'unliked',
  },
  {
    key: 'myactivity-expressedInterestIn',
    value: 'started an application for',
  },
  {
    key: 'myactivity-removeApplied',
    value: 'removed your application for',
  },
  {
    key: 'myactivity-archive',
    value: 'archived your successful application for',
  },
  {
    key: 'myactivity-loggedIn',
    value: 'ouvert une session dans MyJobMatch le',
  },
  {
    key: 'myactivity-unhandledCase',
    value: 'Unhandled case',
  },
  {
    key: 'myactivity-edited',
    value: 'Vous avez modifié vos',
  },
  {
    key: 'myactivity-onYourProfile',
    value: 'dans votre profil.',
  },
  {
    key: 'myactivity-yourProfile',
    value: 'votre profil.',
  },
  {
    key: 'myactivity-earlier',
    value: 'EARLIER',
  },
  {
    key: 'myactivity-startDate',
    value: 'Date de début',
  },
  {
    key: 'myactivity-endDate',
    value: 'Date de fin',
  },
  {
    key: 'myactivity-errorMessage',
    value: 'Please select a valid date range to continue',
  },
  {
    key: 'myactivity-resetButton',
    value: 'Rafraîchir',
  },
  {
    key: 'jobs-resetButton',
    value: 'Effacer',
  },
  {
    key: 'jobs-applyButton',
    value: 'Appliquer',
  },
  {
    key: 'myactivity-searchButton',
    value: 'Rechercher',
  },
  {
    key: 'profile-overview',
    value: 'Aperçu',
  },
  {
    key: 'profile-overviewSubHeading',
    value: 'Cliquez sur « Modifier le profil » pour modifier les renseignements ci-dessous.',
  },
  {
    key: 'onboardingQuiz-quizComplete',
    value: 'Questionnaire terminé!',
  },
  {
    key: 'onboardingQuiz-noteToEdit1',
    value: 'Note that the answers you provide are not permanent! You can edit your profile if your',
  },
  {
    key: 'onboardingQuiz-noteToEdit2',
    value: 'change.',
  },
  {
    key: 'onboardingQuiz-currentSkills',
    value: 'Compétences actuelles :',
  },
  {
    key: 'onboardingQuiz-currentInterests',
    value: 'L’intérêt actuelles :',
  },
  {
    key: 'onboardingQuiz-newTypeSkills',
    value: 'Nouvelles compétences d’après les résultats du questionnaire :',
  },
  {
    key: 'onboardingQuiz-newTypeInterests',
    value: 'Nouvelles l’intérêt d’après les résultats du questionnaire :',
  },
  {
    key: 'onboardingQuiz-addNewS',
    value: 'Ajouter de nouvelles compétences',
  },
  {
    key: 'onboardingQuiz-addNewI',
    value: 'Ajouter de nouvelles l’intérêt',
  },
  {
    key: 'onboardingQuiz-goBack',
    value: 'Revenir',
  },
  {
    key: 'individualCreate-quizCompletedPopup',
    value: 'Mettez à jour votre profil pour enregistrer ces nouveaux mots-clés.',
  },
  {
    key: 'individualCreate-keywordSubmitPopup',
    value: 'Votre demande a été reçue.',
  },
  {
    key: 'individualCreate-confirmChoice',
    value: 'Are you sure you want to delete this job record?',
  },
  {
    key: 'stepper-next',
    value: 'Suivant',
  },
  {
    key: 'stepper-back',
    value: 'Précédent',
  },
  {
    key: 'jobQuizCarousel-no',
    value: 'Non',
  },
  {
    key: 'jobQuizCarousel-yes',
    value: 'Oui!',
  },
  {
    key: 'jobQuizCarousel-added',
    value: 'Added!',
  },
  {
    key: 'jobQuizCarousel-remove',
    value: 'Remove',
  },
  {
    key: 'jobQuizCarousel-previous',
    value: 'Précédent',
  },
  {
    key: 'jobQuizCarousel-next',
    value: 'Suivant',
  },
  {
    key: 'selectRegisterOption-referenceCode?',
    value: 'Avez-vous un code de référence?',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode0',
    value:
      'Avez-vous un fournisseur de soutien à l’emploi? Cette personne a-t-elle créé un compte MyJobMatch pour vous?',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode0_1',
    value: 'Have they created a MyJobMatch account for you?',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode1',
    value: 'Si votre fournisseur de soutien à l’emploi',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode2',
    value:
      ' a créé un profil MyJobMatch pour vous, demandez-lui un code de référence pour accéder au service.',
  },
  {
    key: 'selectRegisterOption-espRequestReferenceCode3',
    value:
      'Si vous utilisez le service pour la première fois, cliquez sur « Nouvel utilisateur » pour créer un compte MyJobMatch.',
  },
  {
    key: 'selectRegisterOption-newUser',
    value: 'Nouvel utilisateur',
  },
  {
    key: 'selectRegisterOption-referenceCode',
    value: 'Code de référence',
  },
  {
    key: 'referenceCodePanel-inputPersonalCode',
    value: 'Saisissez votre code de référence',
  },
  {
    key: 'referenceCodePanel-pleaseNumOrLet',
    value: 'please enter a number or letter',
  },
  {
    key: 'referenceCodePanel-enterRefCode',
    value:
      'Vous devez demander un code de référence à votre fournisseur de soutien à l’emploi. Si vous n’avez pas de code de référence, vous êtes un nouvel utilisateur.',
  },
  {
    key: 'referenceCodePanel-continue',
    value: 'Continuer',
  },
  {
    key: 'panelForms-continue',
    value: 'Continuer',
  },
  {
    key: 'panelForms-previous',
    value: 'Précédent',
  },
  {
    key: 'panelForms-termsAndConditions1',
    value: 'J’accepte les',
  },
  {
    key: 'panelForms-termsAndConditions2',
    value: 'conditions générales',
  },
  {
    key: 'panelForms-termsAndConditions3',
    value: 'et la',
  },
  {
    key: 'panelForms-termsAndConditions4',
    value: 'politique de confidentialité',
  },
  {
    key: 'panelForms-marketingPromotionalMaterials',
    value: 'J’accepte de recevoir des ressources marketing ou promotionnelles',
  },
  {
    key: 'panelForms-letUsKnowPreferences',
    value: 'Indiquez vos préférences d’emploi:',
  },
  {
    key: 'panelForms-orgFullError1',
    value: 'Sorry!',
  },
  {
    key: 'panelForms-orgFullError2',
    value:
      'is currently not onboarding new individuals, choose another organization or let us pick for you!',
  },
  {
    key: 'panelForms-fullCapacity',
    value: 'Full Capacity',
  },
  {
    key: 'panelForms-avalible',
    value: 'Available',
  },
  {
    key: 'panelForms-descriptionAndFocus',
    value: 'Description and Focus',
  },
  {
    key: 'panelForms-chooseOrg',
    value:
      'Préférez-vous bénéficier de l’aide d’un professionnel du soutien à l’emploi ou poursuivre vos objectifs de manière plus autonome? Veuillez choisir l’option qui correspond le mieux à vos besoins.',
  },
  {
    key: 'panelForms-fillMinRate',
    value: 'Veuillez indiquer le salaire horaire minimum que vous souhaitez gagner.',
  },
  {
    key: 'panelForms-addNonZero',
    value: 'Veuillez indiquer un nombre non nul',
  },
  {
    key: 'panelForms-pleaseTellUsMinimumHourlyWage',
    value: 'Veuillez indiquer le salaire horaire minimum que vous souhaitez gagner.',
  },
  {
    key: 'panelForms-inputHours',
    value: 'Combien d’heures souhaitez-vous travailler par semaine?',
  },
  {
    key: 'panelForms-inputHoursError',
    value: 'Veuillez indiquer le nombre d’heures que vous souhaitez travailler chaque semaine.',
  },
  {
    key: 'hourlyRate-errorNonZero',
    value: 'Veuillez indiquer le salaire horaire minimum que vous souhaitez gagner.',
  },
  {
    key: 'panelForm-minRateHelp',
    value: 'Quel est le salaire horaire minimum que vous souhaitez gagner?',
  },
  {
    key: 'panelForms-quizAlmostDone',
    value: 'Vous y êtes presque.',
  },
  {
    key: 'panelForms-quizAlmostDoneSubHeader',
    value:
      'Des compétences ont été ajoutées à votre profil en fonction de vos résultats au questionnaire. Ajoutons maintenant vos intérêts.',
  },
  {
    key: 'panelForms-suggestedRole',
    value: 'Le poste suivant vous convient-il? Sélectionnez « Oui » pour 3 options.',
  },
  {
    key: 'panelForms-exciteYou?',
    value: 'L’élément suivant vous intéresse-t-il? Sélectionnez « Oui » pour 3 options.',
  },
  {
    key: 'panelForms-completeQuizText1',
    value: 'Take this quiz to help',
  },
  {
    key: 'panelForms-completeQuizText2',
    value: 'us add new',
  },
  {
    key: 'panelForms-completeQuizText3',
    value: 'to your profile!',
  },
  { key: 'panelForms-completeQuizText4', value: 'You can always add more' },
  { key: 'panelForms-completeQuizText5', value: 'later on.' },
  {
    key: 'panelForms-quizIncomplete',
    value: 'Questionnaire incomplet!',
  },
  {
    key: 'panelForms-pleaseCompleteQuiz',
    value:
      'Terminez le questionnaire en choisissant « Oui » pour 3 éléments. Nous ajouterons ensuite des compétences et des intérêts à votre profil en fonction de vos réponses.',
  },
  {
    key: 'panelForms-completeQuizButton',
    value: 'Terminer le questionnaire',
  },
  {
    key: 'panelForms-completeQuizNoButton',
    value: 'Non, merci',
  },
  {
    key: 'panelForms-areYouSureCont?',
    value: 'Are you sure you want to continue?',
  },
  {
    key: 'panelForms-quizUnsavedProgWillBeLost',
    value:
      'You have not completed the quiz. Any skills and interests gathered up to this point will will be lost.',
  },
  {
    key: 'panelForms-accAlreadyExists1',
    value: 'MyJobMatch Account',
  },
  {
    key: 'panelForms-accAlreadyExists2',
    value: 'Already Exists',
  },
  {
    key: 'panelForms-alreadyHaveAcc1',
    value: 'Have you created a MyJobMatch account already?',
  },
  {
    key: 'panelForms-alreadyHaveAcc2',
    value: 'If so, try logging in with you email instead of creating a new account.',
  },
  {
    key: 'panelForms-hasEspGivenRC?1',
    value: 'Has your Employment Support Provider created an account on your behalf?',
  },
  {
    key: 'panelForms-hasEspGivenRC?2',
    value: 'If so, please request a Reference Code from them to gain access to your account. ',
  },
  {
    key: 'panelForms-forgotPasswordSupport1',
    value:
      'If you have forgotten your password or require additional assistance, please reach out to',
  },
  {
    key: 'panelForms-forgotPasswordSupport2',
    value: 'MyJobMatch Support',
  },
  {
    key: 'pageNoteFound',
    value:
      "Ooops, this link doesn't work, you may have entered in the wrong link name. Head back to the dashboard, if the problem persists, please contact the admin",
  },
  {
    key: 'logOutButton',
    value: 'Déconnexion',
  },
  {
    key: 'signUp-liveInOntario?',
    value: 'Do you live in Ontario?',
  },
  {
    key: 'signUp-mjmOnlyInToronto1',
    value:
      'MyJobMatch presently services the Greater Toronto Area (GTA), with future plans to expand elsewhere in Ontario. While you are welcome to create an account if you are an Ontario resident, please know that most employers and job opportunities are currently in the GTA.',
  },
  {
    key: 'signUp-mjmOnlyInToronto2',
    value:
      'If you do not live in Ontario, please join our waitlist to receive a notification if MyJobMatch comes your way.',
  },
  {
    key: 'signUp-iLiveInOntario',
    value: 'I live in Ontario',
  },
  {
    key: 'signUp-notifyMe',
    value: 'Notify Me',
  },
  {
    key: 'mobileNav-myProfile',
    value: 'Mon profil',
  },
  {
    key: 'mobileNav-myJobMatches',
    value: 'Mes postes suggérés',
  },
  {
    key: 'mobileNav-myActivity',
    value: 'Mon activité',
  },
  {
    key: 'mobileNav-help',
    value: 'Aide',
  },
  {
    key: 'notifcation-view',
    value: 'View',
  },
  {
    key: 'notifcation-jobPosting',
    value: 'l’offre d’emploi',
  },
  {
    key: 'notification-jobMatch1',
    value: 'Un poste susceptible de vous correspondre a été trouvé chez',
  },
  {
    key: 'notifcation-view',
    value: 'View',
  },
  {
    key: 'notification-jobPosting',
    value: 'l’offre d’emploi',
  },
  {
    key: 'notification-jobMatch2',
    value: 'pour en savoir plus.',
  },
  {
    key: 'notification-tryAgainError',
    value: 'Sorry, something went wrong, please try again',
  },
  {
    key: 'notification-activeApplications1',
    value: 'Candidatures en cours',
  },
  {
    key: 'notification-activeApplications2',
    value: 'pour suivre les modifications.',
  },
  {
    key: 'notification-indivUpdated1',
    value: 'Visit your',
  },
  {
    key: 'notification-indivUpdated2',
    value: 'Activity Log',
  },
  {
    key: 'notification-indivUpdated3',
    value: 'to view changes.',
  },
  {
    key: 'notification-ejiUpdated1',
    value: 'Le statut de votre candidature au poste de',
  },
  {
    key: 'notification-ejiUpdated2',
    value: ' a changé',
  },
  {
    key: 'notification-ejiUpdatedProfile',
    value: 'has updated your profile.',
  },
  {
    key: 'notification-errorCheckInternet',
    value: 'Sorry, something went wrong, check your internet connection and please try again.',
  },
  {
    key: 'formQuizComp-leave?',
    value: 'Vos résultats ne seront pas enregistrés si vous quittez le questionnaire.',
  },
  {
    key: 'formQuizComp-veiwResults',
    value: 'Afficher les résultats',
  },
  {
    key: 'formQuizComp-previous',
    value: 'Précédent',
  },
  {
    key: 'formQuizComp-notPermenantSkills',
    value:
      'Veuillez noter que les réponses que vous communiquez ne sont pas permanentes! Vous pouvez modifier votre profil si vos compétences changent.',
  },
  {
    key: 'formQuizComp-notPermenantInterests',
    value:
      'Veuillez noter que les réponses que vous communiquez ne sont pas permanentes! Vous pouvez modifier votre profil si vos compétences changent.',
  },
  {
    key: 'formQuizComp-skillHeader',
    value: 'Qu’êtes-vous capable de faire?',
  },
  {
    key: 'formQuizComp-interestHeader',
    value: 'Qu’est-ce que vous aimez?',
  },
  {
    key: 'formQuizComp-helpAddTypeToProfile1',
    value: 'Complete this quiz to help us add',
  },
  {
    key: 'formQuizComp-helpAddTypeToProfile2',
    value: 'to your profile!',
  },
  {
    key: 'formQuizComp-suitYou?',
    value:
      'Choisissez « Oui » ou « Non » selon que les compétences figurant sur cette liste correspondent ou non à vos capacités.',
  },
  {
    key: 'formQuizComp-exciteYou?',
    value: 'L’élément suivant vous intéresse-t-il? Sélectionnez « Oui » pour 3 options.',
  },
  {
    key: 'formQuizComp-skillsSubHeader',
    value:
      'Choisissez « Oui » ou « Non » selon que les compétences figurant sur cette liste correspondent ou non à vos capacités.',
  },
  {
    key: 'formQuizComp-interestsSubHeader',
    value: 'Choisissez « Oui » ou « Non » selon que vous aimez ou non l’intérêt proposé.',
  },
  {
    key: 'notification-reOpen1',
    value: 'The',
  },
  {
    key: 'notification-reOpen2',
    value: 'job you liked has re-opened. Submit your application now!',
  },
  {
    key: 'notification-notAMatch0',
    value: 'Le poste de',
  },
  {
    key: 'notification-notAMatch1',
    value: 'a été pourvu. Revenez à la',
  },
  {
    key: 'notification-notAMatch2',
    value: 'pour parcourir plus d’offres.',
  },
  {
    key: 'notification-offer',
    value:
      'Contactez votre fournisseur de soutien à l’emploi pour obtenir de plus amples renseignements.',
  },
  {
    key: 'notification-typeOffer1',
    value: 'Le poste de',
  },
  {
    key: 'notification-typeOffer2',
    value: 'vous a été proposé!',
  },
  {
    key: 'qt-admin-assistant',
    value: 'Adjoint administratif/Adjointe administrative',
  },
  {
    key: 'qt-barista',
    value: 'Barista',
  },
  {
    key: 'qt-bike-mechanic',
    value: 'Mécanicien/Mécanicienne de vélos',
  },
  {
    key: 'qt-childcare-provider',
    value: 'Prestataire de services de garde d’enfants',
  },
  {
    key: 'qt-cleaner',
    value: 'Nettoyeur/Nettoyeuse',
  },
  {
    key: 'qt-community-engagement-coordinator',
    value: 'Coordonnateur/Coordonnatrice de l’engagement communautaire',
  },
  {
    key: 'qt-computer-programmer',
    value: 'Programmeur/Programmeuse informatique',
  },
  {
    key: 'qt-construction-worker',
    value: 'Ouvrier/Ouvrière en bâtiment',
  },
  {
    key: 'qt-cook',
    value: 'Cuisinier/Cuisinière',
  },
  {
    key: 'qt-delivery-driver',
    value: 'Chauffeur-livreur/Chauffeuse-livreuse',
  },
  {
    key: 'qt-dog-walker',
    value: 'Promeneur/Promeneuse de chiens',
  },
  {
    key: 'qt-event-and-project-coordinator',
    value: 'Coordonnateur/Coordonnatrice d’événements et de projets',
  },
  {
    key: 'qt-grocery-clerk',
    value: 'Commis d’épicerie',
  },
  {
    key: 'qt-healthcare-worker',
    value: 'Travailleur/Travailleuse de la santé',
  },
  {
    key: 'qt-it-technician',
    value: 'Technicien/Technicienne informatique',
  },
  {
    key: 'qt-library-assistant',
    value: 'Assistant/Assistante de bibliothèque',
  },
  {
    key: 'qt-retail-sales-associate',
    value: 'Vendeur-associé/Vendeuse-associée dans le commerce de détail',
  },
  {
    key: 'qt-server',
    value: 'Serveur/Serveuse de restaurant',
  },
  {
    key: 'qt-social-media-manager',
    value: 'Responsable des réseaux sociaux',
  },
  {
    key: 'qt-utility-worker',
    value: 'Mécanicien/Mécanicienne – services publics',
  },
  {
    key: 'qt-note-that-the-answers-you-provide-are-not-permanent!-you-can-edit-your-profile-if-ever-your-skills-change.',
    value:
      'Les réponses que vous communiquez ne sont pas permanentes! Vous pouvez modifier votre profil si vos compétences changent.',
  },
  {
    key: 'qt-animals',
    value: 'Animaux',
  },
  {
    key: 'qt-creative-art',
    value: 'Arts créatifs',
  },
  {
    key: 'qt-children',
    value: 'Enfants',
  },
  {
    key: 'qt-computers',
    value: 'Informatique',
  },
  {
    key: 'qt-culinary-arts',
    value: 'Arts culinaires',
  },
  {
    key: 'qt-driving',
    value: 'Conduite',
  },
  {
    key: 'qt-entertaining-people',
    value: 'Divertir autrui',
  },
  {
    key: 'qt-fitness',
    value: 'Entraînement physique',
  },
  {
    key: 'qt-helping-people',
    value: 'Aider autrui',
  },
  {
    key: 'qt-learning-new-things',
    value: 'Apprendre de nouvelles choses',
  },
  {
    key: 'qt-organization',
    value: 'Organisation',
  },
  {
    key: 'qt-outdoors',
    value: 'Plein air',
  },
  {
    key: 'qt-solving-puzzles',
    value: 'Résoudre des casse-tête',
  },
  {
    key: 'qt-shopping',
    value: 'Magasinage',
  },
  {
    key: 'qt-playing-sports',
    value: 'Sport',
  },
  {
    key: 'qt-talking',
    value: 'Parler aux gens',
  },
  {
    key: 'qt-skills-and-interests-have-been-added-to-your-profile-based-on-your-quiz-results.',
    value: 'De nouvelles compétences et intérêts ont été ajoutés à votre profil.',
  },
  {
    key: 'help',
    value: 'Aide',
  },
  {
    key: 'panel1AHelp-welcome',
    value:
      'Bienvenue dans notre Centre d’aide et d’assistance. Nous vous accompagnons à chaque étape de votre parcours professionnel.',
  },
  {
    key: 'panel1AHelp-bubbleTitle',
    value: 'Vous avez du mal à remplir votre profil? Nous pouvons vous aider!',
  },
  {
    key: 'panel1AHelp-bubbleContent',
    value:
      'Indiquez-nous les renseignements importants dont nous avons besoin pour créer votre profil. Une fois le profil créé, vous pourrez parcourir les offres d’emploi sur MyJobMatch.',
  },
  {
    key: 'panel2AHelp-bubbleTitle',
    value: 'Vous avez du mal à remplir votre profil? Nous pouvons vous aider!',
  },
  {
    key: 'panel2AHelp-bubbleContent',
    value:
      'Suivez les instructions à l’écran et indiquez-nous les renseignements importants dont nous avons besoin pour créer votre profil. Une fois le profil créé, vous pourrez parcourir les offres d’emploi sur MyJobMatch.',
  },
  {
    key: 'panel3AHelp-relatedSkills',
    value:
      'Les questionnaires sur les compétences et les intérêts sont terminés lorsque 3 compétences et 3 intérêts ont été sélectionnés. Pour mettre à jour vos choix, cliquez sur « Modifier le profil » dans la section « Mon profil ».',
  },
  {
    key: 'panel3AHelp-relatedInterests',
    value:
      'Les questionnaires sur les compétences et les intérêts sont terminés lorsque 3 compétences et 3 intérêts ont été sélectionnés. Pour mettre à jour vos choix, cliquez sur « Modifier le profil » dans la section « Mon profil ».',
  },
  {
    key: 'panel3AHelp-bubbleTitle',
    value: 'Aidez-nous à créer votre profil en répondant à ce questionnaire',
  },
  {
    key: 'dashboardHelp-bubbleTitle',
    value: 'Tableau de bord',
  },
  {
    key: 'dashboardHelp-bubbleContent',
    value:
      'Le tableau de bord MyJobMatch récapitule les informations et activités les plus importantes en une seule vue. Vous pouvez parcourir les dernières offres d’emploi et consulter vos candidatures en cours en un coup d’œil.',
  },
  {
    key: 'dashboard-subtitle',
    value: 'Affichez et gérez toutes vos informations et tâches importantes',
  },
  {
    key: 'referenceCodeHelp-bubbleTitle',
    value: 'Qu’est-ce qu’un code de référence? On vous explique!',
  },
  {
    key: 'referenceCodeHelp-bubbleContent',
    value:
      'Si votre fournisseur de soutien à l’emploi (FSE) a déjà créé un profil MyJobMatch en votre nom, vous pouvez demander un code de référence qui vous permettra d’accéder à votre profil et de le gérer. Veuillez communiquer directement avec votre FSE pour lui demander votre code de référence MyJobMatch et mener à bien cette étape.',
  },
  {
    key: 'myProfileHelp-bubbleTitle',
    value: 'Mon profil',
  },
  {
    key: 'myProfileHelp-bubbleContent',
    value:
      'Votre profil contient des renseignements importants sur votre historique de travail, notamment sur votre statut d’emploi, vos heures de travail passées et actuelles, vos compétences et vos intérêts. Vous pouvez mettre à jour ces renseignements à tout moment en cliquant sur « Modifier le profil ».',
  },
  {
    key: 'editProfileHelp-bubbleTitle',
    value: 'Modifier le profil',
  },
  {
    key: 'editProfileHelp-bubbleContent',
    value:
      'Les renseignements que vous fournissez ne sont pas permanents! Vous pouvez modifier votre profil chaque fois que vos préférences changent. Suivez les invites pour mettre à jour ou ajouter des renseignements dans votre profil.',
  },
  {
    key: 'jobsHelp-bubbleTitle',
    value: 'Postes',
  },
  {
    key: 'jobsHelp-bubbleContent',
    value:
      'Parcourez les offres d’emploi sur MyJobMatch et indiquez-nous si l’une d’elles vous intéresse. Cliquez sur le bouton « J’aime » pour sauvegarder un poste ou sur le bouton « Démarrer la candidature » pour informer MyJobMatch que vous souhaitez commencer le processus de candidature.',
  },
  {
    key: 'jobsHelp-bubbleContent-list-title',
    value: 'Pour affiner votre recherche, vous pouvez utiliser les fonctions de filtre et de tri.',
  },
  {
    key: 'jobsHelp-bubbleContent-list-item1',
    value:
      'Filtre : filtrez la liste par taux horaire minimal, par jour de disponibilité ou par nombre d’heures par semaine. Chaque filtre est renseigné en fonction de votre profil, mais vous pouvez également modifier les champs à votre convenance.',
  },
  {
    key: 'jobsHelp-bubbleContent-list-item2',
    value:
      'Tri : cochez les cases souhaitées pour trier les postes du plus récent au moins récent, du plus proche de votre domicile au plus éloigné, du taux horaire minimum le plus bas au plus élevé et de la date de clôture la plus proche à la plus éloignée.',
  },
  {
    key: 'jobMatchesHelp-bubbleTitle',
    value: 'Mes postes suggérés',
  },
  {
    key: 'jobMatchesHelp-bubbleContent',
    value:
      'Cette vue contient les postes qui correspondent le mieux à votre profil, en fonction de vos compétences, de vos intérêts et de votre localisation. Le volet « Candidatures en cours » présente les postes pour lesquels vous avez manifesté votre intérêt, tandis que le volet « Postes aimés » affiche les postes que vous avez aimés en parcourant la page Postes.',
  },
  {
    key: 'myActivityHelp-bubbleTitle',
    value: 'Mon activité',
  },
  {
    key: 'chatHelp-bubbleTitle',
    value: 'Flux de Chat',
  },
  {
    key: 'myActivityHelp-bubbleContent',
    value:
      'Ce registre numérique dresse la liste de toutes les activités effectuées dans votre profil. Vous pouvez parcourir cette liste pour consulter toutes vos activités ou filtrer les activités par date.',
  },
  {
    key: 'chatHelp-bubbleContent',
    value:
      "La section Chat est l'endroit où vous pouvez communiquer avec votre conseiller en soutien à l'emploi par le biais de messages. Une fois que votre conseiller vous accorde l'accès, vous pourrez répondre et participer à des conversations pour recevoir du soutien et des conseils. Si vous attendez un nouveau message, essayez de rafraîchir l'application pour vous assurer de voir les dernières mises à jour. C'est un espace conçu pour rendre la communication facile et utile pour votre parcours.",
  },
  {
    key: 'needSupport?',
    value: 'Avez-vous besoin de plus d’aide?',
  },
  {
    key: 'contactCustomerSupport',
    value: 'Contactez le service à la clientèle',
  },
  {
    key: 'FAQs',
    value: 'Foire aux questions',
  },
  {
    key: 'mjm-userGuide',
    value: 'Guide d’utilisation de MyJobMatch',
  },
  {
    key: 'filterKeyEventsBtn',
    value: 'Delete All',
  },
  {
    key: 'skillsAndInterests-noRestrictions',
    value: 'No Restrictions',
  },
  {
    key: 'panelForms-alreadyUsingEmail',
    value: 'We found an account that already uses this email address.',
  },
  {
    key: 'qt-congratulations-your-profile-is-complete!',
    value: 'Congatulations your profile is complete!',
  },
  {
    key: 'dashboard-popupMessage1',
    value: 'Votre profil est maintenant actif. Il est temps d’explorer MyJobMatch!',
  },
  {
    key: 'dashboard-popupMessage2',
    value:
      'Votre profil n’est pas encore actif, car il ne contient pas vos compétences et intérêts. Sans ces informations, MyJobMatch ne peut pas trouver les offres d’emploi qui vous conviennent.',
  },
  {
    key: 'mustBe14YearsOrOlder',
    value: 'Vous devez avoir au moins 14 ans pour travailler en Ontario.',
  },
  {
    key: 'isValidDate-invalidDateMessage',
    value: 'La date que vous avez saisie n’est pas valide, veuillez réessayer (MM/JJ/AAAA).',
  },
  {
    key: 'jobs-errorMessage1',
    value:
      'Il n’y a actuellement aucune information à consulter. Parcourez la liste des postes pour voir si l’un d’eux vous intéresse ou envoyez un message dans la fenêtre de clavardage pour formuler une demande.',
  },
  {
    key: 'jobs-errorMessage2',
    value:
      'Il n’y a actuellement aucune information à consulter. Parcourez la liste des postes pour voir si l’un d’eux vous intéresse ou envoyez un message dans la fenêtre de clavardage pour formuler une demande.',
  },
  {
    key: 'maximumApplication',
    value: 'Vous avez atteint le nombre maximum de candidatures en cours (5). ',
  },
  {
    key: 'myjobmatches-buttonSubtitleMatches',
    value:
      'Des postes qui correspondent à vos compétences et à vos intérêts et qui sont situés près de chez vous.',
  },
  {
    key: 'myjobmatches-buttonSubtitleApplications',
    value:
      'Suivez les candidatures que vous avez présentées, avec une limite de trois candidatures en cours à la fois.',
  },
  {
    key: 'myjobmatches-buttonSubtitleLikes',
    value:
      'Le nombre de postes que vous pouvez aimer n’est pas limité : vous pouvez ainsi suivre les nombreuses offres qui retiennent votre attention.',
  },
  {
    key: 'exitQuizButton',
    value: 'Quitter le questionnaire',
  },
  {
    key: 'completeQuizButton',
    value: 'Terminer le questionnaire',
  },
  {
    key: 'formQuizComp-quizHeaderSkills1',
    value:
      'Répondez à ce bref questionnaire pour nous aider à ajouter des compétences à votre profil. Vous pourrez toujours ajouter d’autres compétences ultérieurement.',
  },
  {
    key: 'formQuizComp-quizHeaderInterests1',
    value:
      'Voici un autre bref questionnaire qui nous aidera à ajouter des intérêts à votre profil. Vous pourrez toujours ajouter d’autres intérêts ultérieurement.',
  },
  {
    key: 'pleaseSD',
    value: 'Veuillez sélectionner une date de début.',
  },
  {
    key: 'qt-note-that-the-answers-you-provide-are-not-permanent!-you-can-edit-your-profile-if-your-skills-change.',
    value:
      'Veuillez noter que les réponses que vous communiquez ne sont pas permanentes! Vous pouvez modifier votre profil si vos compétences changent.',
  },
  {
    key: 'weeklySchedule',
    value: 'Please let us know your work schedule.',
  },
  {
    key: 'skillsTitlePh',
    value: 'Sélectionnez toutes les options pertinentes',
  },
  {
    key: 'interestsTitlePh',
    value: 'Sélectionnez toutes les options pertinentes',
  },
  {
    key: 'daysAvailPh',
    value: 'Sélectionnez toutes les options pertinentes',
  },
  {
    key: 'independent',
    value: 'Autonome',
  },
  {
    key: 'independentSubtitle',
    value:
      'Pour les demandeurs d’emploi qui préfèrent rechercher un emploi sans l’aide d’un organisme d’aide à l’emploi. ',
  },
  {
    key: 'clto',
    value: 'Intégration communautaire Toronto',
  },
  {
    key: 'caa',
    value: 'Corbrook Awakening Abilities',
  },
  {
    key: 'letsExplore',
    value: 'C’est parti',
  },
  {
    key: 'completeMyProfile',
    value: 'Compléter mon profil',
  },
  {
    key: 'editProfile-stepPersonalDetails',
    value: 'Détails personnels',
  },
  {
    key: 'editProfile-stepKeywords',
    value: 'Mots-clés',
  },
  {
    key: 'editProfile-stepPreferences',
    value: 'Préférences',
  },
  {
    key: 'editProfile-stepEmploymentDetails',
    value: 'Détails relatifs à l’emploi',
  },
  {
    key: 'editProfile-stepAdditional',
    value: 'Autres renseignements',
  },
  {
    key: 'editProfile-skillsSubtitle',
    value: 'Une compétence est la capacité de bien faire une tâche.',
  },
  {
    key: 'editProfile-interestsSubtitle',
    value: 'Un intérêt est une chose que l’on aime bien et pour laquelle on a de la curiosité.',
  },
  {
    key: 'editProfile-skillssButton',
    value: 'Questionnaire sur les compétences',
  },
  {
    key: 'editProfile-interestsButton',
    value: 'Questionnaire sur les intérêts',
  },
  {
    key: 'stepper-step',
    value: 'Étape',
  },
  {
    key: 'stepper-of',
    value: 'sur',
  },
  {
    key: 'hrs',
    value: 'heures',
  },
  {
    key: 'step2-org',
    value: 'Organisme',
  },
  {
    key: 'notification-view',
    value: 'Consultez',
  },
  {
    key: 'yourESP',
    value: 'Votre fournisseur de soutien à l’emploi a',
  },
  {
    key: 'activity-you',
    value: 'Vous avez',
  },
  {
    key: 'remove-app-header',
    value: "Are you sure you want to take back this application you've started?",
  },
  {
    key: 'remove-app-bold',
    value: 'Removing your application will alert your Support Provider.',
  },
  {
    key: 'remove-app-content',
    value: 'If you still want to proceed click Continue',
  },
];
